/* google places api autocomplete */
function autocomplete(countries = ['us']) {
  var inputs = $('input[type="search"][name="address"]');
  $(inputs).each(function(index, input) {
    var options = {
      componentRestrictions: {
        country: countries
      }
    };
    
    var autocomplete = new google.maps.places.Autocomplete(input, options);
    
    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (place && place.place_id) {
        place_selected = true;
      } else {
        place_selected = false;
      }
      var lat = place.geometry.location.lat();
      var lng = place.geometry.location.lng();
      var offset = place.utc_offset_minutes * 60;
      $(input).attr('data-latitude', lat).attr('data-longitude', lng).attr('data-offset', offset);
    });
    
    $(input).on('input', function() {
      place_selected = false;
      // console.log('input:', place_selected);
    });
    
    /*
     * Removed 'Your Location' from input field if user focuses on it to search for an actual address.
     * This prevents Google autocomplete from searching 'Your Location'.
     */
    $(input).focus(function (e) {
      if (e.target.value === 'Your Location') {
        $(this).val('');
      }
    });
  });
}

function GetDateStr(date) {
  return moment(date).format("YYYY-MM-DD");
}

function GetMobileMonthFormat(month) {
  //Momentjs use 0 based indexing for month
  if (month == 0) {
    return 'Jan';
  } else if (month == 1) {
    return 'Feb';
  } else if (month == 2) {
    return 'Mar';
  } else if (month == 3) {
    return 'Apr';
  } else if (month == 4) {
    return 'May';
  } else if (month == 5) {
    return 'Jun';
  } else if (month == 6) {
    return 'Jul';
  } else if (month == 7) {
    return 'Aug';
  } else if (month == 8) {
    return 'Sep';
  } else if (month == 9) {
    return 'Oct';
  } else if (month == 10) {
    return 'Nov';
  } else if (month == 11) {
    return 'Dec';
  }
}

const getV2GraphQLApiUrl = () => {
  const hostName = window.location.hostname;

  if (hostName === 'parkchirp.localhost') {
    return 'http://127.0.0.1:4004';
  }

  if (hostName === 'chirpqa.com' || hostName.endsWith('.chirpqa.com')) {
    return 'https://api.chirpqa.com/v2';
  }

  if (hostName === 'parkcheep.com' || hostName.endsWith('.parkcheep.com')) {
    return 'https://api.parkcheep.com/v2';
  }

  return 'https://api.parkchirp.com/v2';
}

const getVehicleMakes = async () => {
  try {
    const response = await fetch(`${getV2GraphQLApiUrl()}/graphqlPublic`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: `
          query listVehicleMakes {
            listVehicleMakes {
              data {
                id
                name
              }
            }
          }`,
        context: {
          apiVersion: 'v2',
          public: true,
        }
      })
    });
    const result = await response.json();
    if (result.errors) {
      console.error('GraphQL errors:', result.errors);
      return [];
    }
    return result.data.listVehicleMakes.data || [];
  } catch (error) {
    console.error('Error fetching vehicle makes:', error);
    return [];
  }
}

const getVehicleModels = async (vehicleMakeId) => {
  try {
    const response = await fetch(`${getV2GraphQLApiUrl()}/graphqlPublic`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: `
          query listVehicleModels($vehicleMakeId: Int!) {
            listVehicleModels(vehicleMakeId: $vehicleMakeId) {
              data {
                id
                name
              }
            }
          }`,
        variables: { vehicleMakeId: parseInt(vehicleMakeId) },
        context: {
          apiVersion: 'v2',
          public: true,
        }
      })
    });
    const result = await response.json();
    if (result.errors) {
      console.error('GraphQL errors:', result.errors);
      return [];
    }
    return result.data.listVehicleModels.data || [];
  } catch (error) {
    console.error('Error fetching vehicle models:', error);
    return [];
  }
}

const populateDropdown = (selectElement, items, selectedValue = '') => {
  selectElement.find('option:not(:first)').remove();
  for (const item of items) {
    $('<option>')
      .val(item.id)
      .text(item.name)
      .data('name', item.name)
      .data('id', item.id)
      .prop('selected', selectedValue && item.name === selectedValue)
      .appendTo(selectElement);
  }
};

const populateVehicleMakeDropdown = async (selectElement, selectedValue = '') => {
  const makes = await getVehicleMakes();
  populateDropdown(selectElement, makes, selectedValue);
  return makes;
};

const populateVehicleModelDropdown = async (selectElement, vehicleMakeId, selectedValue = '') => {
  selectElement.prop('disabled', true);
  selectElement.find('option:not(:first)').remove();
  selectElement.prop('selectedIndex', 0);

  if (!vehicleMakeId) {
    return [];
  }
  const models = await getVehicleModels(vehicleMakeId);
  populateDropdown(selectElement, models, selectedValue);
  selectElement.prop('disabled', false);
  return models;
};

const populateAndDisableVehicleDropdowns = (index, vehicle) => {
  const $makeSelect = $('#vehicle-make-' + index);
  const $modelSelect = $('#vehicle-model-' + index);
  $makeSelect.find('option:not(:first)').remove();
  $modelSelect.find('option:not(:first)').remove();
  $('<option>')
    .val(vehicle.make)
    .text(vehicle.make)
    .data('name', vehicle.make)
    .prop('selected', true)
    .appendTo($makeSelect);
  $('<option>')
    .val(vehicle.model)
    .text(vehicle.model)
    .data('name', vehicle.model)
    .data('id', vehicle.modelId)
    .prop('selected', true)
    .appendTo($modelSelect);
  $makeSelect.prop('disabled', true).data('make-name', vehicle.make);
  $modelSelect.prop('disabled', true).data('model-name', vehicle.model);
};

const initializeVehicleDropdowns = () => {
  $('select[name="vehicle-make"]').each(function () {
    const $makeSelect = $(this);
    const $modelSelect = $makeSelect.closest('.form-field-group-vehicle')
      .find('select[name="vehicle-model"]');
    populateVehicleMakeDropdown($makeSelect);
    $makeSelect.on('change', function () {
      const $selected = $(this).find('option:selected');
      const selectedMakeId = $selected.val();
      const selectedMakeName = $selected.data('name');
      $(this).data('make-name', selectedMakeName);
      populateVehicleModelDropdown($modelSelect, selectedMakeId);
      updateVehicleSurchargeMessage();
    });
    $modelSelect.on('change', function () {
      const selectedModelName = $(this).find('option:selected').data('name');
      $(this).data('model-name', selectedModelName);
      updateVehicleSurchargeMessage();
    });
  });
};

let vehicleSurchargeRequestId = 0;

const getVehicleSurchargeConfig = () => {
  const $vehicles = $('#vehicles');

  return {
    enabled: Boolean($vehicles.data('vehicleSurchargeFees')),
    facilityId: $vehicles.data('facilityId') || '',
  };
};

const hideVehicleSurchargeMessage = () => {
  $('.vehicle-surcharge-message').hide();
};

const getNewVehicleSelections = () => {
  return $('#vehicles')
    .find('.form-field-group-vehicle')
    .map(function () {
      const $vehicleGroup = $(this);

      if ($vehicleGroup.data('vehicleId')) {
        return null;
      }

      const make = $vehicleGroup.find('select[name="vehicle-make"] option:selected').data('name');
      const model = $vehicleGroup.find('select[name="vehicle-model"] option:selected').data('name');

      if (!make || !model) {
        return null;
      }

      return { make, model };
    })
    .get()
    .filter(Boolean);
};

const updateVehicleSurchargeMessage = () => {
  const { enabled, facilityId } = getVehicleSurchargeConfig();

  if (!enabled || !facilityId) {
    vehicleSurchargeRequestId++;
    hideVehicleSurchargeMessage();
    return;
  }

  const vehicles = getNewVehicleSelections();

  if (!vehicles.length) {
    vehicleSurchargeRequestId++;
    hideVehicleSurchargeMessage();
    return;
  }

  const requestId = ++vehicleSurchargeRequestId;

  fetch(`${getV2GraphQLApiUrl()}/graphqlPublic`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: `
        query vehiclesHaveSurcharges($facilityId: String!, $vehicles: [VehicleMakeModelInput]!) {
          vehiclesHaveSurcharges(facilityId: $facilityId, vehicles: $vehicles)
        }
      `,
      variables: {
        facilityId,
        vehicles,
      },
      context: {
        apiVersion: 'v2',
        public: true,
      },
    }),
  })
    .then((response) => response.json())
    .then((result) => {
      if (requestId !== vehicleSurchargeRequestId) {
        return;
      }

      if (result.errors?.length) {
        console.log(result.errors);
        hideVehicleSurchargeMessage();
        return;
      }

      $('.vehicle-surcharge-message').toggle(Boolean(result?.data?.vehiclesHaveSurcharges));
    })
    .catch((error) => {
      if (requestId !== vehicleSurchargeRequestId) {
        return;
      }

      console.log('Error checking vehicle surcharges', error);
      hideVehicleSurchargeMessage();
    });
};

const setVehicleSurchargeConfig = ({ facilityId, vehicleSurchargeFees }) => {
  const $vehicles = $('#vehicles');

  $vehicles.data('facilityId', facilityId || '');
  $vehicles.data('vehicleSurchargeFees', Boolean(vehicleSurchargeFees));

  if (!vehicleSurchargeFees) {
    vehicleSurchargeRequestId++;
    hideVehicleSurchargeMessage();
    return;
  }

  updateVehicleSurchargeMessage();
};

function initializeSession(facilityId) {
  const parkerId = crypto.randomUUID();
  const sessionId = crypto.randomUUID();
  const now = new Date();
  const localISO = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString();
  const formattedDate = localISO.split('T')[0];

  const apiUrl = getV2GraphQLApiUrl();

  const endpoint = `${apiUrl}/graphqlPublic`;

  const mutation = `
    mutation initializeMonthlySession(
        $id: String!,
        $rateId: String,
        $startDate: String,
        $facilityId: String,
        $parkerId: String!
        ) {
        initializeMonthlySession(
            id: $id,
            rateId: $rateId,
            startDate: $startDate,
            facilityId: $facilityId
            parkerId: $parkerId
        )
    }
  `;
  const variables = {
      id: sessionId,
      rateId: null,
      startDate: formattedDate,
      parkerId,
      facilityId
  };

  fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: mutation,
      variables: variables,
      context: {
        apiVersion: 'v2',
        public: true,
      }
    })
  })
  .then(response => response.json())
  .then(data => {
    let redirectUrl;
    let hostname = window.location.hostname;

    if (hostname.includes('iconparking.parkchirp')) {
      hostname = 'iconparking.com';
    }

    const domainParts = hostname.split('.');
    const domainWithoutTLD =
      domainParts.length > 2
        ? domainParts[1]
        : domainParts[0];

    if (hostname.includes('parkchirp.localhost')) {
      redirectUrl = 'http://127.0.0.1:4050';
    } else if (hostname.includes('chirpqa.com')) {
      redirectUrl = 'https://checkout.chirpqa.com';
    } else if (hostname.includes('staging.abmparking.com')) {
      redirectUrl = 'https://checkout.parkcheep.com';
    } else if (hostname.includes('parkcheep.com')) {
      redirectUrl = 'https://checkout.parkcheep.com';
    } else {
      redirectUrl = `https://checkout.parkchirp.com`;
    }

    console.log('Redirecting to:', redirectUrl);

    window.location.href = `${redirectUrl}/?sessionId=${sessionId}&host=${domainWithoutTLD}`;
  })
  .catch(error => {
    console.error('Error during API call:', error);
  });
}

function initializeSessionFromMapPage(rateId, facilityId) {
  const parkerId = crypto.randomUUID();
  const sessionId = crypto.randomUUID();
  const now = new Date();
  const localISO = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString();
  const formattedDate = localISO.split('T')[0];
  const apiUrl = getV2GraphQLApiUrl();

  const endpoint = `${apiUrl}/graphqlPublic`;

  const mutation = `
    mutation initializeMonthlySession(
        $id: String!,
        $rateId: String,
        $startDate: String,
        $facilityId: String,
        $parkerId: String!
        ) {
        initializeMonthlySession(
            id: $id,
            rateId: $rateId,
            startDate: $startDate,
            facilityId: $facilityId
            parkerId: $parkerId
        )
    }
  `;
  const variables = {
    id: sessionId,
    rateId,
    startDate: formattedDate,
    parkerId,
    facilityId
  };

  fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: mutation,
      variables: variables,
      context: {
        apiVersion: 'v2',
        public: true,
      }
    })
  })
  .then(response => response.json())
  .then(data => {
    let redirectUrl;
    const hostname = window.location.hostname;
    const domainParts = hostname.split('.');
    const domainWithoutTLD =
      domainParts.length > 2
        ? domainParts[1]
        : domainParts[0];
    switch (hostname) {
      case 'parkchirp.localhost':
        redirectUrl = 'http://127.0.0.1:4050';
        break;
      case 'chirpqa.com':
        redirectUrl = 'https://checkout.chirpqa.com';
        break;
      case 'parkcheep.com':
        redirectUrl = 'https://checkout.parkcheep.com';
        break;
      default:
        redirectUrl = `https://checkout.parkchirp.com`;
        break;
    }
    console.log('Redirecting to:', redirectUrl);
    window.location.href = `${redirectUrl}/?sessionId=${sessionId}&host=${domainWithoutTLD}`;
  })
  .catch(error => {
    console.error('Error during API call:', error);
  });
}

function UpdateMobileMapTime(startUnix, endUnix, timezone) {
  //.format("YYYY-MM-DD hh:mm a")
  startMoment = moment.tz(startUnix * 1000, timezone || "Etc/UTC")
  endMoment = moment.tz(endUnix * 1000, timezone || "Etc/UTC")
  console.log(`${GetMobileMonthFormat(startMoment.month())} ${startMoment.format("D")} ${startMoment.format("h:mm a")}`)
  if (startMoment.isSame(new Date(), "day")) {
    $('.search-toolbar-button-datetime-start .search-toolbar-button-date').empty().text('Today');
  } else {
    $('.search-toolbar-button-datetime-start .search-toolbar-button-date').empty().text(`${GetMobileMonthFormat(startMoment.month())} ${startMoment.format("D")}`);
  }

  if (endMoment.isSame(new Date(), "day")) {
    $('.search-toolbar-button-datetime-end .search-toolbar-button-date').empty().text('Today');
  } else {
    $('.search-toolbar-button-datetime-end .search-toolbar-button-date').empty().text(`${GetMobileMonthFormat(endMoment.month())} ${endMoment.format("D")}`);
  }


  $('.search-toolbar-button-datetime-start .search-toolbar-button-time').empty().text(startMoment.format("h:mm a"));
  $('.search-toolbar-button-datetime-end .search-toolbar-button-time').empty().text(endMoment.format("h:mm a"));

}

function GetTimeNearest30(date) {
  m = moment(date);
  if (m.minute() > 30) {
    m.minute(30)
  } else {
    m.minute(0)
  }
  return m.format("HH:mm");
}

function GetTimeStr(date) {
  return moment(date).format("hh:mm a");
}

function GetUTCNow() {
  var date = new Date();
  `${date.getFullYear()}-${date.getMonth()}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`
  var now_utc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(),
    date.getHours(), date.getMinutes(), date.getSeconds());
  return Number(now_utc / 1000);
}

function GetSlugFromStr(str) {
  return str.split(' ').join('-').toLowerCase();
}

function initialSearchForm(type) {
  
  // allow choosing location with keyboard
  $('#address').keydown(function (e) {
    if (e.which == 13 && $('.pac-container:visible').length) {
      return false;
    }
  });

  var autocompleteForm = $('#autocomplete-form').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('form'));
      // error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('form').addClass(errorClass).removeClass(validClass);
      // $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('form').removeClass(errorClass).addClass(validClass);
      // $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    rules: {
      'address': {
        required: true,
      }
    },
    messages: {
      'address': {
        required: 'Please enter a place, address, or landmark.',
      }
    },
    submitHandler: function (form) {
      $('.button-spinner').prop('disabled', true);

      var parkingType = 'hourly';
      if ($('input[name="parking-type"]', form).length > 0) {
        var parkingType = $('input[name="parking-type"]:checked', form).val();
      } else if (type) {
        var parkingType = type;
      }

      console.log('parking type:', parkingType);

      var address = $('#address').val();
      var offset = $('#address').attr('data-offset');
      var latitude = $('#address').attr('data-latitude');
      var longitude = $('#address').attr('data-longitude');
      var nonce = $('#autocomplete-form-nonce').val();

      if (latitude == 0 && longitude == 0) {
        // input has a value, but user hasn't selected a location from autocomplete
        autocompleteForm.showErrors({
          'address': 'Please choose a location from the dropdown menu.'
        });
        $('.button-spinner').prop('disabled', false);
      } else {
        var date = new Date();

        var url = new URL(window.location.href);
        url.pathname = '/search/';
        url.searchParams.set('type', parkingType);
        url.searchParams.set('startDate', GetDateStr(date));
        url.searchParams.set('startTime', GetTimeNearest30(date));
        url.searchParams.set('lat', latitude);
        url.searchParams.set('lng', longitude);
        url.searchParams.set('address', encodeURIComponent(address));
        url.searchParams.set('offset', offset);
        console.log('url:', url);
        window.location.href = url.href;
      }
    }
  });
}

/* launch custom alert */
function launchAlert(alertTitle, alertText) {
  var alertTitle = alertTitle;
  var alertText = alertText;
  var alertTemplate = '<div class="site-content-overlay-alert"><div class="alert-header">' + alertTitle + '</div><div class="alert-content">' + alertText + '</div><div class="alert-buttons"><button class="alert-button" id="alert-close">Ok</button></div></div>';
  $('.site-content-overlay').addClass('site-content-overlay-active').append(alertTemplate);
  /* close custom alerts */
  $(document).on('click', '#alert-close', function () {
    $(this).closest('.site-content-overlay').removeClass('site-content-overlay-active');
    $('.site-content-overlay-alert').remove();
  });
}

/* custom map markers */
function customMarker(latlng, price, id, city, state, map, focusedPin) {
  this.latlng = latlng;
  this.price = price;
  this.id = id;
  this.city = city;
  this.state = state;
  this.focusedPin = !!focusedPin;
  this.setMap(map);
}

/* show all facilities on search page */
function allFacilitiesMap(mapId, centerType, centerLat, centerLng, centerZoom) {

  // get facilities from the search results list
  var facilities = [];
  $('.result:not([data-zone-id])').each(function (key, value) {
    var lat = $(this).attr('data-latitude');
    var lng = $(this).attr('data-longitude');
    var price = $(this).attr('data-display-price');
    var id = $(this).attr('id');
    var city = $(this).attr('data-city');
    var state = $(this).attr('data-state');
    facilities.push({
      lat: lat,
      lng: lng,
      price: price,
      id: id,
      city: city,
      state: state
    });
  });

  console.log(facilities);

  if (facilities) {

    var center = { lat: 0, lng: 0 }
    var zoom = 15;
    if (centerType === 'center-location') {
      var centerLat = Number(centerLat);
      var centerLng = Number(centerLng);
      var center = { lat: centerLat, lng: centerLng }
      var zoom = Number(centerZoom);
    }

    var mapOptions = {
      zoom: zoom,
      center: center,
      // disableDefaultUI: true,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: true,
      fullScreenControl: false,
      clickableIcons: false
    };

    var map = new google.maps.Map(document.getElementById(mapId), mapOptions);

    if (centerType === 'fit-all-facilities') {
      var bounds = new google.maps.LatLngBounds();
    }

    // if (centerType === 'center-location') {
    //   var marker = new google.maps.Marker({
    //     position: center,
    //     map: map
    //   });
    // }

    $(facilities).each(function (index, facility) {
      var latLng = new google.maps.LatLng(facility.lat, facility.lng);
      var marker = new customMarker(latLng, facility.price, facility.id, facility.city, facility.state, map);
      if (centerType === 'fit-all-facilities') {
        bounds.extend(latLng);
      }
    });

    if (centerType === 'fit-all-facilities') {
      map.fitBounds(bounds);
    }

    addZoneMapMarkers(map, centerType === 'fit-all-facilities' ? bounds : null);

  }
}

/* fancy google map for search page */
function searchMap(lat, lng, mapId) {
  var lat = parseFloat(lat);
  var lng = parseFloat(lng);
  var mapId = mapId;

  var myLatLng = new google.maps.LatLng(lat, lng);
  
  console.log(lat, lng, myLatLng.lat(), myLatLng.lng());
  
  var mapOptions = {
    zoom: 15,
    center: myLatLng,
    // disableDefaultUI: true,
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: true,
    fullScreenControl: false,
    clickableIcons: false
  };
  var map = new google.maps.Map(document.getElementById(mapId), mapOptions);

  var marker = new google.maps.Marker({
    position: myLatLng,
    map: map
  });

  // get facilities from the search results list
  var facilities = [];
  $('.result:not([data-zone-id])').each(function (key, value) {
    var lat = $(this).attr('data-latitude');
    var lng = $(this).attr('data-longitude');
    var price = $(this).attr('data-display-price');
    var id = $(this).attr('id');
    var city = $(this).attr('data-city');
    var state = $(this).attr('data-state');
    facilities.push({
      lat: lat,
      lng: lng,
      price: price,
      id: id,
      city: city,
      state: state
    });
  });

  // for each facility, run these...
  facilities.forEach(function (facility) {
    var latlng = new google.maps.LatLng(facility.lat, facility.lng);
    var chirpMarker = new customMarker(latlng, facility.price, facility.id, facility.city, facility.state, map);
  });

  addZoneMapMarkers(map);

}

// Pin settings are stored as addresses. Resolve them using the map's existing Google
// Maps session, retaining results across date/filter changes and throttling requests.
var zonePinLocations = new Map();
var zonePinQueue = [];
var zonePinGeocoding = false;

function geocodeZonePin(address) {
  if (zonePinLocations.has(address)) return zonePinLocations.get(address);
  var request = new Promise(function (resolve, reject) {
    zonePinQueue.push({ address: address, resolve: resolve, reject: reject, attempts: 0 });
  });
  zonePinLocations.set(address, request);
  processZonePinQueue();
  return request;
}

function processZonePinQueue() {
  if (zonePinGeocoding || !zonePinQueue.length) return;
  zonePinGeocoding = true;
  var request = zonePinQueue.shift();
  var finished = false;
  var timer = setTimeout(function () { finish(null, 'TIMEOUT'); }, 10000);
  function finish(results, status) {
    // Authentication failures may never call back; late callbacks must not settle
    // the request twice or release another request's queue slot.
    if (finished) return;
    finished = true;
    clearTimeout(timer);
    if (status === 'OVER_QUERY_LIMIT' && request.attempts < 2) {
      request.attempts++;
      zonePinQueue.push(request);
    } else {
      var location = status === 'OK' && results && results[0] ? results[0].geometry.location : null;
      if (!location) zonePinLocations.delete(request.address);
      if (location || status === 'ZERO_RESULTS') {
        request.resolve(location);
      } else {
        request.reject(new Error('Google Maps could not load this pin. Check the Maps configuration and try again.'));
      }
    }
    setTimeout(function () {
      zonePinGeocoding = false;
      processZonePinQueue();
    }, status === 'OVER_QUERY_LIMIT' ? 1000 : 100);
  }
  try {
    new google.maps.Geocoder().geocode({ address: request.address }, finish);
  } catch (error) {
    finish(null, 'ERROR');
  }
}

function addZoneMapMarkers(map, bounds) {
  var container = map.getDiv();
  container.chirpActiveMap = map;
  var target = getZonePinTarget();
  var targetFound = false;
  if (!target) $('#zone-pin-status').remove();
  $('.result').removeClass('result-pin-focus');
  $('.result[data-zone-id]').each(function () {
    var row = $(this);
    var addresses;
    try { addresses = JSON.parse(row.attr('data-map-pin-addresses') || '[]'); }
    catch (error) { return; }
    if (!Array.isArray(addresses)) return;
    addresses.forEach(function (address) {
      if (typeof address !== 'string' || !address.trim()) return;
      var focused = isTargetZonePin(target, row.attr('data-zone-id'), address);
      if (focused) targetFound = true;
      geocodeZonePin(address).then(function (location) {
        // A new search may have replaced this map while geocoding was in flight.
        if (container.chirpActiveMap !== map || !row[0].isConnected) return;
        if (!location) {
          if (focused) showZonePinStatus('The saved pin address could not be located. Please check its address in Zone Settings.', map);
          return;
        }
        new customMarker(location, row.attr('data-display-price'), row.attr('id'), row.attr('data-city'), row.attr('data-state'), map, focused);
        row.attr('data-latitude', location.lat()).attr('data-longitude', location.lng());
        if (focused) {
          map.chirpPinFocused = true;
          map.setCenter(location);
          map.setZoom(17);
          row.addClass('result-pin-focus');
          row[0].scrollIntoView({ block: 'nearest' });
          showZonePinStatus(row.attr('data-price') === 'NA' ? 'Selected pin — this zone is unavailable for the selected dates.' : 'Selected pin: ' + address, map);
        }
        if (bounds && !map.chirpPinFocused) {
          bounds.extend(location);
          map.fitBounds(bounds);
        }
      }).catch(function (error) {
        if (focused && container.chirpActiveMap === map && row[0].isConnected) {
          showZonePinStatus(error.message, map);
        }
      });
    });
  });
  if (target && !targetFound) showZonePinStatus('The selected pin is not displayed for the current dates or filters. It may also no longer be published on this map.', map);
}

/* simple google map with one marker */
function simpleMap(lat, lng, mapId) {
  var lat = lat;
  var lng = lng;
  var mapId = mapId;

  var myLatLng = new google.maps.LatLng(lat, lng);
  var mapOptions = {
    zoom: 16,
    center: myLatLng,
    disableDefaultUI: true,
    clickableIcons: false
  };
  var map = new google.maps.Map(document.getElementById(mapId), mapOptions);

  var marker = new google.maps.Marker({
    position: myLatLng,
    map: map
  });
}

/* hourly parking query */
function updateSearchForm() {
  var form = $('#update-search');
  $(form).submit(function (e) {
    e.preventDefault();

    // disable button on submit
    $('.button-spinner', this).prop('disabled', true);

    // close and empty modal if open
    if ($('body').hasClass('modal-active')) {
      $('body').removeClass('modal-active');
      $('.modal-window').empty();
    }

    // close search toolbar if open
    if ($('body').hasClass('search-toolbar-active')) {
      $('body').removeClass('search-toolbar-active');
    }

    // close filter toolbar if open
    if ($('body').hasClass('filter-toolbar-active')) {
      $('body').removeClass('filter-toolbar-active');
    }

    // trigger loading overlay
    $('.site-content-overlay').addClass('site-content-overlay-active');
    $('.site-content-overlay-text').empty().text('Loading...');

    // show all facilities, even if they don't have pricing or products?
    var showAllFacilities = 'false';
    if ($('#show-all-facilities').length) {
      var showAllFacilities = $('#show-all-facilities').val();
    }

    console.log('showAllFacilities', showAllFacilities);

    // shared fields for both hourly and monthly
    var parkingType = $('input[name="parking-type"]:checked', form).val();
    var address = $('input[name="address"]', form).val();
    var lat = $('input[name="address"]', form).attr('data-latitude');
    var lng = $('input[name="address"]', form).attr('data-longitude');
    var amenities = [];
    $.each($('input[name="amenities"]:checked', form), function () {
      amenities.push($(this).val());
    });
    var maxPrice = $('#max-price', form).val();
    var timezone = $('#timezone', form).val();
    // var offset = $('#offset').val();
    var offset = Number($('input[name="address"]', form).attr('data-offset'));
    var nonce = $('#chirp-update-search-nonce', form).val();

    // compare to startDateTime and endDateTime for basic error handling
    var nowDateTime = Number($('#now-date-time', form).val());

    // hourly parking!
    if (parkingType == 'hourly') {

      // hourly-specific variables
      var startDate = $('#start-date', form).val();
      var startTime = $('#start-time', form).val();
      var endDate = $('#end-date', form).val();
      var endTime = $('#end-time', form).val();

      console.log('startDate:', startDate, 'startTime:', startTime);
      console.log('endDate:', endDate, 'endTime:', endTime);
      console.log('offset', offset);

      if (offset == 0) {

        var offsetISO8601 = '+00:00';

      } else {

        var offsetWIP = ((offset / 60) / 60) * 100;
        var offsetHours = offsetWIP.toString().slice(0, -2);
        var isNegative = offsetHours.indexOf('-');
        if (isNegative == 0) {
          if (offsetHours.length < 3) {
            offsetHours = offsetHours.substring(1);
            offsetHours = '-0' + offsetHours;
          }
        } else {
          if (offsetHours.length < 2) {
            offsetHours = '+0' + offsetHours;
          } else {
            offsetHours = '+' + offsetHours;
          }
        }
        var offsetMinutes = offsetWIP.toString().slice(-2);
        var offsetISO8601 = offsetHours + ':' + offsetMinutes;

      }

      offsetISO8601 = '+00:00';
      console.log('offsetISO8601:', offsetISO8601);

      // convert dates and times to unix epoch format
      // DO NOT ENABLE, THis is correct behavior on checkout but not for map page.
      // MAP PAGE uses set default timezone which breaks this logic
      var startDateISO = new Date(startDate + 'T' + startTime + offsetISO8601);
      startDateISO.setSeconds(startDateISO.getSeconds() - offset);

      var endDateISO = new Date(endDate + 'T' + endTime + offsetISO8601);
      endDateISO.setSeconds(endDateISO.getSeconds() - offset);

      var startDateTime = new Date(startDate + 'T' + startTime).getTime() / 1000;
      var endDateTime = new Date(endDate + 'T' + endTime).getTime() / 1000;
      var nowDateTime = GetUTCNow();

      console.log('startDateTime', startDateTime);
      console.log('endDateTime', endDateTime);
      console.log('nowDateTime', nowDateTime);

      if (startDateTime < nowDateTime) {

        launchAlert('Error', 'Start date or time is in the past!');
        $('.button-spinner', this).prop('disabled', false);

      } else if (endDateTime < nowDateTime) {

        launchAlert('Error', 'End date or time is in the past!');
        $('.button-spinner', this).prop('disabled', false);

      } else if (startDateTime >= endDateTime) {

        launchAlert('Error', 'End date or time is earlier than start date or time!');
        $('.button-spinner', this).prop('disabled', false);

      } else {

        $.ajax({
          type: 'post',
          dataType: 'json',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'hourly_parking_query',
            showAllFacilities: showAllFacilities,
            parkingType: parkingType,
            address: address,
            lat: lat,
            lng: lng,
            amenities: amenities,
            maxPrice: maxPrice,
            timezone: timezone,
            offset: offset,
            nonce: nonce,
            startDateISO: startDateISO.toISOString(),
            startDateTime: startDateTime,
            startDate: startDate,
            startTime: startTime,
            endDate: endDate,
            endTime: endTime,
            endDateTime: endDateTime,
            endDateISO: endDateISO.toISOString(),
          },
          success: function (results) {
            console.log(results);
            $('.button-spinner').prop('disabled', false);
            if (results.status == 'success') {

              $('.site-content-overlay').removeClass('site-content-overlay-active');
              $('.search-results-list').empty().append(results.template);

              // get current url and parameters
              var url = new URL(window.location);

              // update parameters based on search query
              url.searchParams.set('type', parkingType);
              url.searchParams.set('startDate', startDate);
              url.searchParams.set('startTime', startTime);
              url.searchParams.set('endDate', endDate);
              url.searchParams.set('endTime', endTime);
              url.searchParams.set('lat', lat);
              url.searchParams.set('lng', lng);
              url.searchParams.set('address', encodeURIComponent(address));
              url.searchParams.set('offset', offset);

              // update url with new parameters
              window.history.replaceState({}, '', url.origin + url.pathname + url.search);

              // window.history.replaceState({}, '', '/search/?type=hourly&startTime=' + startTime + '&startDate=' + startDate + '&lat=' + lat + '&lng=' + lng + '&address=' + encodeURIComponent(address) + '&offset=' + offset + '');

              UpdateMobileMapTime(results.startDateTime, results.endDateTime);
              console.log("REPLACE ", startTime)
              searchResultsList();
              sortSearchResults();
              searchMap(lat, lng, 'map');
              $('input[name="max-price"]').attr('disabled', false);

              /*** highlight pin when hovering on result listing ***/
              $('.result').hover(function () {
                var thisFacility = $(this).attr('id');
                $('.marker[data-facility-id="' + thisFacility + '"]').addClass('marker-active');
              }, function () {
                var thisFacility = $(this).attr('id');
                $('.marker[data-facility-id="' + thisFacility + '"]').removeClass('marker-active');
              });

              UpdateMobileMapTime(results.startDateTime, results.endDateTime);

            } else if (results.status == 'error') {

              if (results.template) {

                $('.site-content-overlay').removeClass('site-content-overlay-active');
                $('.search-results-list').empty().append(results.template);
                searchMap(lat, lng, 'map');

                // get current url and parameters
                var url = new URL(window.location);

                // update parameters based on search query
                url.searchParams.set('type', parkingType);
                // url.searchParams.set('startDate', startDate);
                // url.searchParams.set('startTime', startTime);
                // url.searchParams.set('endDate', endDate);
                // url.searchParams.set('endTime', endTime);
                url.searchParams.set('lat', lat);
                url.searchParams.set('lng', lng);
                url.searchParams.set('address', encodeURIComponent(address));
                url.searchParams.set('offset', offset);

                // update url with new parameters
                window.history.replaceState({}, '', url.origin + url.pathname + url.search);

                // window.history.replaceState({}, '', '/search/?type=hourly&lat=' + lat + '&lng=' + lng + '&address=' + encodeURIComponent(address) + '&offset=' + offset + '');

              } else {

                launchAlert('Error', results.message);

              }

            } else {

              launchAlert('Error', 'Uh oh, something went wrong.');

            }

          },
          error: function (results) {
            console.error('Parking search failed', results.status);
            $('.button-spinner', form).prop('disabled', false);
            $('.site-content-overlay').removeClass('site-content-overlay-active');
            $('.site-content-overlay-text').empty();
            launchAlert('Error', 'Unable to load parking results. Please try again.');
          }
        });

      }

      // monthly parking!
    } else if (parkingType == 'monthly') {

      // monthly-specific variables
      var spotType = $('#spot-type').val();
      var accessHours = $('#access-hours').val();
      var startDate = $('#start-date-monthly').val();
      let cookieDomain = window.location.hostname;
      let isSecure = window.location.protocol === 'https:';
      let cookieString = `startDate=${startDate}; path=/; domain=.${cookieDomain};`;
      if (isSecure) {
        cookieString += ' Secure; SameSite=None;';
      }
      document.cookie = cookieString;
      var startTime = '23:59';

      var startDateTime = new Date(startDate + 'T' + startTime).getTime() / 1000;

      if (startDateTime < nowDateTime) {

        launchAlert('Error', 'Sorry, you can\'t buy parking in the past!')
        $('.button-spinner').prop('disabled', false);

      } else {

        $.ajax({
          type: 'post',
          dataType: 'json',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'monthly_parking_query',
            showAllFacilities: showAllFacilities,
            parkingType: parkingType,
            address: address,
            lat: lat,
            lng: lng,
            amenities: amenities,
            maxPrice: maxPrice,
            timezone: timezone,
            offset: offset,
            nonce: nonce,
            spotType: spotType,
            accessHours: accessHours,
            startDateTime: startDateTime
          },
          success: function (results) {
            console.log(results);
            $('.button-spinner').prop('disabled', false);
            if (results.status == 'success') {

              $('.search-toolbar').removeClass('hourly-parking');
              $('.search-toolbar').addClass('monthly-parking');
              $('.site-content-overlay').removeClass('site-content-overlay-active');
              $('.search-results-list').empty().append(results.template);

              // get current url and parameters
              var url = new URL(window.location);

              // update parameters based on search query
              url.searchParams.set('type', parkingType);
              // url.searchParams.set('startDate', startDate);
              // url.searchParams.set('startTime', startTime);
              // url.searchParams.set('endDate', endDate);
              // url.searchParams.set('endTime', endTime);
              url.searchParams.set('lat', lat);
              url.searchParams.set('lng', lng);
              url.searchParams.set('address', encodeURIComponent(address));
              url.searchParams.set('offset', offset);
              url.searchParams.set('spotType', spotType);
              url.searchParams.set('accessHours', accessHours);

              // update url with new parameters
              window.history.replaceState({}, '', url.origin + url.pathname + url.search);

              // window.history.replaceState({}, '', '/search/?type=monthly&lat=' + lat + '&lng=' + lng + '&address=' + encodeURIComponent(address) + '&offset=' + offset + '&spotType=' + spotType + '&accessHours=' + accessHours + '');

              searchResultsList();
              sortSearchResults();
              searchMap(lat, lng, 'map');
              $('input[name="max-price"]').attr('disabled', true);

              /*** highlight pin when hovering on result listing ***/
              $('.result').hover(function () {
                var thisFacility = $(this).attr('id');
                $('.marker[data-facility-id="' + thisFacility + '"]').addClass('marker-active');
              }, function () {
                var thisFacility = $(this).attr('id');
                $('.marker[data-facility-id="' + thisFacility + '"]').removeClass('marker-active');
              });

            } else if (results.status == 'error') {

              if (results.template) {

                $('.site-content-overlay').removeClass('site-content-overlay-active');
                $('.search-results-list').empty().append(results.template);
                searchMap(lat, lng, 'map');

                // get current url and parameters
                var url = new URL(window.location);

                // update parameters based on search query
                url.searchParams.set('type', parkingType);
                // url.searchParams.set('startDate', startDate);
                // url.searchParams.set('startTime', startTime);
                // url.searchParams.set('endDate', endDate);
                // url.searchParams.set('endTime', endTime);
                url.searchParams.set('lat', lat);
                url.searchParams.set('lng', lng);
                url.searchParams.set('address', encodeURIComponent(address));
                url.searchParams.set('offset', offset);

                // update url with new parameters
                window.history.replaceState({}, '', url.origin + url.pathname + url.search);

                // window.history.replaceState({}, '', '/search/?type=hourly&lat=' + lat + '&lng=' + lng + '&address=' + encodeURIComponent(address) + '&offset=' + offset + '');

              } else {

                launchAlert('Error', results.message);

              }

            } else {

              launchAlert('Error', results.message);

            }
          },
          error: function (results) {
            console.error('Parking search failed', results.status);
            $('.button-spinner', form).prop('disabled', false);
            $('.site-content-overlay').removeClass('site-content-overlay-active');
            $('.site-content-overlay-text').empty();
            launchAlert('Error', 'Unable to load parking results. Please try again.');
          }

        });

      }

    } else {

      launchAlert('Error', 'Somehow you managed to not choose hourly or monthly parking?');
      $('.button-spinner').prop('disabled', false);

    }

  });

}

/* facility modal window */
function facilityModal(facilityId) {

  $('.site-content-overlay').addClass('site-content-overlay-active');
  $('.site-content-overlay-text').empty().text('Loading...');

  // get facility information
  var thisFacility = $('#' + facilityId);
  var facilityId = thisFacility.attr('data-facility-id') || facilityId;
  var zoneId = thisFacility.attr('data-zone-id');
  var reserveUrl = $('.result-button-reserve', thisFacility).attr('href');

  // get search information
  var parkingType = $('input[name="parking-type"]:checked').val();
  var price = thisFacility.attr('data-price');

  console.log('price:', price);

  if (parkingType == 'hourly') {
    var startDate = $('#start-date').val();
    var startTime = $('#start-time').val();
    var endDate = $('#end-date').val();
    var endTime = $('#end-time').val();

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'facility_modal',
        facilityId: facilityId,
        zoneId: zoneId,
        reserveUrl: reserveUrl,
        parkingType: parkingType,
        startDate: startDate,
        startTime: startTime,
        endDate: endDate,
        endTime: endTime,
        price: price
      },
      success: function (results) {
        $('.site-content-overlay').removeClass('site-content-overlay-active');
        $('.modal-window').empty().append(results);
        $('body').addClass('modal-active');
        modalClose();
        basicTabs();
        facilityPhotos();
        // modalDistance(facilityId);
      },
      error: function (results) {
        $('.site-content-overlay').removeClass('site-content-overlay-active');
        console.log('Hmm, something might be broken...', results);
      }
    });

  } else if (parkingType == 'monthly') {
    var startDate = $('#start-date-monthly').val();

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'facility_modal',
        facilityId: facilityId,
        reserveUrl: reserveUrl,
        parkingType: parkingType,
        startDate: startDate,
        price: price
      },
      success: function (results) {
        $('.site-content-overlay').removeClass('site-content-overlay-active');
        $('.modal-window').empty().append(results);
        $('body').addClass('modal-active');
        modalClose();
        basicTabs();
        facilityPhotos();
        // modalDistance(facilityId);
      },
      error: function (results) {
        console.log('Hmm, something might be broken...', results);
      }
    });

  }
}

/* close modal and empty content */
function modalClose() {
  $('.modal-close-button').click(function (e) {
    e.preventDefault();
    $('body').removeClass('modal-active');
    $('.modal-window').empty();
  });
}

/* tabs functionality */
function basicTabs() {
  $('.tabs').each(function () {
    $('.tabs-nav a').click(function (e) {
      e.preventDefault();
      var tab = $(this).attr('href');
      $('.tabs-nav li').removeClass('tab-active');
      $('.tab').removeClass('tab-active');
      $(this).parent().addClass('tab-active');
      $(tab).addClass('tab-active');
    });
  });
}

/* facility photo gallery */
function facilityPhotos() {
  $('.facility-photo-gallery').each(function () {
    // if there's more than one photo, initalize slider
    if ($(this).find('.facility-photo').length > 1) {
      var facility_photos = $(this).flickity({
        adaptiveHeight: true,
        cellAlign: 'left',
        contain: true,
        imagesLoaded: true,
        pageDots: false,
        percentPosition: true,
        wrapAround: true
      });
    }
  });
}

/* search results list functionality */
function searchResultsList() {
  $('.result').each(function () {
    var thisFacility = $(this);
    var latitude = $(this).attr('data-latitude');
    var longitude = $(this).attr('data-longitude');
    // calculate walking distance and time from facility to location
    // walkingDistance(thisFacility, latitude, longitude);
    // get content for facility modal on "details" button click
    $('.result-button-details', this).click(function () {
      var facilityId = $(this).parents('li').attr('id');
      $('body').removeClass('search-results-overlay');
      facilityModal(facilityId);
    });
  });
}

/* search results sort functionality */
function sortSearchResults() {
  var config = {
    debug: {
      enable: true
    },
    load: {
      sort: 'proximity:asc'
    },
    animation: {
      effects: 'fade scale',
      duration: 500,
      easing: 'ease-in-out'
    },
    classNames: {
      block: 'toolbar',
      elementFilter: 'button',
      elementSort: 'button'
    },
    selectors: {
      target: '.result'
    }
  };
  var container = $('.search-results-list ol');
  if (container.length > 0) {
    var mixer = mixitup(container, config);
  }
}

/* get cookies */
function getCookie(cookieName) {
  let cookie = {};
  document.cookie.split(';').forEach(function (el) {
    let [key, value] = el.split('=');
    cookie[key.trim()] = value;
  });
  return cookie[cookieName];
}

/* process url parameters */
function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

/* add a new license plate */
function newLicensePlateField() {
  $('input[name="license-plates"]').change(function () {
    var value = $(this).val();
    if (value == 'new') {
      $('#new-license-plate-field').show();
    } else {
      $('#new-license-plate-field').hide();
    }
  });
}

/* add a new credit card */
function newCreditCardField() {
  $('input[name="credit-cards"]').change(function () {
    var value = $(this).val();
    if (value == 'new') {
      $('#new-credit-card-field').show();
    } else {
      $('#new-credit-card-field').hide();
    }
  });
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this, args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

let USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});

function calculateMonthlyPrice() {
  var quantity = $('#quantity').val();
  if (quantity > 0) {
    var productPrice = $('input[name="monthly-options"]:checked').attr('data-price');
    var displayPrice = productPrice * quantity;
    $('#display-price').text(USDollar.format(displayPrice).replace('$', '').trim());
    // var stripePrice = displayPrice * 100;
    var stripePrice = productPrice * 100;
    $('#price').val(stripePrice);
  } else {
    console.log('quantity is less than 1');
  }
}

function calculateCouponPrice() {
  var quantity = $('#quantity').val();
  if (quantity > 0) {
    var productPrice = $('input[name="coupon-options"]:checked').attr('data-price');
    var displayPrice = productPrice * quantity;
    $('#display-price').text(USDollar.format(displayPrice).replace('$', '').trim());
    // var stripePrice = displayPrice * 100;
    var stripePrice = productPrice * 100;
    $('#price').val(stripePrice);
  } else {
    console.log('quantity is less than 1');
  }
}

function slugify(string) {
  var slug = string;
  slug = $.trim(slug);
  slug = slug.replace(/[^a-z0-9-]/gi, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  return slug.toLowerCase();
}

function updateGpiCardFormHeight() {
  Object.keys(GPIForm.fields).forEach(formField => {
    $(GPIForm.fields[formField].target + " iframe").height(50);
  });
}

function chirp2_sf_form_update_hourly_checkout_url(url, start_date_time, end_date_time, offset, promo_code, price) {
  var checkout_url = new URL(url);
  // adjust times for offset
  start_date_time = Number(start_date_time) + Number(offset);
  end_date_time = Number(end_date_time) + Number(offset);
  // set/reset url parameters
  checkout_url.searchParams.set('startTime', start_date_time);
  checkout_url.searchParams.set('endTime', end_date_time);
  if (promo_code) {
    checkout_url.searchParams.set('promoCode', promo_code);	
  } else {
    checkout_url.searchParams.delete('promoCode');	
  }
  if (price) {
    checkout_url.searchParams.set('expectedPrice', price);  
  }
  // convert url object into string
  var checkout_url_string = checkout_url.toString();
  $('#hourly-parking-submit').attr('href', checkout_url_string);
}

function chirp2_sf_form_update_monthly_checkout_url(url, product_id, start_date, offset, quantity, promo_code) {
  var checkout_url = new URL(url);
  // convert start date into unix timestamp
  var start_moment_obj = moment(start_date + ' 12:00', 'YYYY-MM-DD HH:mm');
  var start_date_time = start_moment_obj.unix();
  // adjust times for offset
  start_date_time = Number(start_date_time) + Number(offset);
  // set/reset url parameters
  checkout_url.searchParams.set('productId', product_id);
  checkout_url.searchParams.set('startTime', start_date_time);
  checkout_url.searchParams.set('quantity', quantity);
  if (promo_code) {
    checkout_url.searchParams.set('promoCode', promo_code);	
  } else {
    checkout_url.searchParams.delete('promoCode');	
  }
  // convert url object into string
  var checkout_url_string = checkout_url.toString();
  $('#monthly-parking-submit').attr('href', checkout_url_string);
}

function chirp2_sf_form_update_coupon_checkout_url(url, product_id, quantity, promo_code) {
  var checkout_url = new URL(url);
  // set/reset url parameters
  checkout_url.searchParams.set('productId', product_id);
  checkout_url.searchParams.set('quantity', quantity);
  if (promo_code) {
    checkout_url.searchParams.set('promoCode', promo_code);	
  } else {
    checkout_url.searchParams.delete('promoCode');	
  }
  // convert url object into string
  var checkout_url_string = checkout_url.toString();
  $('#coupon-parking-submit').attr('href', checkout_url_string);
}

function chirp2_sf_form_update_hourly_price(facility_id, start_date, start_time, end_date, end_time, offset, promo_code) {
  // enable loading overlay
  $('#hourly-parking-loading').addClass('chirp2-sf-form-tab-loading-active');
  
  // convert dates and times into unix timestamps
  var start_moment_obj = moment(start_date + ' ' + start_time, 'YYYY-MM-DD HH:mm');
  var end_moment_obj = moment(end_date + ' ' + end_time, 'YYYY-MM-DD HH:mm');
  var start_date_time = start_moment_obj.unix();
  var end_date_time = end_moment_obj.unix();

  // get the date and time right now for comparison
  var now_moment = moment();
  // round minutes down to the nearest 30 minutes interval
  if (now_moment.minutes() < 30) {
    // minutes less than 30, round down to 0
    now_moment.minutes(0).seconds(0);
  } else {
    // minutes 30 or more, round down to 30
    now_moment.minutes(30).seconds(0);
  }
  var now_date_time = moment(now_moment).unix();
  
  $.ajax({
    type: 'post',
    url: '/wp-admin/admin-ajax.php',
    data: {
      action: 'calculate_hourly_price',
      facilityId: facility_id,
      startDateTime: start_date_time,
      endDateTime: end_date_time,
      nowDateTime: now_date_time,
      promoCode: promo_code
    },
    success: function(results) {
      var results = JSON.parse(results);
      console.log(results);
      if (results.status === 'success') {
        $('#hourly-display-price').empty().text(results.new_display_price);
        $('#hourly-price').val(results.new_price);
        $('#hourly-parking-message').empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
      } else if (results.status === 'error') {
        $('#hourly-display-price').empty().text(' N/A');
        $('#hourly-price').val('N/A');
        $('#hourly-parking-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
      }
      var current_url = $('#hourly-parking-submit').attr('href');
      chirp2_sf_form_update_hourly_checkout_url(current_url, start_date_time, end_date_time, offset, promo_code, results.new_price);
      // disable loading overlay
      $('#hourly-parking-loading').removeClass('chirp2-sf-form-tab-loading-active');
    },
    error: function(results) {
      $('#hourly-display-price').empty().text(' N/A');
      $('#hourly-price').val('N/A');
      $('#hourly-parking-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong?');
      // disable loading overlay
      $('#hourly-parking-loading').removeClass('chirp2-sf-form-tab-loading-active');
    }
  });
}

function chirp2_sf_form_update_product_price(type, price, quantity) {
  var display_price = price * quantity;
  $('#' + type + '-display-price').text(USDollar.format(display_price).replace('$', '').trim());
}

function chirp2_sf_form_update_products(type, facility_id, promo_code) {
  $.ajax({
    type: 'post',
    url: '/wp-admin/admin-ajax.php',
    data: {
      action: 'calculate_product_price',
      facilityId: facility_id,
      parkingType: type,
      promoCode: promo_code
    },
    success: function(results) {
      var results = JSON.parse(results);
      console.log(results);
      if (results.status === 'success') {
        $('#' + type + '-products').empty().append(results.productTemplate);
        $('#' + type + '-display-price').empty().text(USDollar.format(results.productsArray[0].product_price).replace('$', '').trim());
        $('#' + type + '-parking-message').empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
        var current_url = $('#' + type + '-parking-submit').attr('href');
        var quantity = $('#' + type + '-quantity').val();
        chirp2_sf_form_update_coupon_checkout_url(current_url, results.productsArray[0].product_id, quantity, promo_code); 
      } else if (results.status === 'error') {
        $('#' + type + '-parking-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
      }
    },
    error: function(results) {
      var results = JSON.parse(results);
      console.log(results);
      $('#' + type + '-parking-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong?');
    }
  });
}

function chirp2_sf_form_update_coupon_products(facility_id, promo_code) {
  console.log(facility_id, promo_code);
}

/*** new all-purpose find parking form functionality ***/
$.validator.addMethod('google_place_selected', function(value, element) {
  return JSON.parse($(element).attr('data-place-selected'));
}, 'Please select a valid location from the dropdown.');

function chirp_init_find_parking_form() {
  const inputs = $('input[name="google-places-autocomplete"]');
  const options = {
    componentRestrictions: { country: 'us' },
    fields: [ 'address_components', 'geometry', 'place_id', 'utc_offset_minutes' ],
    // types: [ 'address']
  };
  $(inputs).each(function(index, input) {
    const google_places_autocomplete_field = new google.maps.places.Autocomplete(input, options);
    google_places_autocomplete_field.addListener('place_changed', function() {
      const place = google_places_autocomplete_field.getPlace();
      console.log(place); 
      let place_selected = 'false';
      if (place && place.place_id) {
        place_selected = 'true';
      }
      $(input).attr({
        'data-latitude': place.geometry.location.lat(),
        'data-longitude': place.geometry.location.lng(),
        'data-offset': place.utc_offset_minutes * 60,
        'data-place-selected': place_selected
      });
      $(input).valid();
    });
    // set validation data attribute to false if user keeps typing
    $(input).on('input', function() {
      $(this).attr('data-place-selected', 'false');
    });
    
  });
};

$(document).ready(function () {
  initializeVehicleDropdowns();
  // get reCAPTCHA site key from script URL
  var recaptcha_url = new URL($('#recaptcha-js').attr('src'));
  var recaptcha_site_key = recaptcha_url.searchParams.get('render');

  const errorMessage = "There is an issue processing your payment. Please review the information entered, and try again."
	
  /*** new all-purpose find parking form functionality ***/
  
  let google_places_autocomplete_field;
  chirp_init_find_parking_form();
  
  const find_parking_forms = $('form[name="chirp-find-parking-form"]');
  $(find_parking_forms).each(function(index, form) {
    $(form).validate({
      // debug: true,
      errorElement: 'span',
      errorClass: 'form-field-error',
      validClass: 'form-field-valid',
      errorPlacement: function(error, element) {
        error.appendTo(element.parents('.chirp-find-parking-form-field'));
      },
      highlight: function(element, errorClass, validClass) {
        $(element).parents('.chirp-find-parking-form-field').addClass(errorClass).removeClass(validClass);
      },
      unhighlight: function(element, errorClass, validClass) {
        $(element).parents('.chirp-find-parking-form-field').removeClass(errorClass).addClass(validClass);
      },
      rules: {
        'parking-type': {
          required: true
        },
        'google-places-autocomplete': {
          required: true,
          google_place_selected: true
        }
      },
      messages: {
        'parking-type': {
          required: 'Please choose a parking type.'
        },
        'google-places-autocomplete': {
          required: 'Please enter a place, address, or landmark.',
          google_place_selected: 'Please select a valid location from the dropdown.'
        }
      },
      submitHandler: function(form) {
        $('.button-spinner').prop('disabled', true);
        
        const parking_type = $('input[name="parking-type"]:checked', form).val();
        const address = $('input[name="google-places-autocomplete"]', form).val();
        const latitude = $('input[name="google-places-autocomplete"]', form).attr('data-latitude');
        const longitude = $('input[name="google-places-autocomplete"]', form).attr('data-longitude');
        const offset = $('input[name="google-places-autocomplete"]', form).attr('data-offset');
        
        console.log('parking_type:', parking_type);
        console.log('address:', address);
        console.log('latitude:', latitude);
        console.log('longitude:', longitude);
        console.log('offset:', offset);
    
        if (latitude === 0 && longitude === 0 && offset === 0) {
          form.showErrors({
            'google-places-autocomplete': 'Please enter a place, address, or landmark.'
          });
        } else {  
          var date = new Date();
          var url = new URL(window.location.href);
          url.pathname = '/search/';
          url.searchParams.set('type', parking_type);
          url.searchParams.set('startDate', GetDateStr(date));
          url.searchParams.set('startTime', GetTimeNearest30(date));
          url.searchParams.set('lat', latitude);
          url.searchParams.set('lng', longitude);
          url.searchParams.set('address', encodeURIComponent(address));
          url.searchParams.set('offset', offset);
          console.log('url:', url);
          window.location.href = url.href;
        }
      }
    });
  });
  
  
  
  
  
  
  
  
  
  
	/* protect facilities cards block products menus with reCAPTCHA */
	var facilities_cards_groups = $('.chirp-block-facilities-cards-group');
	if (facilities_cards_groups) {
		$(facilities_cards_groups).each(function(index, group) {
			var facilities = [];
			var cards = $('.chirp-block-facility-card', group);
			if (cards) {
				$(cards).each(function(index, card) {
					var facility_id = $(card).attr('data-id');
					var facility_uid = $(card).attr('data-uid');
					var facility_name = $('.chirp-block-facility-card-title', card).text();
					var card = {};
					card['id'] = facility_id;
					card['uid'] = facility_uid;			
					card['name'] = facility_name;
					facilities.push(card);
				});
			}
			if (facilities.length > 0) {
				console.log('facilities:', facilities);
				grecaptcha.ready(function() {
					grecaptcha.execute(recaptcha_site_key, { action: 'buy_product_buttons' }).then(function(token) {
						$.ajax({
							type: 'post',
							url: '/wp-admin/admin-ajax.php',
							data: {
								action: 'chirp_facilities_cards_products_menus',
								recaptcha_token: token,
								facilities: facilities
							},
							success: function(results) {
								var results = JSON.parse(results);
								console.log(results);
								if (results['recaptcha_score'] >= 0.5) {
									$(facilities).each(function(index, facility) {
										// console.log(facility);
										var template = '';
										if (results['hourly_rates_buttons']) {
											if (facility['id'] in results['hourly_rates_buttons']) {
												template = template + results['hourly_rates_buttons'][facility['id']];
											}
										}
										if (results['hourly_products_buttons']) {
											if (facility['id'] in results['hourly_products_buttons']) {
												template = template + results['hourly_products_buttons'][facility['id']];
											}
										}
										if (results['monthly_rates_buttons']) {
											if (facility['id'] in results['monthly_rates_buttons']) {
												template = template + results['monthly_rates_buttons'][facility['id']];
											}
										}
										if (results['monthly_products_buttons']) {
											if (facility['id'] in results['monthly_products_buttons']) {
												template = template + results['monthly_products_buttons'][facility['id']];
											}
										}
										if (results['monthly_external_buttons']) {
											if (facility['id'] in results['monthly_external_buttons']) {
												template = template + results['monthly_external_buttons'][facility['id']];
											}
										}
										if (results['coupon_products_buttons']) {
											if (facility['id'] in results['coupon_products_buttons']) {
												template = template + results['coupon_products_buttons'][facility['id']];
											}
										}
										$('.chirp-block-facility-card[data-id="' + facility['id'] + '"] .chirp-block-facility-card-buttons').prepend(template);
									});
								}
								$(group).addClass('chirp-block-facility-card-buttons-are-loaded');
							},
							error: function(results) {
								console.log(results);
								$(group).addClass('chirp-block-facility-card-buttons-are-loaded');
							}
						});
					});
				});					
			}
		});
	}

	/* protect single facility page products menu with reCAPTCHA */
	var products_menus = $('.products-nav-js');
	if (products_menus) {
		$(products_menus).each(function(index, menu) {
			var facility_id = $(menu).attr('data-facility-id');
			var facility_uid = $(menu).attr('data-facility-uid');
			grecaptcha.ready(function() {
				grecaptcha.execute(recaptcha_site_key, { action: 'buy_product_buttons' }).then(function(token) {
					$.ajax({
						type: 'post',
						url: '/wp-admin/admin-ajax.php',
						data: {
							action: 'chirp_single_facility_products_menu',
							recaptcha_token: token,
							facility_id: facility_id,
							facility_uid: facility_uid
						},
						success: function(results) {
							var results = JSON.parse(results);
							console.log(results);
							if (results['recaptcha_score'] >= 0.5) {
								var template = '';
								if (results['hourly_rates_button']) {
									template = template + results['hourly_rates_button'];
								}
								if (results['hourly_products_button']) {
									template = template + results['hourly_products_button'];
								}
								if (results['monthly_rates_button']) {
									template = template + results['monthly_rates_button'];
								}
								if (results['monthly_products_button']) {
									template = template + results['monthly_products_button'];
								}
								if (results['monthly_external_button']) {
									template = template + results['monthly_external_button'];
								}
								if (results['coupon_products_button']) {
									template = template + results['coupon_products_button'];
								}
								$('ul', menu).prepend(template);
							}
							$(menu).addClass('products-nav-is-loaded');
						},
						error: function(results) {
							console.log(results);
							$(menu).addClass('products-nav-is-loaded');
						}
					});				
				});
			});	
		});
	}

  /* Request account deletion button */
  $('#request-account-deletion').on('click', function (e) {
    e.preventDefault();

    var button = $(this);
    $(button).prop('disabled', true);

    var name = $(this).attr('data-name');
    var email_address = $(this).attr('data-email-address');
    var time = moment().format('dddd, MMMM Do YYYY, h:mm:ss a');

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'request_account_deletion',
        name: name,
        email_address: email_address,
        time: time
      },
      success: function (results) {
        var results = JSON.parse(results);
        console.log(results);
        if (results.status === 'success') {
          $(button).hide();
          $(button).next('.form-card-message').empty().removeClass('form-card-message-error').text(results.message);
        } else {
          $(button).next('.form-card-message').empty().removeClass('form-card-message-error').addClass('form-card-message-error').text(results.message);
        }
        $(button).prop('disabled', false);
      },
      error: function (results) {
        console.log(results);
        $(button).next('.form-card-message').empty().removeClass('form-card-message-error').addClass('form-card-message-error').text('Uh oh, something went wrong. Try again?');
        $(button).prop('disabled', false);
      }
    });
  });

  /* open/close mobile nav */
  $('#mobile-nav-trigger').click(function () {
    var pixels_from_top = $(window).scrollTop();
    $('.mobile-nav').css('top', pixels_from_top + 'px');
    console.log('scrolled:', pixels_from_top);
    $('body').toggleClass('mobile-nav-active');
    var aria_label = 'Close main menu';
    var aria_expanded = 'true';    
    if (!$('body').hasClass('mobile-nav-active')) {
      // mobile menu is closed
      var aria_label = 'Open main menu';
      var aria_expanded = 'false';  
    }
    $(this).attr({
      'aria-label': aria_label,
      'aria-expanded': aria_expanded
    });
  });

  /* custom map markers */
  customMarker.prototype = new google.maps.OverlayView();

  customMarker.prototype.draw = function () {
    var thisMarker = this;
    var div = this.div;
    if (!div) {
      div = this.div = document.createElement('div');
      if (this.price == 'NA') {
        div.className = 'marker marker-alt';
      } else {
        div.className = 'marker';
      }

      if (this.city && this.state) {
        div.classList.add('marker-' + this.city + '-' + this.state);
      }
      if (this.focusedPin) div.classList.add('marker-pin-focus');

      var facilityId = document.createAttribute('data-facility-id');
      facilityId.value = this.id;
      div.setAttributeNode(facilityId);
      if (this.price == 'NA') {
        div.textContent = '';
      } else {
        div.textContent = '$' + Math.round(this.price);
      }

      // open facility modal on click
      google.maps.event.addDomListener(div, 'click', function (event) {
        google.maps.event.trigger(thisMarker, 'click');
        var facilityId = $(this).attr('data-facility-id');
        facilityModal(facilityId);
      });

      // highlight facility in sidebar on hover
      google.maps.event.addDomListener(div, 'mouseover', function (event) {
        var facilityId = $(this).attr('data-facility-id');
        $('#' + facilityId).addClass('result-active');
      });
      google.maps.event.addDomListener(div, 'mouseout', function (event) {
        var facilityId = $(this).attr('data-facility-id');
        $('#' + facilityId).removeClass('result-active');
      });

      var panes = this.getPanes();
      panes.floatPane.appendChild(div);
    }

    var position = this.getProjection().fromLatLngToDivPixel(this.latlng);
    if (position) {
      div.style.left = position.x + 'px';
      div.style.top = position.y + 'px';
    }
  };

  customMarker.prototype.remove = function () {
    if (this.div) {
      this.div.parentNode.removeChild(this.div);
      this.div = null;
    }
  };

  customMarker.prototype.getPosition = function () {
    return this.latlng;
  };

  /* toggle between map and list views */
  $('#map-list-trigger').click(function () {
    if ($('body').hasClass('search-map-active')) {
      // if map view is visible, show list view
      $('body').removeClass('search-map-active').addClass('search-list-active');
      var aria_label = 'Show map view';
    } else if ($('body').hasClass('search-list-active')) {
      // if list view is visible, show map view
      $('body').removeClass('search-list-active').addClass('search-map-active');
      var aria_label = 'Show list view';
    }
    $(this).attr({
      'aria-label': aria_label
    });
  });

  /* trigger search toolbar on mobile */
  $('#search-toolbar-trigger').click(function (e) {
    e.preventDefault();
    $('body').addClass('search-toolbar-active');
  });

  $('#search-toolbar-close').click(function (e) {
    e.preventDefault();
    $('body').removeClass('search-toolbar-active');
  });

  /* search toolbar - hourly/monthly parking toggle */
  $('#update-search input[name="parking-type"]').change(function () {
    var parkingType = this.value;

    // toggle data-cy attributes
    var options = $('#update-search input[name="parking-type"]');
    $(options).each(function (index, option) {
      var data_cy_inactive_string = $(option).attr('data-cy-inactive-string');
      $(option).attr('data-cy', data_cy_inactive_string);
    });
    var data_cy_active_string = $(this).attr('data-cy-active-string');
    $(this).attr('data-cy', data_cy_active_string);

    $('.search-toolbar')
      .toggleClass('hourly-parking', parkingType === 'hourly')
      .toggleClass('monthly-parking', parkingType === 'monthly');

    // Use the Apply flow so both searches share date validation and request fields.
    $('#update-search').trigger('submit');
  });

  /* trigger filter toolbar */
  $('#filter-toolbar-trigger').click(function (e) {
    e.preventDefault();
    $('body').toggleClass('filter-toolbar-active');
  });

  $('#filter-toolbar-close').click(function (e) {
    e.preventDefault();
    $('body').removeClass('filter-toolbar-active');
  });

  /* display value on input["range"] elements */
  $('.toolbar-input-range').each(function () {
    var rangeInput = $('input[type="range"]', this);
    var rangeValue = $('.toolbar-input-range-value', this);
    $(rangeInput).on('input change', function () {
      $(rangeValue).html($(this).val());
    });
  });

  /* show/hide password in registration fields */
  $('#show-password').change(function () {
    if ($(this).is(':checked')) {
      var input = $(this).closest('.form-field').find('input[type="password"]');
      input.attr('type', 'text');
    } else {
      var input = $(this).closest('.form-field').find('input[type="text"]');
      input.attr('type', 'password');
    }
  });

  /* registration form functionality */
  $('#registration-form').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
      error.attr('data-cy', `${error[0].id}-text`);
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    rules: {
      'create-first-name': {
        required: true,
        minlength: 2
      },
      'create-last-name': {
        required: true,
        minlength: 2
      },
      'create-email': {
        required: true,
        email: true
      },
      'create-email-match': {
        email: true,
        equalTo: '#create-email'
      },
      'create-password': {
        required: true,
        minlength: 8,
        maxlength: 99
      },
      'create-password-match': {
        minlength: 8,
        maxlength: 99,
        equalTo: '#create-password'
      }
    },
    messages: {
      'create-first-name': {
        required: 'Please enter your first name.',
        minlength: 'Your first name must be at least 2 characters long.'
      },
      'create-last-name': {
        required: 'Please enter your last name.',
        minlength: 'Your last name must be at least 2 characters long.'
      },
      'create-email': {
        required: 'Please enter your email address.',
        email: 'Please enter a valid email address.'
      },
      'create-email-match': {
        email: 'Please enter a valid email address.',
        equalTo: 'Your email address does not match the previous field.'
      },
      'create-password': {
        required: 'Please provide a password.',
        minlength: 'Your password must be at least 8 characters long.',
        maxlength: 'Your password must be 64 characters or less.'
      },
      'create-password-match': {
        minlength: 'Your password must be at least 8 characters long.',
        maxlength: 'Your password must be 64 characters or less.',
        equalTo: 'Your password does not match the previous field.'
      }
    },
    submitHandler: function (form) {

      $('.button-spinner', form).prop('disabled', true);

      grecaptcha.ready(function() {
        grecaptcha.execute(recaptcha_site_key, { action: 'create_account' }).then(function(token) {
          var redirectUrl = $(form).attr('data-redirect-url');
          var firstName = $('#create-first-name').val();
          var lastName = $('#create-last-name').val();
          var email = $('#create-email').val();
          var username = $('#create-email').val();
          var password = $('#create-password').val();
          var siteId = $('#site-id').val();
          var nonce = $('#chirp-new-user-nonce').val();
          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'register_user',
              redirectUrl: redirectUrl,
              firstName: firstName,
              lastName: lastName,
              email: email,
              username: username,
              password: password,
              siteId: siteId,
              recaptchaToken: token,
              nonce: nonce
            },
            success: function (results) {
              var results = $.parseJSON(results);
              console.log(results);
              if (results.status === 'success') {
                console.log(results.redirectUrl);
                $('.form-card-message').removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
                setTimeout(function () {
                  if (results.redirectUrl == 'reload') {
                    location.reload();
                  } else {
                    window.location.href = redirectUrl;
                  }
                }, 1000);
              } else if (results.status === 'error') {
                $('.button-spinner', form).prop('disabled', false);
                $('.form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
              } else {
                $('.button-spinner', form).prop('disabled', false);
                $('.form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('Oops, something went wrong. Please try again?');
              }
            },
            error: function (results) {
              var results = $.parseJSON(results);
              console.log(results);
              $('.button-spinner', form).prop('disabled', false);
              $('.form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('Oops, something went wrong. Please try again?');
            }
          });
        });
      });
    }
  });

  /* account settings: update profile form */
  $('#update-profile').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
      error.attr('data-cy', `${error[0].id}-text`);
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    rules: {
      'first-name': {
        required: true,
        minlength: 2
      },
      'last-name': {
        required: true,
        minlength: 2
      },
      'phone-number': {
        // required: true,
        phoneUS: true
      },
      'street-address': {
        // required: true,
        minlength: 2
      },
      'city': {
        // required: true,
        minlength: 2
      },
      'zip-code': {
        // required: true,
        zipcodeUS: true
      }
    },
    messages: {
      'first-name': {
        required: 'Please enter your first name.',
        minlength: 'Your first name must be at least 2 characters long.'
      },
      'last-name': {
        required: 'Please enter your last name.',
        minlength: 'Your last name must be at least 2 characters long.'
      },
      'phone-number': {
        // required: 'Please enter your phone number.',
        phoneUS: 'Please enter a valid phone number.'
      },
      'street-address': {
        // required: 'Please enter your street address',
        minlength: 'Please enter a valid street address.'
      },
      'city': {
        // required: 'Please enter your city.',
        minlength: 'Please enter a valid city name.'
      },
      'zip-code': {
        // required: 'Please enter your zip code.',
        zipcodeUS: 'Please enter a valid zip code.'
      }
    },
    submitHandler: function (form) {

      $('.button-spinner', form).prop('disabled', true);

      var userId = $('#user-id').val();
      var firstName = $('#first-name').val();
      var lastName = $('#last-name').val();

      var phoneNumber = $('#phone-number').val();
      var streetAddress = $('#street-address').val();
      var city = $('#city').val();
      var state = $('#state').val();
      var zipCode = $('#zip-code').val();

      var licensePlates = [];
      $('input[name="license-plates"]').each(function () {
        if ($(this).val()) {
          var plate = $(this).val();
          licensePlates.push(plate);
        }
      });

      console.log(licensePlates);

      var nonce = $('#chirp-update-profile-nonce').val();

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'update_profile',
          userId: userId,
          firstName: firstName,
          lastName: lastName,
          streetAddress: streetAddress,
          city: city,
          state: state,
          zipCode: zipCode,
          phoneNumber: phoneNumber,
          licensePlates: licensePlates,
          nonce: nonce
        },
        success: function (results) {
          var results = JSON.parse(results);
          console.log(results);
          $('.button-spinner', form).prop('disabled', false);
          if (results.updated == true) {
            $('.form-card-message', form).addClass('form-card-message-success').text(results.message).attr("data-cy", "form-success-text");
          } else {
            $('.form-card-message', form).addClass('form-card-message-error').text(results.message);
          }
        },
        error: function (results) {
          var results = JSON.parse(results);
          console.log(results);
          $('.button-spinner', form).prop('disabled', false);
        }
      });

    }
  });

  /* account settings: delete payment form */
  $('#delete-credit-cards, #delete-bank-accounts').submit(function (e) {
    e.preventDefault();

    $('.button-spinner', this).prop('disabled', true);

    var customerId = $('#customer-id').val();
    var nonce = $('#chirp-delete-payment-nonce').val();
    var sources = [];
    $('input[type="checkbox"]:checked', this).each(function () {
      var thisSourceId = $(this).val();
      sources.push(thisSourceId);
    });

    if (sources.length > 0) {

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'delete_payment',
          customerId: customerId,
          sources: sources,
          nonce: nonce
        },
        success: function (results) {
          console.log('success!', results);
          $('.button-spinner', this).prop('disabled', false);
          location.reload();
        },
        error: function (results) {
          console.log('error!', results);
          $('.button-spinner', this).prop('disabled', false);
        }
      });

    } else {

      $('.button-spinner', this).prop('disabled', false);
      $(this).siblings('.form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Please select a source to delete.');

    }

  });

  /* icon rewards enrollment */
  $('#icon-rewards-enrollment').submit(function (e) {
    e.preventDefault();

    var form = this;
    $('.button-spinner', form).prop('disabled', true);

    var nonce = $('#icon-rewards-enrollment-nonce').val();

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'icon_rewards_enroll',
        nonce: nonce
      },
      success: function (results) {
        var results = JSON.parse(results);
        if (results.status === 'success') {
          location.reload();
        } else {
          $('.button-spinner', form).prop('disabled', false);
          $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
        }
      },
      error: function () {
        $('.button-spinner', form).prop('disabled', false);
        $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong. Please try again.');
      }
    });
  });

  if ($('body').hasClass('page-template-page-account-monthly-icon-rewards')) {
    if ($('.receipt-barcode').length > 0) {
      $('.receipt-barcode').each(function () {
        var thisBarcode = $(this);
        var thisBarcodeString = $(thisBarcode).attr('data-barcode-string');
        var thisBarcodeSize = $(thisBarcode).attr('data-barcode-size');
        new QRCode(this, {
          text: thisBarcodeString,
          width: thisBarcodeSize,
          height: thisBarcodeSize,
          colorDark: '#000000',
          colorLight: '#FFFFFF',
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    }
  }

  /* request refund from transaction history */
  $('.transaction-refund').click(function (e) {
    e.preventDefault();
    var transactionId = $(this).attr('data-transaction-id');
    var facilityId = $(this).attr('data-facility-id');
    var thisTransaction = $(this).parents('.transaction');

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'request_refund',
        transactionId: transactionId,
        facilityId: facilityId
      },
      success: function (results) {
        var results = JSON.parse(results);
        console.log(results);
        if (results.status == 'success') {

          $('.transaction-refund[data-transaction-id="' + transactionId + '"]').hide();
          $('.transaction-change-license[data-transaction-id="' + transactionId + '"]').hide();
          $(thisTransaction).addClass('transaction-refunded');
          console.log('Success!', results.message);

        } else {

          console.log('Error:', results.message);

        }
      },
      error: function (results) {
        // var results = JSON.parse(results);
        console.log(results);
      }
    });
  });

  /* toggle search results list */
  $('#search-results-trigger').click(function (e) {
    e.preventDefault();
    $('.search-grid').toggleClass('search-results-hidden');
  });

  /* toggle search panel (seo content) */
  $('#search-panel-trigger').click(function (e) {
    e.preventDefault();
    $('.search-grid').toggleClass('search-panel-hidden');
  });

  /* home page functionality */
  if ($('body').hasClass('page-template-page-home')) {

    // get local timezone
    var today = new Date();
    var timezoneOffset = today.getTimezoneOffset();
    var offset = (timezoneOffset * 60) * -1;
    $('#address').attr('data-offset', offset);

    autocomplete();
    initialSearchForm();
  }

  /* 404 page functionality */
  if ($('body').hasClass('error404')) {
    autocomplete();
    initialSearchForm();
  }

  /* single city page functionality */
  if ($('body').hasClass('single-cities')) {
    autocomplete();
    initialSearchForm();
  }

  /* single location page functionality */
  if ($('body').hasClass('single-locations') || $('body').hasClass('page-template-page-special-event')) {

    var lat = $('#map').attr('data-latitude');
    var lng = $('#map').attr('data-longitude');

    searchMap(lat, lng, 'map');
    autocomplete();
    searchResultsList();
    sortSearchResults();
    updateSearchForm();

  }

  /* search page functionality */
  if ($('body').hasClass('page-template-page-search') || $('body').hasClass('page-template-page-pw-search')) {
    var behavior = $('#default-behavior').val();
    var pinTarget = getZonePinTarget();
    if (pinTarget && behavior !== 'search-results') {
      initializeZonePinNavigation(pinTarget);
    } else if (behavior === 'geolocate') {

      $('.site-content-overlay').addClass('site-content-overlay-active');
      $('.site-content-overlay-text').empty().text('Finding your location...');

      if ('geolocation' in navigator) {

        var geoOptions = {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 60000
        }

        navigator.geolocation.getCurrentPosition(geoSuccess, geoError, geoOptions);

        function geoSuccess(position) {
          console.log(position);

          var showAllFacilities = 'false';
          if ($('#show-all-facilities').length) {
            var showAllFacilities = $('#show-all-facilities').val();
          }
          var parkingType = $('input[name="parking-type"]:checked').val();
          var address = '';
          var latitude = position.coords.latitude;
          var longitude = position.coords.longitude;
          // var latitude = parseFloat(position.coords.latitude);
          // var longitude = parseFloat(position.coords.longitude);
          // var latitude = 27.95661879999999;
          // var longitude = -82.524525;

          var amenities = [];
          $.each($('input[name="amenities"]:checked'), function () {
            amenities.push($(this).val());
          });
          var maxPrice = $('#max-price').val();

          // get the date and time right now
          var start_moment = moment();
          // round minutes down to the nearest 30 minutes interval
          if (start_moment.minutes() < 30) {
            // minutes less than 30, round down to 0
            start_moment.minutes(0);
          } else {
            // minutes 30 or more, round down to 30
            start_moment.minutes(30);
          }
          // reset seconds to zero just to make it nice and clean
          start_moment.seconds(0);
          // add three hours to create the end date and time
          var end_moment = moment(start_moment).add(3, 'hours');

          // format start and end dates and times
          var startDate = start_moment.format('YYYY-MM-DD');
          var startTime = start_moment.format('HH:mm');
          var endDate = end_moment.format('YYYY-MM-DD');
          var endTime = end_moment.format('HH:mm');
          // get the timezone offset and format correctly
          var offset = start_moment.utcOffset() * 60;
          // use moment to find the timezone
          var timezone = moment.tz.guess();

          // set form elements to generated times
          $('#start-date').val(startDate);
          $('#start-time').val(startTime);
          $('#end-date').val(endDate);
          $('#end-time').val(endTime);
          $('#mobile-start-date').text(start_moment.format('MMM D'));
          $('#mobile-start-time').text(start_moment.format('H:mma'));
          $('#mobile-end-date').text(end_moment.format('MMM D'));
          $('#mobile-end-time').text(end_moment.format('H:mma'));
          $('#start-date-monthly').val(startDate);
          $('#now-date-time').val(start_moment.utc().unix());
          $('#timezone').val(timezone);
          $('#offset').val(offset);
          $('#address').attr({ 'data-latitude': latitude, 'data-longitude': longitude, 'data-offset': offset });

          if (parkingType == 'hourly') {

            var startDateTime = new Date(startDate + 'T' + startTime).getTime() / 1000;
            var endDateTime = new Date(endDate + 'T' + endTime).getTime() / 1000;

            $.ajax({
              type: 'post',
              url: '/wp-admin/admin-ajax.php',
              data: {
                action: 'hourly_parking_query',
                showAllFacilities: showAllFacilities,
                parkingType: parkingType,
                address: address,
                lat: latitude,
                lng: longitude,
                amenities: amenities,
                maxPrice: maxPrice,
                timezone: timezone,
                offset: offset,
                startDateTime: startDateTime,
                endDateTime: endDateTime,
                startDate: startDate,
                startTime: startTime,
                endDate: endDate,
                endTime: endTime,
              },
              success: function (results) {
                var results = JSON.parse(results);
                console.log(results);

                if (results.status == 'success') {

                  $('.site-content-overlay').removeClass('site-content-overlay-active');
                  $('.search-results-list').empty().append(results.template);

                  // get current url and parameters
                  var url = new URL(window.location);

                  // update parameters based on search query
                  url.searchParams.set('type', parkingType);
                  url.searchParams.set('startDate', startDate);
                  url.searchParams.set('startTime', startTime);
                  url.searchParams.set('endDate', endDate);
                  url.searchParams.set('endTime', endTime);
                  url.searchParams.set('lat', lat);
                  url.searchParams.set('lng', lng);
                  url.searchParams.set('address', encodeURIComponent(address));
                  url.searchParams.set('offset', offset);

                  // update url with new parameters
                  window.history.replaceState({}, '', url.origin + url.pathname + url.search);

                  // window.history.replaceState({}, '', '/search/?type=hourly&lat=' + latitude + '&lng=' + longitude + '&offset=' + offset + '');

                  UpdateMobileMapTime(results.startDateTime, results.endDateTime);
                  searchResultsList();
                  searchMap(latitude, longitude, 'map');
                  autocomplete();
                  updateSearchForm();
                  sortSearchResults();
                  $('input[name="max-price"]').attr('disabled', false);

                  /*** highlight pin when hovering on result listing ***/
                  $('.result').hover(function () {
                    var thisFacility = $(this).attr('id');
                    $('.marker[data-facility-id="' + thisFacility + '"]').addClass('marker-active');
                  }, function () {
                    var thisFacility = $(this).attr('id');
                    $('.marker[data-facility-id="' + thisFacility + '"]').removeClass('marker-active');
                  });

                  UpdateMobileMapTime(results.startDateTime, results.endDateTime);

                } else {

                  $('.site-content-overlay').removeClass('site-content-overlay-active');
                  $('.search-results-list').empty().append(results.template);

                  // get current url and parameters
                  var url = new URL(window.location);

                  // update parameters based on search query
                  url.searchParams.set('type', parkingType);
                  url.searchParams.set('startDate', startDate);
                  url.searchParams.set('startTime', startTime);
                  url.searchParams.set('endDate', endDate);
                  url.searchParams.set('endTime', endTime);
                  url.searchParams.set('lat', latitude);
                  url.searchParams.set('lng', longitude);
                  url.searchParams.set('address', encodeURIComponent(address));
                  url.searchParams.set('offset', offset);

                  // update url with new parameters
                  window.history.replaceState({}, '', url.origin + url.pathname + url.search);

                  // window.history.replaceState({}, '', '/search/?type=hourly&lat=' + latitude + '&lng=' + longitude + '&offset=' + offset + '');

                  searchResultsList();
                  searchMap(latitude, longitude, 'map');
                  $('#map').attr('data-latitude', latitude).attr('data-longitude', longitude);
                  autocomplete();
                  updateSearchForm();
                  sortSearchResults();
                  $('input[name="max-price"]').attr('disabled', false);
                  // launchAlert('Sorry!', results.message);

                }

              },
              error: function (results) {
                var results = JSON.parse(results);
                console.log(results);
                launchAlert('Error!', 'Uh oh, something is broken.');
              }
            });

          } else if (parkingType == 'monthly') {

            var spotType = $('#spot-type').val();
            var accessHours = $('#access-hours').val();
            startTime = '23:59';
            let cookieDomain = window.location.hostname;
            let isSecure = window.location.protocol === 'https:';
            let cookieString = `startDate=${startDate}; path=/; domain=.${cookieDomain};`;
            if (isSecure) {
              cookieString += ' Secure; SameSite=None;';
            }
            document.cookie = cookieString;
            var startDateTime = new Date(startDate + 'T' + startTime).getTime() / 1000;

            $.ajax({
              type: 'post',
              url: '/wp-admin/admin-ajax.php',
              data: {
                action: 'monthly_parking_query',
                showAllFacilities: showAllFacilities,
                parkingType: parkingType,
                address: address,
                lat: latitude,
                lng: longitude,
                amenities: amenities,
                maxPrice: maxPrice,
                timezone: timezone,
                offset: offset,
                startDateTime: startDateTime
              },
              success: function (results) {
                var results = JSON.parse(results);
                console.log(results);

                if (results.status == 'success') {

                  $('.site-content-overlay').removeClass('site-content-overlay-active');
                  $('.search-results-list').empty().append(results.template);

                  // get current url and parameters
                  var url = new URL(window.location);

                  // update parameters based on search query
                  url.searchParams.set('type', parkingType);
                  url.searchParams.set('startDate', startDate);
                  url.searchParams.set('startTime', startTime);
                  url.searchParams.set('endDate', endDate);
                  url.searchParams.set('endTime', endTime);
                  url.searchParams.set('lat', latitude);
                  url.searchParams.set('lng', longitude);
                  url.searchParams.set('address', encodeURIComponent(address));
                  url.searchParams.set('offset', offset);

                  // update url with new parameters
                  window.history.replaceState({}, '', url.origin + url.pathname + url.search);

                  // window.history.replaceState({}, '', '/search/?type=monthly&lat=' + latitude + '&lng=' + longitude + '&offset=' + offset + '');

                  searchResultsList();
                  searchMap(latitude, longitude, 'map');
                  autocomplete();
                  updateSearchForm();
                  $('input[name="max-price"]').attr('disabled', true);

                  /*** highlight pin when hovering on result listing ***/
                  $('.result').hover(function () {
                    var thisFacility = $(this).attr('id');
                    $('.marker[data-facility-id="' + thisFacility + '"]').addClass('marker-active');
                  }, function () {
                    var thisFacility = $(this).attr('id');
                    $('.marker[data-facility-id="' + thisFacility + '"]').removeClass('marker-active');
                  });

                  // update date and times in mobile view button
                  var startDateTimeObject = new Date((results.startDateTime * 1000) + (offset * 1000));
                  var nowDateTimeObject = new Date();

                  var startDateMonth = startDateTimeObject.getMonth() + 1;
                  var startDateDate = startDateTimeObject.getDate();
                  var startDateYear = startDateTimeObject.getFullYear();
                  var startTimeHours = startDateTimeObject.getHours() > 12 ? startDateTimeObject.getHours() - 12 : startDateTimeObject.getHours();
                  var startTimeMinutes = (startDateTimeObject.getMinutes() < 10 ? '0' : '') + startDateTimeObject.getMinutes();
                  var startTimeAmPm = (startDateTimeObject.getHours() > 11) ? 'pm' : 'am';

                  var nowDateMonth = nowDateTimeObject.getMonth() + 1;
                  var nowDateDate = nowDateTimeObject.getDate();
                  var nowDateYear = nowDateTimeObject.getFullYear();

                  function mobileMonthFormat(month) {
                    if (month == 1) {
                      return 'Jan';
                    } else if (month == 2) {
                      return 'Feb';
                    } else if (month == 3) {
                      return 'Mar';
                    } else if (month == 4) {
                      return 'Apr';
                    } else if (month == 5) {
                      return 'May';
                    } else if (month == 6) {
                      return 'Jun';
                    } else if (month == 7) {
                      return 'Jul';
                    } else if (month == 8) {
                      return 'Aug';
                    } else if (month == 9) {
                      return 'Sep';
                    } else if (month == 10) {
                      return 'Oct';
                    } else if (month == 11) {
                      return 'Nov';
                    } else if (month == 12) {
                      return 'Dec';
                    }
                  }

                  var startDateString = startDateYear + '-' + startDateMonth + '-' + startDateDate;
                  var startTimeString = startTimeHours + ':' + startTimeMinutes + '' + startTimeAmPm;
                  var startDateStringDisplay = mobileMonthFormat(startDateMonth) + ' ' + startDateDate;

                  var nowDateString = nowDateYear + '-' + nowDateMonth + '-' + nowDateDate;

                  if (startDateString == nowDateString) {
                    $('.search-toolbar-button-datetime-start .search-toolbar-button-date').empty().text('Today');
                  } else {
                    $('.search-toolbar-button-datetime-start .search-toolbar-button-date').empty().text(startDateStringDisplay);
                  }

                  $('.search-toolbar-button-datetime-start .search-toolbar-button-time').empty().text(startTimeString);

                } else {

                  launchAlert('Sorry!', results.message);

                }

              },
              error: function (results) {
                var results = JSON.parse(results);
                console.log(results);
                launchAlert('Error!', 'Uh oh, something is broken.');
              }
            });

          }

        }

        function geoError(error) {
          console.log(error);
          autocomplete();
          updateSearchForm();

          if (error.code == 1) {

            // permission denied
            launchAlert('Error', 'Please enable location services on your device and try again.');

          } else if (error.code == 2) {

            // position unavailable
            launchAlert('Error', 'Sorry, we were unable to find your location. Please try again.');

          } else if (error.code == 3) {

            // timeout
            launchAlert('Error', 'Geolocation timed out. Please try again.');

          } else {

            launchAlert('Error', error.message);

          }

        }

      } else {

        launchAlert('Sorry!', 'Your browser doesn\'t support geolocation.');

      }

    } else if (behavior === 'show-all-facilities') {

      var startDateTime = $('#start-date-time').val();
      var centerType = $('#center-type').val();
      var centerLat = $('#center-location-lat').val();
      var centerLng = $('#center-location-lng').val();
      var zoom = $('#center-location-zoom').val();

      if (startDateTime === '0') {

        $('.site-content-overlay').addClass('site-content-overlay-active');
        $('.site-content-overlay-text').empty().text('Loading...');

        // get current date and time, rounded to nearest 30 minutes
        var date = new Date();
        var startDate = GetDateStr(date);
        var startTime = GetTimeNearest30(date);

        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_get_date_and_show_all_facilities',
            startDate: startDate,
            startTime: startTime,
            centerType: centerType,
            centerLat: centerLat,
            centerLng: centerLng,
            zoom: zoom
          },
          success: function (results) {
            var results = JSON.parse(results);
            console.log(results);
            if (results.status === 'success') {

              $('#start-date').val(results.startDate);
              $('#start-time').val(results.startTime);
              $('#end-date').val(results.endDate);
              $('#end-time').val(results.endTime);

              $('.search-results-list').append(results.template);
              UpdateMobileMapTime(results.startDateTime, results.endDateTime);
              searchResultsList();
              allFacilitiesMap('map', centerType, centerLat, centerLng, zoom);
              autocomplete();
              updateSearchForm();
              sortSearchResults();
              /*** highlight pin when hovering on result listing ***/
              $('.result').hover(function () {
                var thisFacility = $(this).attr('id');
                $('.marker[data-facility-id="' + thisFacility + '"]').addClass('marker-active');
              }, function () {
                var thisFacility = $(this).attr('id');
                $('.marker[data-facility-id="' + thisFacility + '"]').removeClass('marker-active');
              });

              $('.site-content-overlay').removeClass('site-content-overlay-active');
              $('.site-content-overlay-text').empty();

            }
          },
          error: function (results) {
            // var results = JSON.parse(results);
            console.log(results);
            $('.site-content-overlay').removeClass('site-content-overlay-active');
            $('.site-content-overlay-text').empty()
          }
        });

      } else {
        allFacilitiesMap('map', centerType);
      }

    } else if (behavior === 'search-results') {

      var lat = $('#map').attr('data-latitude');
      var lng = $('#map').attr('data-longitude');

      searchMap(lat, lng, 'map');
      autocomplete();
      searchResultsList();
      sortSearchResults();
      updateSearchForm();

    }
  }

  /*** highlight pin when hovering on result listing ***/
  $('.result').hover(function () {
    var thisFacility = $(this).attr('id');
    $('.marker[data-facility-id="' + thisFacility + '"]').addClass('marker-active');
  }, function () {
    var thisFacility = $(this).attr('id');
    $('.marker[data-facility-id="' + thisFacility + '"]').removeClass('marker-active');
  });

  /* facility/checkout page functionality */

  /*** license plate repeater fields ***/

  $('.repeater').each(function () {
    var thisRepeater = $(this);

    // add a row
    $('.repeater-row-add', thisRepeater).click(function (e) {
      e.preventDefault();

      var rowNumbers = [];
      if ($('.repeater-row', thisRepeater).length) {
        $('.repeater-row', thisRepeater).each(function () {
          var rowNumber = $(this).attr('data-row-number');
          rowNumbers.push(rowNumber);
        });
        var newRowNumber = Math.max.apply(Math, rowNumbers) + 1;
      } else {
        var newRowNumber = 0;
      }

      $('.repeater-rows-group').append('<div class="form-field form-field-group repeater-row" data-row-number="' + newRowNumber + '"><div class="form-field"><label class="form-field-label visually-hidden" for="plate-' + newRowNumber + '">License Plate</label><input type="text" name="license-plates" id="plate-' + newRowNumber + '" /></div><button class="delete-button repeater-row-delete">Delete This Row</button></div>');
    });

    // delete a row
    $(document).on('click', '.repeater-row-delete', function (e) {
      e.preventDefault();
      $(this).parents('.repeater-row').remove();
    });

  });

  /*** stripe stuff ***/

  if ($('body').hasClass('single-facilities')) {

    var map = $('#map');
    if (map.length > 0) {
      var lat = $('#map').attr('data-latitude');
      var lng = $('#map').attr('data-longitude');
      if (lat.length > 0 && lng.length > 0) {
        simpleMap(lat, lng, 'map');
      }
    }

    facilityPhotos();

    var checkout = getUrlParameter('checkout');
    if (checkout == 'true') {

      var type = getUrlParameter('type');
      var expectedPrice = getUrlParameter('expectedPrice');
      var promoCode = getUrlParameter('promoCode');

      // $('#checkout-submit').prop('disabled', false);
      newLicensePlateField();
      basicTabs();

      // promo code apply button
      $('#apply-promo-code').click(function (e) {
        e.preventDefault();

        // show loading animation
        $('#reservation-summary .card-content-overlay').addClass('card-content-overlay-active');

        if (type == 'hourly') {

          // get variables
          var facilityId = $('#facility-id').val();
          var startDate = $('#start-date').val();
          var startTime = $('#start-time').val();
          var endDate = $('#end-date').val();
          var endTime = $('#end-time').val();
          var offset = Number($('#offset').val());
          var promoCode = $('#promo-code').val();

          console.log('startDate:', startDate, 'startTime:', startTime);
          console.log('endDate:', endDate, 'endTime:', endTime);

          if (offset == 0) {

            var offsetISO8601 = '+00:00';

          } else {

            var offsetWIP = ((offset / 60) / 60) * 100;
            var offsetHours = offsetWIP.toString().slice(0, -2);
            var isNegative = offsetHours.indexOf('-');
            if (isNegative == 0) {
              if (offsetHours.length < 3) {
                offsetHours = offsetHours.substring(1);
                offsetHours = '-0' + offsetHours;
              }
            } else {
              if (offsetHours.length < 2) {
                offsetHours = '+0' + offsetHours;
              } else {
                offsetHours = '+' + offsetHours;
              }
            }
            var offsetMinutes = offsetWIP.toString().slice(-2);
            var offsetISO8601 = offsetHours + ':' + offsetMinutes;

          }

          offsetISO8601 = '+00:00';
          console.log('offsetISO8601:', offsetISO8601);

          // convert dates and times to unix epoch format
          var startDateTime = new Date(startDate + 'T' + startTime + offsetISO8601).getTime() / 1000;
          var endDateTime = new Date(endDate + 'T' + endTime + offsetISO8601).getTime() / 1000;
          var nowDateTime = GetUTCNow();

          console.log('startDateTime:', startDateTime);
          console.log('endDateTime:', endDateTime);
          console.log('nowDateTime:', nowDateTime);

          if (startDateTime < (nowDateTime - (60 * 40))) {

            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('Start date/time is in the past.');

          } else if (endDateTime < nowDateTime) {

            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('End date/time is in the past.');

          } else if (startDateTime >= endDateTime) {

            // startDateTime is greater than or equal to endDateTime
            var difference = startDateTime - endDateTime;
            // console.log(difference);
            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('End date/time is earlier than start date/time.');

          } else {

            $('#submit-gpi').css("display", "block")
            // endDateTime is greater than startDateTime, proceed!
            $('#reservation-summary .form-card-message').removeClass('form-card-message-error').empty();

            $.ajax({
              type: 'post',
              url: '/wp-admin/admin-ajax.php',
              data: {
                action: 'calculate_hourly_price',
                facilityId: facilityId,
                startDateTime: startDateTime,
                endDateTime: endDateTime,
                nowDateTime: nowDateTime,
                promoCode: promoCode
              },
              success: function (results) {
                var results = JSON.parse(results);
                console.log(results);
                if (results.status == 'success') {

                  // enable checkout (if disabled) on success
                  $('#secure-payment-field').prop('disabled', false);
                  // update hidden price field in pennies
                  $('#price').val(results['new_price']);
                  // update display price field in dollars
                  $('#display-price').text(results['new_display_price']);
                  $('#reservation-summary .form-card-message').removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

                  console.log('TicketType:', results.body.ticket_items[0].type);

                  // add new startDateTime, endDateTime, and promoCode to the URL
                  var url = new URL(window.location);
                  url.searchParams.set('startTime', results.startDateTime);
                  url.searchParams.set('endTime', results.endDateTime);
                  url.searchParams.set('expectedPrice', results.new_price);
                  if (results.promoCode != '') {
                    url.searchParams.set('promoCode', results.promoCode);
                  }
                  history.pushState('', '', url);

                } else {

                  $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
                  // disable checkout on error
                  $('#checkout-submit').prop('disabled', true);

                }
                // hide loading animation
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
              },
              error: function (results) {
                var results = JSON.parse(results);
                console.log(results);
                // hide loading animation
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
              }
            });

          }

        } else if (type == 'monthly' || type == 'coupon') {

          var facilityId = $('#facility-id').val();
          var promoCode = $('#promo-code').val();
          if (type == 'monthly') {
            var parkingType = 'monthly';
          } else if (type == 'coupon') {
            var parkingType = 'coupon';
          }

          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'calculate_product_price',
              facilityId: facilityId,
              parkingType: parkingType,
              promoCode: promoCode
            },
            success: function (results) {
              var results = JSON.parse(results);
              console.log(results);

              if (results.status == 'success') {

                // remove default options, replace with promo code product
                $('#reservation-summary .radio-buttons-group').empty().append(results.productTemplate);
                // update price to promo code price
                var displayPrice = results.productsArray[0].product_price;
                var stripePrice = displayPrice * 100;
                $('#display-price').text(displayPrice);
                $('#price').val(stripePrice);
                // remove loading overlay
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
                $('#reservation-summary .form-card-message').removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

                console.log('TicketType:', results.body.ticket_items[0].type);

                // add new startDateTime, endDateTime, and promoCode to the URL
                var url = new URL(window.location);
                if (results.promoCode != '') {
                  url.searchParams.set('promoCode', results.promoCode);
                }
                history.pushState('', '', url);

              } else {

                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
                $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);

              }

            },
            error: function (results) {
              var results = JSON.parse(results);
              console.log(results);
            }
          });

        }

      });

      if (type == 'hourly') {

        // if url is missing the `expectedPrice` parameter, run the ajax call to get a price
        if (expectedPrice == 0) {

          // show loading animation
          $('#reservation-summary .card-content-overlay').addClass('card-content-overlay-active');

          // get variables
          var facilityId = $('#facility-id').val();
          var startDate = $('#start-date').val();
          var startTime = $('#start-time').val();
          var endDate = $('#end-date').val();
          var endTime = $('#end-time').val();
          var offset = Number($('#offset').val());
          var promoCode = $('#promo-code').val();

          console.log('startDate:', startDate, 'startTime:', startTime);
          console.log('endDate:', endDate, 'endTime:', endTime);
          console.log('offset:', offset);

          if (offset == 0) {

            var offsetISO8601 = '+00:00';

          } else {

            var offsetWIP = ((offset / 60) / 60) * 100;
            var offsetHours = offsetWIP.toString().slice(0, -2);
            var isNegative = offsetHours.indexOf('-');
            if (isNegative == 0) {
              if (offsetHours.length < 3) {
                offsetHours = offsetHours.substring(1);
                offsetHours = '-0' + offsetHours;
              }
            } else {
              if (offsetHours.length < 2) {
                offsetHours = '+0' + offsetHours;
              } else {
                offsetHours = '+' + offsetHours;
              }
            }
            var offsetMinutes = offsetWIP.toString().slice(-2);
            var offsetISO8601 = offsetHours + ':' + offsetMinutes;

          }

          offsetISO8601 = '+00:00';
          console.log('offsetISO8601:', offsetISO8601);

          // convert dates and times to unix epoch format
          var startDateTime = new Date(startDate + 'T' + startTime + offsetISO8601).getTime() / 1000;
          var endDateTime = new Date(endDate + 'T' + endTime + offsetISO8601).getTime() / 1000;
          var nowDateTime = GetUTCNow();

          console.log('startDateTime:', startDateTime);
          console.log('endDateTime:', endDateTime);
          console.log('nowDateTime:', nowDateTime);

          if (startDateTime < (nowDateTime - (60 * 40))) {

            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('Start date/time is in the past.');

          } else if (endDateTime < nowDateTime) {

            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('End date/time is in the past.');

          } else if (startDateTime >= endDateTime) {

            // startDateTime is greater than or equal to endDateTime
            var difference = startDateTime - endDateTime;
            // console.log(difference);
            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('End date/time is earlier than start date/time.');

          } else {

            $('#submit-gpi').css("display", "block")
            // endDateTime is greater than startDateTime, proceed!
            $('#reservation-summary .form-card-message').removeClass('form-card-message-error').empty();

            $.ajax({
              type: 'post',
              url: '/wp-admin/admin-ajax.php',
              data: {
                action: 'calculate_hourly_price',
                facilityId: facilityId,
                startDateTime: startDateTime,
                endDateTime: endDateTime,
                nowDateTime: nowDateTime,
                promoCode: promoCode
              },
              success: function (results) {
                var results = JSON.parse(results);
                console.log(results);
                if (results.status == 'success') {

                  // enable checkout (if disabled) on success
                  $('#secure-payment-field').prop('disabled', false);
                  // update hidden price field in pennies
                  $('#price').val(results['new_price']);
                  // update display price field in dollars
                  $('#display-price').text(results['new_display_price']);
                  $('#reservation-summary .form-card-message').removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

                  console.log('TicketType:', results.body.ticket_items[0].type);

                  // add new startDateTime, endDateTime, and promoCode to the URL
                  var url = new URL(window.location);
                  url.searchParams.set('startTime', results.startDateTime);
                  url.searchParams.set('endTime', results.endDateTime);
                  url.searchParams.set('expectedPrice', results.new_price);
                  if (results.promoCode != '') {
                    url.searchParams.set('promoCode', results.promoCode);
                  }
                  history.pushState('', '', url);

                } else {

                  $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
                  // disable checkout on error
                  $('#secure-payment-field').prop('disabled', true);

                }
                // hide loading animation
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
              },
              error: function (results) {
                var results = JSON.parse(results);
                console.log(results);
                // hide loading animation
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
              }
            });

          }

        }

        // update price on date/time/promo change
        var recalculatePrice = debounce(function () {
          // show loading animation
          $('#reservation-summary .card-content-overlay').addClass('card-content-overlay-active');

          // get variables
          var facilityId = $('#facility-id').val();
          var startDate = $('#start-date').val();
          var startTime = $('#start-time').val();
          var endDate = $('#end-date').val();
          var endTime = $('#end-time').val();
          var offset = Number($('#offset').val());
          var promoCode = $('#promo-code').val();

          console.log('startDate:', startDate, 'startTime:', startTime);
          console.log('endDate:', endDate, 'endTime:', endTime);

          if (offset == 0) {

            var offsetISO8601 = '+00:00';

          } else {

            var offsetWIP = ((offset / 60) / 60) * 100;
            var offsetHours = offsetWIP.toString().slice(0, -2);
            var isNegative = offsetHours.indexOf('-');
            if (isNegative == 0) {
              if (offsetHours.length < 3) {
                offsetHours = offsetHours.substring(1);
                offsetHours = '-0' + offsetHours;
              }
            } else {
              if (offsetHours.length < 2) {
                offsetHours = '+0' + offsetHours;
              } else {
                offsetHours = '+' + offsetHours;
              }
            }
            var offsetMinutes = offsetWIP.toString().slice(-2);
            var offsetISO8601 = offsetHours + ':' + offsetMinutes;

          }

          offsetISO8601 = '+00:00';
          console.log('offsetISO8601:', offsetISO8601);

          // convert dates and times to unix epoch format
          var startDateTime = new Date(startDate + 'T' + startTime + offsetISO8601).getTime() / 1000;
          var endDateTime = new Date(endDate + 'T' + endTime + offsetISO8601).getTime() / 1000;
          var nowDateTime = GetUTCNow();

          console.log('startDateTime:', startDateTime);
          console.log('endDateTime:', endDateTime);
          console.log('nowDateTime:', nowDateTime);

          if (startDateTime < (nowDateTime - (60 * 40))) {

            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('Start date/time is in the past.');

          } else if (endDateTime < nowDateTime) {

            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('End date/time is in the past.');

          } else if (startDateTime >= endDateTime) {

            // startDateTime is greater than or equal to endDateTime
            var difference = startDateTime - endDateTime;
            // console.log(difference);
            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('End date/time is earlier than start date/time.');

          } else {

            $('#submit-gpi').css("display", "block")
            // endDateTime is greater than startDateTime, proceed!
            $('#reservation-summary .form-card-message').removeClass('form-card-message-error').empty();

            $.ajax({
              type: 'post',
              url: '/wp-admin/admin-ajax.php',
              data: {
                action: 'calculate_hourly_price',
                facilityId: facilityId,
                startDateTime: startDateTime,
                endDateTime: endDateTime,
                nowDateTime: nowDateTime,
                promoCode: promoCode
              },
              success: function (results) {
                var results = JSON.parse(results);
                console.log(results);
                if (results.status == 'success') {

                  // enable checkout (if disabled) on success
                  $('#secure-payment-field').prop('disabled', false);
                  // update hidden price field in pennies
                  $('#price').val(results['new_price']);
                  // update display price field in dollars
                  $('#display-price').text(results['new_display_price']);
                  $('#reservation-summary .form-card-message').removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

                  console.log('TicketType:', results.body.ticket_items[0].type);

                  // add new startDateTime, endDateTime, and promoCode to the URL
                  var url = new URL(window.location);
                  url.searchParams.set('startTime', results.startDateTime);
                  url.searchParams.set('endTime', results.endDateTime);
                  url.searchParams.set('expectedPrice', results.new_price);
                  if (results.promoCode != '') {
                    url.searchParams.set('promoCode', results.promoCode);
                  }
                  history.pushState('', '', url);

                } else {

                  // disable checkout on error
                  $('#secure-payment-field').prop('disabled', true);
                  $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);

                }
                // hide loading animation
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
              },
              error: function (results) {
                var results = JSON.parse(results);
                console.log(results);
                // hide loading animation
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
              }
            });

          }

        }, 500);

        $('#start-date, #start-time, #end-date, #end-time, #promo-code').on('change', recalculatePrice);

      } else if (type == 'monthly') {

        if ($('input[name="monthly-options"]').length > 0) {

          calculateMonthlyPrice();

          var product = $('input[name="monthly-options"]:checked');
          var customQuestionsString = $(product).attr('data-custom-questions');
          var customQuestions = [];
          if (customQuestionsString.length) {
            var customQuestions = customQuestionsString.split(', ');
            $.each(customQuestions, function (index, question) {
              $('#' + question).show();
              if (question == 'why-purchase-monthly') {
                var value = $('input[name="why-purchase-monthly"]:checked').attr('id');
                if (value == 'work-in-building') {
                  $('#why-purchase-monthly-employer').show();
                  $('#employer').removeClass('ignore');
                } else if (value == 'live-in-building') {
                  $('#why-purchase-monthly-unit-number').show();
                  $('#unit-number').removeClass('ignore');
                }
              }
            });

            $('input[name="why-purchase-monthly"]').change(function () {
              $('#why-purchase-monthly-employer, #why-purchase-monthly-unit-number').hide();
              $('#employer, #unit-number').addClass('ignore');
              var value = $(this).attr('id');
              if (value == 'work-in-building') {
                $('#why-purchase-monthly-employer').show();
                $('#employer').removeClass('ignore');
              } else if (value == 'live-in-building') {
                $('#why-purchase-monthly-unit-number').show();
                $('#unit-number').removeClass('ignore');
              }
            });

          }

          $('.radio-buttons-group').on('change', 'input[name="monthly-options"]', function () {

            calculateMonthlyPrice();

            $('#why-purchase-monthly, #why-purchase-monthly-employer, #why-purchase-monthly-unit-number').hide();
            $('#employer, #unit-number').addClass('ignore');

            var product = $(this);
            var customQuestionsString = $(product).attr('data-custom-questions');
            var customQuestions = [];
            if (customQuestionsString.length) {
              var customQuestions = customQuestionsString.split(', ');
              $.each(customQuestions, function (index, question) {
                $('#' + question).show();
                if (question == 'why-purchase-monthly') {
                  var value = $('input[name="why-purchase-monthly"]:checked').attr('id');
                  if (value == 'work-in-building') {
                    $('#why-purchase-monthly-employer').show();
                    $('#employer').removeClass('ignore');
                  } else if (value == 'live-in-building') {
                    $('#why-purchase-monthly-unit-number').show();
                    $('#unit-number').removeClass('ignore');
                  }
                }
              });
            }

          });

          // recalculate on quantity change
          $('#quantity').change(function () {
            calculateMonthlyPrice();
          });

        }

      } else if (type == 'coupon') {

        if ($('input[name="coupon-options"]').length > 0) {

          calculateCouponPrice();

          var product = $('input[name="coupon-options"]:checked');
          var customQuestionsString = $(product).attr('data-custom-questions');
          var customQuestions = [];
          if (customQuestionsString.length) {
            var customQuestions = customQuestionsString.split(', ');
            $.each(customQuestions, function (index, question) {
              $('#' + question).show();
              if (question == 'why-purchase-coupons') {
                var value = $('input[name="why-purchase-coupons"]:checked').attr('id');
                if (value == 'live-in-building') {
                  $('#why-purchase-coupons-unit-number').show();
                  $('#unit-number').removeClass('ignore');
                }
              }
            });

            $('input[name="why-purchase-coupons"]').change(function () {
              $('#why-purchase-coupons-unit-number').hide();
              $('#unit-number').addClass('ignore');
              var value = $(this).attr('id');
              if (value == 'live-in-building') {
                $('#why-purchase-coupons-unit-number').show();
                $('#unit-number').removeClass('ignore');
              }
            });

          }

          $('.radio-buttons-group').on('change', 'input[name="coupon-options"]', function () {

            calculateCouponPrice();

            $('#why-purchase-coupons, #why-purchase-coupons-unit-number').hide();
            $('#unit-number').addClass('ignore');

            var product = $(this);
            var customQuestionsString = $(product).attr('data-custom-questions');
            var customQuestions = [];
            if (customQuestionsString.length) {
              var customQuestions = customQuestionsString.split(', ');
              $.each(customQuestions, function (index, question) {
                $('#' + question).show();
                if (question == 'why-purchase-coupons') {
                  var value = $('input[name="why-purchase-coupons"]:checked').attr('id');
                  if (value == 'live-in-building') {
                    $('#why-purchase-coupons-unit-number').show();
                    $('#unit-number').removeClass('ignore');
                  }
                }
              });
            }

          });

          // recalculate on quantity change
          $('#quantity').change(function () {
            calculateCouponPrice();
          });

        }

      }

      if (type == 'monthly' || type == 'coupon') {

        if (promoCode) {

          // show loading animation
          $('#reservation-summary .card-content-overlay').addClass('card-content-overlay-active');

          var facilityId = $('#facility-id').val();
          var promoCode = $('#promo-code').val();
          if (type == 'monthly') {
            var parkingType = 'monthly';
          } else if (type == 'coupon') {
            var parkingType = 'coupon';
          }

          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'calculate_product_price',
              facilityId: facilityId,
              parkingType: parkingType,
              promoCode: promoCode
            },
            success: function (results) {
              var results = JSON.parse(results);
              console.log(results);

              if (results.status == 'success') {

                // remove default options, replace with promo code product
                $('#reservation-summary .radio-buttons-group').empty().append(results.productTemplate);
                // update price to promo code price
                var displayPrice = results.productsArray[0].product_price;
                var stripePrice = displayPrice * 100;
                $('#display-price').text(displayPrice);
                $('#price').val(stripePrice);
                // remove loading overlay
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
                $('#reservation-summary .form-card-message').removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

                // add new startDateTime, endDateTime, and promoCode to the URL
                var url = new URL(window.location);
                if (results.promoCode != '') {
                  url.searchParams.set('promoCode', results.promoCode);
                }
                history.pushState('', '', url);

                if (type == 'monthly') {

                  calculateMonthlyPrice();

                  var product = $('input[name="monthly-options"]:checked');
                  var customQuestionsString = $(product).attr('data-custom-questions');
                  var customQuestions = [];
                  if (customQuestionsString.length) {
                    var customQuestions = customQuestionsString.split(', ');
                    $.each(customQuestions, function (index, question) {
                      $('#' + question).show();
                      if (question == 'why-purchase-monthly') {
                        var value = $('input[name="why-purchase-monthly"]:checked').attr('id');
                        if (value == 'work-in-building') {
                          $('#why-purchase-monthly-employer').show();
                          $('#employer').removeClass('ignore');
                        } else if (value == 'live-in-building') {
                          $('#why-purchase-monthly-unit-number').show();
                          $('#unit-number').removeClass('ignore');
                        }
                      }
                    });

                    $('input[name="why-purchase-monthly"]').change(function () {
                      $('#why-purchase-monthly-employer, #why-purchase-monthly-unit-number').hide();
                      $('#employer, #unit-number').addClass('ignore');
                      var value = $(this).attr('id');
                      if (value == 'work-in-building') {
                        $('#why-purchase-monthly-employer').show();
                        $('#employer').removeClass('ignore');
                      } else if (value == 'live-in-building') {
                        $('#why-purchase-monthly-unit-number').show();
                        $('#unit-number').removeClass('ignore');
                      }
                    });

                  }

                  $('.radio-buttons-group').on('change', 'input[name="monthly-options"]', function () {

                    calculateMonthlyPrice();

                    $('#why-purchase-monthly, #why-purchase-monthly-employer, #why-purchase-monthly-unit-number').hide();
                    $('#employer, #unit-number').addClass('ignore');

                    var product = $(this);
                    var customQuestionsString = $(product).attr('data-custom-questions');
                    var customQuestions = [];
                    if (customQuestionsString.length) {
                      var customQuestions = customQuestionsString.split(', ');
                      $.each(customQuestions, function (index, question) {
                        $('#' + question).show();
                        if (question == 'why-purchase-monthly') {
                          var value = $('input[name="why-purchase-monthly"]:checked').attr('id');
                          if (value == 'work-in-building') {
                            $('#why-purchase-monthly-employer').show();
                            $('#employer').removeClass('ignore');
                          } else if (value == 'live-in-building') {
                            $('#why-purchase-monthly-unit-number').show();
                            $('#unit-number').removeClass('ignore');
                          }
                        }
                      });
                    }

                  });

                  // recalculate on quantity change
                  $('#quantity').change(function () {
                    calculateMonthlyPrice();
                  });

                } else if (type == 'coupon') {

                  calculateCouponPrice();

                  var product = $('input[name="coupon-options"]:checked');
                  var customQuestionsString = $(product).attr('data-custom-questions');
                  var customQuestions = [];
                  if (customQuestionsString.length) {
                    var customQuestions = customQuestionsString.split(', ');
                    $.each(customQuestions, function (index, question) {
                      $('#' + question).show();
                      if (question == 'why-purchase-coupons') {
                        var value = $('input[name="why-purchase-coupons"]:checked').attr('id');
                        if (value == 'live-in-building') {
                          $('#why-purchase-coupons-unit-number').show();
                          $('#unit-number').removeClass('ignore');
                        }
                      }
                    });

                    $('input[name="why-purchase-coupons"]').change(function () {
                      $('#why-purchase-coupons-unit-number').hide();
                      $('#unit-number').addClass('ignore');
                      var value = $(this).attr('id');
                      if (value == 'live-in-building') {
                        $('#why-purchase-coupons-unit-number').show();
                        $('#unit-number').removeClass('ignore');
                      }
                    });

                  }

                  $('.radio-buttons-group').on('change', 'input[name="coupon-options"]', function () {

                    calculateCouponPrice();

                    $('#why-purchase-coupons, #why-purchase-coupons-unit-number').hide();
                    $('#unit-number').addClass('ignore');

                    var product = $(this);
                    var customQuestionsString = $(product).attr('data-custom-questions');
                    var customQuestions = [];
                    if (customQuestionsString.length) {
                      var customQuestions = customQuestionsString.split(', ');
                      $.each(customQuestions, function (index, question) {
                        $('#' + question).show();
                        if (question == 'why-purchase-coupons') {
                          var value = $('input[name="why-purchase-coupons"]:checked').attr('id');
                          if (value == 'live-in-building') {
                            $('#why-purchase-coupons-unit-number').show();
                            $('#unit-number').removeClass('ignore');
                          }
                        }
                      });
                    }

                  });

                  // recalculate on quantity change
                  $('#quantity').change(function () {
                    calculateCouponPrice();
                  });

                }

              } else {

                launchAlert('Error', results.message);

                // remove loading overlay
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
                $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);

              }

            },
            error: function (results) {
              var results = JSON.parse(results);
              console.log(results);
            }
          });

        }

        var recalculatePrice = debounce(function () {

          // show loading animation
          $('#reservation-summary .card-content-overlay').addClass('card-content-overlay-active');

          var facilityId = $('#facility-id').val();
          var promoCode = $('#promo-code').val();
          if (type == 'monthly') {
            var parkingType = 'monthly';
          } else if (type == 'coupon') {
            var parkingType = 'coupon';
          }

          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'calculate_product_price',
              facilityId: facilityId,
              parkingType: parkingType,
              promoCode: promoCode
            },
            success: function (results) {
              var results = JSON.parse(results);
              console.log(results);

              if (results.status == 'success') {

                // remove default options, replace with promo code product
                $('#reservation-summary .radio-buttons-group').empty().append(results.productTemplate);
                // update price to promo code price
                var displayPrice = results.productsArray[0].product_price;
                var stripePrice = displayPrice * 100;
                $('#display-price').text(displayPrice);
                $('#price').val(stripePrice);
                // remove loading overlay
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
                $('#reservation-summary .form-card-message').removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

                // console.log('TicketType:', results.body.ticket_items[0].type);

                // add new startDateTime, endDateTime, and promoCode to the URL
                var url = new URL(window.location);
                if (results.promoCode != '') {
                  url.searchParams.set('promoCode', results.promoCode);
                }
                history.pushState('', '', url);

                if (type == 'monthly') {

                  calculateMonthlyPrice();

                  var product = $('input[name="monthly-options"]:checked');
                  var customQuestionsString = $(product).attr('data-custom-questions');
                  var customQuestions = [];
                  if (customQuestionsString.length) {
                    var customQuestions = customQuestionsString.split(', ');
                    $.each(customQuestions, function (index, question) {
                      $('#' + question).show();
                      if (question == 'why-purchase-monthly') {
                        var value = $('input[name="why-purchase-monthly"]:checked').attr('id');
                        if (value == 'work-in-building') {
                          $('#why-purchase-monthly-employer').show();
                          $('#employer').removeClass('ignore');
                        } else if (value == 'live-in-building') {
                          $('#why-purchase-monthly-unit-number').show();
                          $('#unit-number').removeClass('ignore');
                        }
                      }
                    });

                    $('input[name="why-purchase-monthly"]').change(function () {
                      $('#why-purchase-monthly-employer, #why-purchase-monthly-unit-number').hide();
                      $('#employer, #unit-number').addClass('ignore');
                      var value = $(this).attr('id');
                      if (value == 'work-in-building') {
                        $('#why-purchase-monthly-employer').show();
                        $('#employer').removeClass('ignore');
                      } else if (value == 'live-in-building') {
                        $('#why-purchase-monthly-unit-number').show();
                        $('#unit-number').removeClass('ignore');
                      }
                    });

                  }

                  $('.radio-buttons-group').on('change', 'input[name="monthly-options"]', function () {

                    calculateMonthlyPrice();

                    $('#why-purchase-monthly, #why-purchase-monthly-employer, #why-purchase-monthly-unit-number').hide();
                    $('#employer, #unit-number').addClass('ignore');

                    var product = $(this);
                    var customQuestionsString = $(product).attr('data-custom-questions');
                    var customQuestions = [];
                    if (customQuestionsString.length) {
                      var customQuestions = customQuestionsString.split(', ');
                      $.each(customQuestions, function (index, question) {
                        $('#' + question).show();
                        if (question == 'why-purchase-monthly') {
                          var value = $('input[name="why-purchase-monthly"]:checked').attr('id');
                          if (value == 'work-in-building') {
                            $('#why-purchase-monthly-employer').show();
                            $('#employer').removeClass('ignore');
                          } else if (value == 'live-in-building') {
                            $('#why-purchase-monthly-unit-number').show();
                            $('#unit-number').removeClass('ignore');
                          }
                        }
                      });
                    }

                  });

                  // recalculate on quantity change
                  $('#quantity').change(function () {
                    calculateMonthlyPrice();
                  });

                } else if (type == 'coupon') {

                  calculateCouponPrice();

                  var product = $('input[name="coupon-options"]:checked');
                  var customQuestionsString = $(product).attr('data-custom-questions');
                  var customQuestions = [];
                  if (customQuestionsString.length) {
                    var customQuestions = customQuestionsString.split(', ');
                    $.each(customQuestions, function (index, question) {
                      $('#' + question).show();
                      if (question == 'why-purchase-coupons') {
                        var value = $('input[name="why-purchase-coupons"]:checked').attr('id');
                        if (value == 'live-in-building') {
                          $('#why-purchase-coupons-unit-number').show();
                          $('#unit-number').removeClass('ignore');
                        }
                      }
                    });

                    $('input[name="why-purchase-coupons"]').change(function () {
                      $('#why-purchase-coupons-unit-number').hide();
                      $('#unit-number').addClass('ignore');
                      var value = $(this).attr('id');
                      if (value == 'live-in-building') {
                        $('#why-purchase-coupons-unit-number').show();
                        $('#unit-number').removeClass('ignore');
                      }
                    });

                  }

                  $('.radio-buttons-group').on('change', 'input[name="coupon-options"]', function () {

                    calculateCouponPrice();

                    $('#why-purchase-coupons, #why-purchase-coupons-unit-number').hide();
                    $('#unit-number').addClass('ignore');

                    var product = $(this);
                    var customQuestionsString = $(product).attr('data-custom-questions');
                    var customQuestions = [];
                    if (customQuestionsString.length) {
                      var customQuestions = customQuestionsString.split(', ');
                      $.each(customQuestions, function (index, question) {
                        $('#' + question).show();
                        if (question == 'why-purchase-coupons') {
                          var value = $('input[name="why-purchase-coupons"]:checked').attr('id');
                          if (value == 'live-in-building') {
                            $('#why-purchase-coupons-unit-number').show();
                            $('#unit-number').removeClass('ignore');
                          }
                        }
                      });
                    }

                  });

                  // recalculate on quantity change
                  $('#quantity').change(function () {
                    calculateCouponPrice();
                  });

                }

              } else {

                launchAlert('Error', results.message);

                // remove loading overlay
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
                $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);

              }

            },
            error: function (results) {
              var results = JSON.parse(results);
              console.log(results);
            }
          });

        });

        $('#promo-code').on('change', recalculatePrice);

      }
    }
  }

  if ($('body').hasClass('page-template-page-account-receipt')) {

    // generate barcode image from string
    if ($('.receipt-barcode').length > 0) {
      $('.receipt-barcode').each(function () {
        var thisBarcode = $(this);
        var thisBarcodeString = $(thisBarcode).attr('data-barcode-string');
        var thisBarcodeSize = $(thisBarcode).attr('data-barcode-size');
        var thisQRCode = new QRCode(this, {
          text: thisBarcodeString,
          width: thisBarcodeSize,
          height: thisBarcodeSize,
          colorDark: '#000000',
          colorLight: '#FFFFFF',
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    }

    if ($('#map').length > 0) {
      var map = $('#map');
      var latitude = map.attr('data-latitude');
      var longitude = map.attr('data-longitude');
      simpleMap(latitude, longitude, 'map');
    }

    facilityPhotos();
  }

  // show/hide frequently asked questions
  $('.faqs-group').each(function () {
    $('.faq-question').click(function () {
      $(this).parents('.faq').toggleClass('faq-active');
    });
  });

  if ($('body').hasClass('page-template-page-support')) {

    // show/hide form fields based on topic selection
    $('#topic').change(function () {
      var topic = $(this).val();
      console.log(topic);
      $('.form-field-optional').hide();
      $('.form-field-' + topic).show();
    });

    // show/hide app and browser options based on device selection
    $('#device').change(function () {
      var device = $(this).val();
      var target = $('#browser');
      $('optgroup, option', target).show();
      if (device == 'Android Phone' || device == 'iPhone' || device == 'Android Tablet' || device == 'iPad') {
        $('option[value="Edge"], option[value="Internet Explorer"]', target).hide();
        if (device == 'Android Phone' || device == 'Android Tablet') {
          $('option[value="ParkChirp iOS App"], option[value="Safari"]', target).hide();
        } else if (device == 'iPhone' || device == 'iPad') {
          $('option[value="ParkChirp Android App"]', target).hide();
        }
      } else if (device == 'Google Chromebook' || device == 'Macintosh Laptop or Desktop' || device == 'Windows Laptop or Desktop') {
        $('optgroup[label="Apps"]', target).hide();
        if (device == 'Google Chromebook') {
          $('option[value="Edge"], option[value="Firefox"], option[value="Internet Explorer"], option[value="Safari"], option[value="Other"]', target).hide();
        } else if (device == 'Macintosh Laptop or Desktop') {
          $('option[value="Edge"], option[value="Internet Explorer"]', target).hide();
        } else if (device == 'Windows Laptop or Desktop') {
          $('option[value="Safari"]', target).hide();
        }
      }
    });
  }

  /*** date and time picker helpers ***/
  if ($('#start-date').length && $('#start-time').length && $('#end-date').length && $('#end-time').length) {

    $('#start-date').on('change', function () {
      var startDate = $('#start-date').val();
      var startTime = $('#start-time').val();
      var endDate = $('#end-date').val();
      var endTime = $('#end-time').val();
      if (startDate > endDate) {
        $('#end-date').val(startDate);
        console.log('changed #end-date to match #start-date');
      }
    });

    // todo: #start-time helper

    $('#end-date').on('change', function () {
      var startDate = $('#start-date').val();
      var startTime = $('#start-time').val();
      var endDate = $('#end-date').val();
      var endTime = $('#end-time').val();
      if (endDate < startDate) {
        $('#start-date').val(endDate);
        console.log('changed #start-date to match #end-date');
      }
    });

    // todo: #end-time helper

  }

  /*** transaction history pagination ***/

  if ($('body').hasClass('page-template-page-account-history-php')) {

    var config = {
      debug: {
        enable: true
      },
      load: {
        sort: 'date:desc'
      },
      animation: {
        effects: 'fade scale',
        duration: 500,
        easing: 'ease-in-out'
      },
      classNames: {
        block: 'toolbar',
        elementFilter: 'button',
        elementSort: 'button'
      },
      selectors: {
        pageList: '.transactions-page-list',
        pageStats: '.transactions-page-stats',
        target: '.transaction'
      },
      callbacks: {
        onMixEnd: function (state) {
          var errorField = $('.transactions-error');
          if (state.hasFailed) {
            errorField.show();
          } else {
            errorField.hide();
          }
        }
      },
      multifilter: {
        enable: true,
        logicBetweenGroups: 'and',
        logicWithinGroup: 'or'
      },
      pagination: {
        limit: 25
      }
    };
    var container = $('.transactions-group ol');
    if (container.length > 0) {
      var mixer = mixitup(container, config);
      console.log(mixer)

      $('#transactions-sort').change(function () {
        mixer.sort(this.value);
      });

      // show/hide transactions filters
      $('#filter-transactions-trigger').click(function (e) {
        e.preventDefault();
        $('.transactions-filters').toggleClass('transactions-filters-active');
      });
    }
  }

  /*** update license plate functionality ***/

  $('#open-license-form').on('click', function () {
    $('#update-license-section').show();
    $('#open-license-form').hide();
  });

  $('input[name=\'license-plates\']').change(function () {
    let input = $('#license-plate-container');
    this.id === 'new-license-plate-checkbox' ? input.show() : input.hide();
  });

  $('#update-license').validate({
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    ignore: '.ignore',
    rules: {
      'license-plates': {
        required: true
      },
      'new-license-plate': {
        required: {
          depends: function (element) {
            return $('#new-license-plate-checkbox').is(':checked');
          }
        }
      }
    },
    messages: {
      'license-plates': {
        required: 'Please choose a license plate.'
      },
      'new-license-plate': {
        required: 'Please enter a license plate.'
      }
    },
    submitHandler: function (form) {
      let selectedCheckbox = $('input[name="license-plates"]:checked')[0];
      var licensePlate, saveNewLicense = false;
      if (selectedCheckbox.id === 'new-license-plate-checkbox') {
        saveNewLicense = true;
        licensePlate = $('#license-plate-container > input').val().trim();
      } else {
        licensePlate = $('input[name="license-plates"]:checked').val().trim();
      }
      var transactionId = $(form).attr('data-transaction-id');
      var facilityId = $(form).attr('data-facility-id');
      $('.button-spinner').prop('disabled', true);

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'aws_cognito_chirp_update_license_plate',
          transaction_id: transactionId,
          facility_id: facilityId,
          license_plate: licensePlate,
          save_new_license: saveNewLicense
        },
        success: function (results) {
          var results = JSON.parse(results);
          console.log(results);
          $('.button-spinner').prop('disabled', false);
          if (results.status == 'success') {
            $('#license-plate-message').addClass('form-card-message-success').text(`License plate changed to ${results.message}`);
            $('#license-plate-display').text(results.message);
            $('#update-license-section').css("display", "none");
          } else {
            $('#license-plate-message').addClass('form-card-message-error').text(results.message);
          }
        },
        error: function (results) {
          // var results = JSON.parse(results);
          console.log(results);
          $('.button-spinner').prop('disabled', false);
          $('#license-plate-message').addClass('form-card-message-error').text(results.message);
        }
      });
    }
  });

  /*** monthly :: credentials ***/
  var graphQLToken = $('#token').attr('value');
  var graphQLAuth = 'Bearer ' + graphQLToken;
  var graphQLv2Auth = 'Bearer ' + graphQLToken;
  var graphQLNonce = $('#chirp-monthly-nonce').val();
  var graphQLHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + graphQLToken,
    'Access-Control-Allow-Origin': '*'
  };

  var lineItemEntryTypeMap = {
    'PAYMENT': 'Payment',
    'CHARGE': 'Charge',
    'REFUND': 'Refund',
    'POSITIVE_ADJUSTMENT': 'Positive Adjustment',
    'REVERSAL': 'Reversal',
    'ADJUSTMENT': 'Adjustment',
    'LANDLORD_COLLECTED': 'Landlord Collected',
    'WRITE_OFF': 'Write Off',
    'TERMINATION_ADJUSTMENT_NEGATIVE': 'Term adj - Negative',
    'TERMINATION_ADJUSTMENT_POSITIVE': 'Term adj - Positive',
  }

  var accessDeviceTypeMap = {
    'Barcode': 'BARCODE',
    'Proximity Card': 'PROXIMITY_CARD',
    'Tenant Access Card': 'TENANT_ACCESS_CARD',
    "AVI Transponder": 'AVI_TRANSPONDER',
    "Windshield Sticker": 'WINDSHIELD_STICKER',
    'License Plate Recognition': 'LICENSE_PLATE_RECOGNITION',
    'Flash Parking App': 'FLASH_PARKING_APP',
    'Hang Tag': 'HANG_TAG'
  }

  /* request refund from transaction history */
  $('.transaction-refund-new').click(function (e) {
    e.preventDefault();
    var transactionId = $(this).attr('data-transaction-id');
    var sessionId = $(this).attr('data-session-id');
    var amount = Number($(this).attr('data-amount'));
    var thisTransaction = $(this).parents('.transaction');

    $('.transaction-refund-new[data-session-id="' + sessionId + '"]').hide();
    $('.transaction-change-license[data-transaction-id="' + transactionId + '"]').hide();

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'chirp_graphql',
        api_version: 'v2',
        authorization: graphQLv2Auth,
        nonce: graphQLNonce,
        graphql_request: `
          mutation myAccountRefundHourlySession($id: Int!, $amount: Int!, $cancel: Boolean!) {
              myAccountRefundHourlySession(id: $id, amount: $amount, cancel: $cancel)
          }
        `,
        graphql_variables: JSON.stringify({
          id: Number(sessionId),
          amount,
          cancel: true,
        }),
      },
      success: function (results) {
        var results = JSON.parse(results);
        console.log(results);
        if (results.error == null) {
          $(thisTransaction).addClass('transaction-refunded');
        } else {
          $('.transaction-refund-new[data-session-id="' + sessionId + '"]').show();
          $('.transaction-change-license[data-transaction-id="' + transactionId + '"]').show();
          console.log('Error:', results.message);
        }
      },
      error: function (results) {
        $('.transaction-refund-new[data-session-id="' + sessionId + '"]').show();
        $('.transaction-change-license[data-transaction-id="' + transactionId + '"]').show();
        console.log(results);
      }
    });
  });

  const createTerminationDate = (isThirtyDayNotice = false) => {
    const terminationDay = Number($('#subscription option:selected').attr('data-termination-day'));
    const today = moment();
    // create moment object for the termination date
    let terminationDate = moment().date(terminationDay);
    if (today.format('D') > terminationDay) {
      terminationDate = terminationDate.add(1, 'months');
    }
    // the last day to park is the last day of the month of the terminationDate
    let lastDayToPark = terminationDate.endOf('month');
    if (isThirtyDayNotice) {
      lastDayToPark = moment();
      lastDayToPark = lastDayToPark.add(1, 'months');
      // see PCA-3218 for this edge case, has to do with prorating a parker's auto invoice when they terminate
      const isJanuaryThirtyFirst = today.month() === 0 && moment().date() === 31;
      const isFebruaryFirst = today.month() === 1 && moment().date() === 1;
      if (isJanuaryThirtyFirst || isFebruaryFirst) {
        // February
        lastDayToPark.set('month', 1);
        // whatever the last day of February is, leap year or not
        lastDayToPark.set('date', lastDayToPark.daysInMonth());
      }
    }

    return lastDayToPark.format('YYYY-MM-DD');
  }
  const getTerminationDate = (parker = null, isThirtyDayNotice = false) => {
    let lastDayToPark = moment(createTerminationDate(isThirtyDayNotice));
    if (parker && parker.parker_status_history) {
      parker.parker_status_history.forEach((item) => {
        if (item.action === "TERMINATE") {
          lastDayToPark = moment(item.start_date);
        }
      });
    }
    return lastDayToPark.format("MMMM D, YYYY");
  }
  const getTerminationProrationPercentage = (terminationRule, terminationDay) => {
    let lastDayToPark = moment($('#parker-termination-date-picker').val(), 'YYYY-MM-DD');

    // assume the termination rule for the subscription is daily if it's not half month
    let percentage = lastDayToPark.date() / lastDayToPark.daysInMonth();
    if (terminationRule === 'HALF_MONTH') {
      // 50% discount if on or before the termination notice day, otherwise no proration
      percentage = lastDayToPark.date() <= terminationDay ? 0.5 : 1;
    }

    const percentageToTwoDecimalPlaces = Math.floor((percentage) * 10000) / 100;
    return percentageToTwoDecimalPlaces;
  }
  const getTerminationMonthAndYear = (isThirtyDayNotice) => {
    return moment(createTerminationDate(isThirtyDayNotice)).format("MMMM YYYY");
  }

  const oldGetParkerStatusText = (parker) => {
    if (parker.suspension_status == "SUSPENDED") {
      return "Suspended";
    }
    else if (parker.suspension_status == "TERMINATED" || parker.termination_status == "TERMINATED") {
      return "Terminated"
    }
    else if (parker.suspension_status == "PENDING" || parker.termination_status == "PENDING") {
      return "Pending"
    }
    else if (parker.suspension_status == "ACTIVE" || parker.termination_status == "ACTIVE" || parker.suspension_status == "SUSPENSION_PENDING" || parker.termination_status == "TERMINATION_PENDING") {
      return "Active";
    }
    return "";
  }
  const getParkerStatusText = (parker) => {
    if (!feature_flags.FEATURE_MYACCOUNT) {
      return oldGetParkerStatusText(parker);
    }

    if (parker.suspension_status == "SUSPENDED") {
      return "Suspended";
    }
    else if (parker.suspension_status == "TERMINATED" || parker.termination_status == "TERMINATED") {
      return "Terminated"
    }
    else if (parker.suspension_status == "PENDING" || parker.termination_status == "PENDING") {
      return "Pending"
    }
    else if (feature_flags.FEATURE_MYACCOUNT && parker.termination_status == "TERMINATION_PENDING") {
      return "Active: Parker will terminate on " + getTerminationDate(parker);
    }
    else if (parker.suspension_status == "ACTIVE" || parker.termination_status == "ACTIVE" || parker.suspension_status == "SUSPENSION_PENDING") {
      return "Active";
    } else if (parker.suspension_status == "WAITLIST") {
      return "Waitlist";
    }
    return "";
  }

  function displayNewCardForm(useSlidePay) {
    if (useSlidePay) {
      $('#gpi-card-form-container').hide();
      $('#slidepay-card-form-container')
        .show()
        .children()
        .show();
    } else {
      $('#slidepay-card-form-container').hide();
      $('#gpi-card-form-container')
        .show()
        .children()
        .show();

      updateGpiCardFormHeight();
    }
  }

  function updateTotals(creditCardFeePrice, achDiscountAmount) {
    const selectedPaymentMethod = $('input[name="payment-types"]:checked').val();
    const selectedPaymentAmountOption = $('input[name="payment-amount"]:checked').val();
    const partialAmount = $('#partial-amount-input').inputmask('unmaskedvalue') * 100;

    let paymentAmount = selectedPaymentAmountOption === 'full-balance' ? thisInvoicePrice : partialAmount;
    let price = paymentAmount;

    if (selectedPaymentMethod === 'credit-card') {
      price += creditCardFeePrice;
    }

    if (selectedPaymentMethod === 'bank-account' && selectedPaymentAmountOption === 'full-balance') {
      paymentAmount -= achDiscountAmount;
      price -= achDiscountAmount;
    }

    const amountDisplay = (paymentAmount / 100).toFixed(2);
    $('#invoice-amount').text(amountDisplay);
    $('#otp-payment-amount').val(paymentAmount);
    $('#price').val(price);
  }
  
  function hideBankAccountForms() {
    $('#ach-new').prop('checked', false);
    $('#gpi-bank-account-form-container').hide();
    $('#slidepay-bank-account-form-container').hide();
  }

  function displayNewBankAccountForm(useSlidePay) {
    if (useSlidePay) {
      $('#gpi-bank-account-form-container').hide();
      $('#slidepay-bank-account-form-container')
        .show()
        .children()
        .show();
    } else {
      $('#slidepay-bank-account-form-container').hide();
      $('#gpi-bank-account-form-container')
        .show()
        .children()
        .show();
    }
  }

  function makePayment(invoiceId, paymentSource, paymentType, achAuthorizationAcceptance = null, onFailure = () => {}) {
    var invoiceId = invoiceId;
    var paymentSource = paymentSource;
    const paymentAmount = $('#otp-payment-amount').val();

    const selectedPaymentAmountOption = $('input[name="payment-amount"]:checked').val();
    const paymentMethod = paymentType === 'bank-account' ? 'ach' : paymentType === 'credit-card' ? 'card' : 'invalidType';

    let graphqlVariables = {
      invoiceId,
      paymentToken: paymentSource,
      paymentMethod,
      achAuthorizationAcceptance,
    };

    if (selectedPaymentAmountOption === 'partial-amount') {
      graphqlVariables.customPaymentAmount = parseInt(paymentAmount);
    }

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'chirp_graphql',
        api_version: 'v2',
        authorization: graphQLv2Auth,
        nonce: graphQLNonce,
        graphql_request: `
          mutation payInvoice(
            $invoiceId: String!
            $paymentToken: String!
            $paymentMethod: String!
            $customPaymentAmount: Int
            $achAuthorizationAcceptance: CheckoutAchAuthorizationAcceptanceInput
          ) { 
            payInvoice(
              invoiceId: $invoiceId
              paymentToken: $paymentToken
              paymentMethod: $paymentMethod
              customPaymentAmount: $customPaymentAmount
              achAuthorizationAcceptance: $achAuthorizationAcceptance
            ) 
          }
        `,
        graphql_variables: JSON.stringify(graphqlVariables),
      },
      success: function (results) {
        const response = JSON.parse(results);
        console.log('success!', results);
        if (response.errors) {
          $('.button-spinner').prop('disabled', false);
          onFailure();
          let errorText = response.errors[0].message ? response.errors[0].message : errorMessage;

          if (response.errors[0].message && response.errors[0].message.includes('Variable "$paymentMethod" of required type "String!" was not provided')) {
            errorText = "Please select a payment method before submitting"
          } else if (
            response?.errors?.[0]?.message?.includes('earliest payment application date') ||
            response?.errors?.[0]?.message?.includes('latest payment application date')
          ) {
            errorText = response.errors[0].message
          } else {
            errorText = errorMessage;
          }
          $('.form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(errorText);
        } else {
          $('.form-card-message').empty().removeClass('form-card-message-error').addClass('form-card-message-success').text('Your payment was successful!');
          setTimeout(function () {
            window.location.href = '/account/monthly/activity/?invoice=' + invoiceId;
          }, 1000);
        }
      },
      error: function (results) {
        console.log('error!', results);
        $('.button-spinner').prop('disabled', false);
        onFailure();
        $('.form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(errorMessage);
      }
    });
  }

  /*** monthly :: subscription terms and conditions */
  if ($('body').hasClass('page-template-page-account-monthly-terms')) {
    var subscription_id = getUrlParameter('subscription');
    if (subscription_id) {
      console.log('subscription_id', subscription_id);
      function setTermsAcceptanceMessage(message, type) {
        $('#terms-and-conditions-message')
          .empty()
          .removeClass('form-card-message-success form-card-message-error')
          .addClass(type)
          .text(message);
      }

      function acceptMostRecentTerms(subscriptionId, termsAndConditionsHistoryId) {
        const $checkbox = $('#accept-terms-and-conditions');
        $checkbox.prop('disabled', true);
        setTermsAcceptanceMessage('Saving your acceptance...', '');

        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_graphql',
            api_version: 'v2',
            authorization: graphQLv2Auth,
            nonce: graphQLNonce,
            graphql_request: `
              mutation myAccountAcceptTermsAndConditions(
                $subscriptionId: String!,
                $termsAndConditionsHistoryId: String!,
                $userAgent: String!,
                $userIp: String!
              ) {
                myAccountAcceptTermsAndConditions(
                  subscriptionId: $subscriptionId,
                  termsAndConditionsHistoryId: $termsAndConditionsHistoryId,
                  userAgent: $userAgent,
                  userIp: $userIp
                )
              }
            `,
            graphql_variables: JSON.stringify({
              subscriptionId,
              termsAndConditionsHistoryId,
              userAgent: window.navigator.userAgent
            })
          },
          success: function (results) {
            const response = JSON.parse(results);
            console.log('success!', response);
            if (response.errors?.length) {
              $checkbox.prop('checked', false).prop('disabled', false);
              setTermsAcceptanceMessage('Something went wrong accepting the terms and conditions. Please try again.', 'form-card-message-error');
              return;
            }

            $checkbox.prop('checked', true).prop('disabled', true);
            setTermsAcceptanceMessage('Terms and conditions accepted.', 'form-card-message-success');
          },
          error: function (results) {
            console.log(results);
            $checkbox.prop('checked', false).prop('disabled', false);
            setTermsAcceptanceMessage('Something went wrong accepting the terms and conditions. Please try again.', 'form-card-message-error');
          }
        });
      }

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "query getSubscription($subscription_id: String!) { getSubscription(subscription_id: $subscription_id) { id, hasAcceptedMostRecentTerms, termsAndConditions { id, text, summary } billing_profile { id, facility { id, facility_name } } } }",
          graphql_variables: JSON.stringify({
            "subscription_id": subscription_id
          })
          },
          success: function (results) {
            let { data, errors } = JSON.parse(results);
            console.log('success!', data);
          const subscription = data.getSubscription;
          const termsAndConditionsHistoryId = subscription.termsAndConditions?.id;
          const hasAcceptedMostRecentTerms = subscription.hasAcceptedMostRecentTerms === true;
          const termsAcceptanceLabel = hasAcceptedMostRecentTerms
            ? 'You have already accepted the most recent terms and conditions.'
            : 'Click here to accept these terms and conditions.';
          const termsAcceptanceTemplate = `
            <div class="form-field" id="terms-and-conditions-acceptance" style="margin-top: 1.5rem;">
              <input
                type="checkbox"
                id="accept-terms-and-conditions"
                data-cy="terms-and-conditions-acceptance-checkbox"
                ${hasAcceptedMostRecentTerms ? 'checked disabled' : ''}
              />
              <label class="checkbox-label" for="accept-terms-and-conditions">
                ${termsAcceptanceLabel}
              </label>
              <div class="form-card-message" id="terms-and-conditions-message" data-cy="terms-and-conditions-message"></div>
            </div>
          `;

          if (subscription.termsAndConditions?.text) {
            var terms = subscription.termsAndConditions.text;
            var terms_formatted = terms.replace(/(?:\r\n|\r|\n)/g, '<br />');
            $('.card-content').append(terms_formatted);
          }

          $('.card-content').append(termsAcceptanceTemplate);
          $('.facility-name').empty().text(subscription.billing_profile.facility.facility_name);

          if (hasAcceptedMostRecentTerms) {
            setTermsAcceptanceMessage('', '');
          } else {
            $('#accept-terms-and-conditions').on('change', function () {
              if ($(this).is(':checked')) {
                if (termsAndConditionsHistoryId) {
                  acceptMostRecentTerms(subscription_id, termsAndConditionsHistoryId);
                } else {
                  $(this).prop('checked', false);
                  setTermsAcceptanceMessage('Unable to find the latest terms and conditions version. Please try again later.', 'form-card-message-error');
                }
              }
            });
          }
          // remove loading overlay
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        },
        error: function (results) {
          console.log(results);
          // remove loading overlay
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        }
      });
    }
  }

  let thisAchDiscountAmount = 0;
  function getAchDiscountEligibility(subscriptionId, invoiceId) {
    thisAchDiscountAmount = 0;
    $('.card-content-overlay').addClass('card-content-overlay-active');

    let graphqlVariables = { subscriptionId };
    if (invoiceId) {
      graphqlVariables.invoiceIds = [invoiceId];
    }

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'chirp_graphql',
        api_version: 'v2',
        authorization: graphQLv2Auth,
        nonce: graphQLNonce,
        graphql_request: `
          query getAchDiscountEligibility($subscriptionId: String!, $invoiceIds: [String]) {
            getAchDiscountEligibility(
              subscriptionId: $subscriptionId
              invoiceIds: $invoiceIds
            ) {
              isEligible
              discountPercentage
              totalDiscountAmount
            }
          }
        `,
        graphql_variables: JSON.stringify(graphqlVariables),
      },
      success: function (results) {
        const { data, errors } = JSON.parse(results);
        if (errors || !data?.getAchDiscountEligibility) {
          console.log(errors);
          $('.bank-account-discount-notice').hide();
          $('.card-content-message').text('Unable to check ACH discounts. Please reload the page and try again.');
          return;
        }
        
        const { isEligible, discountPercentage, totalDiscountAmount } = data.getAchDiscountEligibility;
          
        if (isEligible) {
          const selectedPaymentAmountOption = $('input[name="payment-amount"]:checked').val();

          if (selectedPaymentAmountOption === 'full-balance') {
            $('.bank-account-discount-notice').show();
          }

          $('.ach-discount-amount').text(`${discountPercentage}%`);

          if (totalDiscountAmount > 0) {
            thisAchDiscountAmount = totalDiscountAmount;
          }
        } else {
          $('.bank-account-discount-notice').hide();
        }

        $(document).trigger('ach-discount-updated');
      },
      error: function () {
        $('.bank-account-discount-notice').hide();
        $('.card-content-message').text('Unable to check ACH discounts. Please reload the page and try again.');
      },
      complete: function () {
        $('.card-content-overlay').removeClass('card-content-overlay-active');
      }
    })
  }

  /*** monthly :: subscriptions index ***/
  if ($('body').hasClass('page-template-page-account-monthly')) {
    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'chirp_graphql',
        authorization: graphQLAuth,
        nonce: graphQLNonce,
        graphql_request: "query listUserSubscriptions($paymentProviderId: Int) { listUserSubscriptions(paymentProviderId: $paymentProviderId) { id, hasAcceptedMostRecentTerms, termsAndConditions { id, text, summary }, account_id, subscription_name, billing_profile { id, validation_only, facility { id, facility_name, address, timezone } } } }",
        graphql_variables: JSON.stringify(listUserSubscriptionsVariables())
      },
      success: function (results) {
        let { data } = JSON.parse(results);
        console.log('success!', data);

        if (data && data.listUserSubscriptions.length > 0) {
          var subscriptions = data.listUserSubscriptions;

          $('.card-content').append('<div class="subscriptions-group" />');
          $(subscriptions).each(function (index, subscription) {
            var template = $($('#subscription-template').html());
            if (subscription.billing_profile.facility) {
              $('.facility-name', template).text(subscription.billing_profile.facility.facility_name);
            } else {
              $('.facility-name', template).text('FACILITY NAME');
            }
            if (subscription.billing_profile.validation_only) {
              $('.subscription-menu li:last-of-type', template).hide();
              $('.parking-type', template).text('Validation Subscription at');
            } else {
              $('.subscription-menu li:last-of-type', template).show();
            }
            $('.subscription-name', template).text('Subscription Name: ' + subscription.subscription_name);
            $('.account-id', template).text('Account ID: AC-' + subscription.account_id);
            var links = $('.subscription-menu a', template);
            $(links).each(function (index, link) {
              var href = $(this).attr('href');
              href = href.replaceAll('subscriptionId', subscription.id);
              $(link).attr('href', href);
            });
            if (subscription.termsAndConditions?.id) {
              if (subscription.hasAcceptedMostRecentTerms !== true) {
                $('.subscription-actions', template).append(
                  '<div class="subscription-action"><a href="/account/monthly/terms/?subscription='
                    + subscription.id
                    + '" title="Terms & Conditions Acceptance Needed" class="subscription-action-link" data-cy="terms-and-conditions-acceptance-needed-button">Terms & Conditions Acceptance Needed</a></div>'
                );
              }
              $('.subscription-menu ul', template).append('<li><a href="/account/monthly/terms/?subscription=' + subscription.id + '" title="Terms & Conditions" data-cy="terms-and-conditions-link">Terms & Conditions</a></li>');
            }
            $('.subscriptions-group').append(template);
          });

          // remove loading overlay
          $('.card-content-overlay').removeClass('card-content-overlay-active');

        } else {

          // inject error message
          $('.card-content-message').text('You don\'t have any subscriptions to display.');
          // remove loading overlay
          $('.card-content-overlay').removeClass('card-content-overlay-active');

        }
      },
      error: function (results) {
        console.log(results);
        // inject error message
        $('.card-content').append('<div class="card-content-error">Sorry, we were unable to look up your subscriptions. Try again?</div>');
        // remove loading overlay
        $('.card-content-overlay').removeClass('card-content-overlay-active');
      }
    });
  }

  let thisCreditCardFeePrice = 0;
  function getCreditCardFeePrice(billingProfileId, paymentAmount, subscriptionId) {
    $('.card-content-overlay').addClass('card-content-overlay-active');

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'chirp_graphql',
        api_version: 'v2',
        authorization: graphQLv2Auth,
        nonce: graphQLNonce,
        graphql_request: `query getCreditCardFeePrice(
          $billingProfileId: String!,
          $paymentAmount: Int!,
          $subscriptionId: String
        ) {
          getCreditCardFeePrice(
            billingProfileId: $billingProfileId,
            paymentAmount: $paymentAmount,
            subscriptionId: $subscriptionId
          ) {
            price,
            displayPrice,
            displayPercentage,
            displayDollarAmount
          }
        }`,
        graphql_variables: JSON.stringify({
          billingProfileId,
          paymentAmount,
          subscriptionId,
        }),
      },
      success: function (results) {
        const { data, errors } = JSON.parse(results);
        if (errors || !data?.getCreditCardFeePrice) {
          console.log(errors);
          $('.card-content-message').text('Unable to calculate payment fees. Please reload the page and try again.');
          return;
        }

        const {
          price: creditCardFeePriceCents,
          displayPrice,
          displayPercentage,
          displayDollarAmount,
        } = data.getCreditCardFeePrice;

        if (creditCardFeePriceCents > 0) {
          thisCreditCardFeePrice = creditCardFeePriceCents;

          $('.credit-card-disclaimer').show();
          $('.bank-account-disclaimer').show();

          // Display credit card fee total price on one-time payment page
          $('.credit-card-fee-display-price').text(displayPrice);

          // Display credit card fee details on the recurring payments page
          let creditCardFeeDetails = '';
          if (displayDollarAmount) creditCardFeeDetails += `$${displayDollarAmount} flat fee`;
          if (displayPercentage) creditCardFeeDetails += `${displayDollarAmount ? ' plus a' : ''} ${displayPercentage}% fee`;
          $('.credit-card-fee-details').text(creditCardFeeDetails);

          // Update one-time payment total if credit card is selected
          const paymentType = $('input[name="payment-types"]:checked').val();
          if (paymentType == 'credit-card') {
            const creditCardFeePriceDollars = Number((creditCardFeePriceCents / 100).toFixed(2));
            const paymentAmountDollars = Number((paymentAmount / 100).toFixed(2));
            const invoiceAmount = (paymentAmountDollars + creditCardFeePriceDollars).toFixed(2);

            $('#invoice-amount').text(invoiceAmount);
            $('#price').val(paymentAmount + creditCardFeePriceCents);
          }

        } else {
          $('.credit-card-disclaimer').hide();
          $('.bank-account-disclaimer').hide();
        }

      },
      error: function () {
        $('.card-content-message').text('Unable to calculate payment fees. Please reload the page and try again.');
      },
      complete: function () {
        $('.card-content-overlay').removeClass('card-content-overlay-active');
      }
    });
  }

  /*** monthly :: one-time payment ***/
  if ($('body').hasClass('page-template-page-account-monthly-one-time-payment')) {

    var displayAch = false;
    let displayCreditCard = true;

    /* get invoice id from url, if it exists */
    var thisSubscription = getUrlParameter('subscription');
    var thisInvoice = getUrlParameter('invoice');
    var thisInvoicePrice = 0;
    var thisBillingProfile = null;
    let thisPaymentProvider = null;
    let selectedSubscription = null;
    let currentAchAuthorization = null;
    let paymentSubmitting = false;

    function getOneTimePaymentSelection() {
      const invoiceId = $('#invoice').val();
      const paymentType = $('input[name="payment-types"]:checked').val();
      if (!selectedSubscription || !invoiceId || invoiceId === '#' || !thisPaymentProvider) {
        return null;
      }
      const usingCard = paymentType === 'credit-card';
      const usingAch = paymentType === 'bank-account';
      if ((!usingCard && !usingAch) || (usingCard && !displayCreditCard) || (usingAch && !displayAch)) {
        return null;
      }
      const method = $(usingCard ? 'input[name="credit-cards"]:checked' : 'input[name="bank-accounts"]:checked');
      const paymentSource = method.val();
      if (!paymentSource || paymentSource === 'card-new' || paymentSource === 'ach-new' || method.prop('disabled')) {
        return null;
      }
      // A saved method can remain checked after switching to an invoice using a different provider.
      if (method.siblings('label.payment-method-option').attr('data-payment-provider') !== thisPaymentProvider) {
        return null;
      }
      return { invoiceId, paymentType, paymentSource };
    }

    function updateOneTimePaymentButton() {
      $('#one-time-payment .payment-checkout')
        .toggleClass('button-spinner', paymentSubmitting)
        .prop('disabled', paymentSubmitting || !getOneTimePaymentSelection());
    }

    updateOneTimePaymentButton();

    function buildOneTimeAchAuthorization(subscription) {
      const bankAccount = $('input[name="bank-accounts"]:checked');
      const settings = subscription?.billing_profile?.facility?.facilitySettings || {};
      const operatorLegalName = settings.achAuthorizationOperatorLegalName || 'the parking operator';
      const identifiers = [
        settings.achAuthorizationAccountLast4 && `Account ID ${settings.achAuthorizationAccountLast4}`,
        settings.achAuthorizationAbaLast4 && `ABA ${settings.achAuthorizationAbaLast4}`,
      ].filter(Boolean);
      const operatorDescription = `${operatorLegalName}${identifiers.length ? ` (${identifiers.join(', ')})` : ''}`;
      const accountType = String(bankAccount.data('account-type') || 'bank').toLowerCase();
      const amountInCents = Number($('#otp-payment-amount').val()) || 0;
      const effectiveDate = moment();

      return {
        authorizationType: 'One_Time',
        authorizationText: `This ACH transaction is governed by NACHA rules and regulations. I authorize ${operatorDescription} to electronically debit my ${accountType} account identified above for a one-time payment of $${(amountInCents / 100).toFixed(2)} on or after ${effectiveDate.format('M/D/YYYY')}. This authorization applies only to this payment and does not authorize recurring payments.`,
        accountType,
        amountInCents,
        effectiveDate: effectiveDate.format('YYYY-MM-DD'),
        recurrenceFrequency: null,
      };
    }

    function updateOneTimeAchAuthorization() {
      const usingAch = $('input[name="payment-types"]:checked').val() === 'bank-account';
      const bankAccount = $('input[name="bank-accounts"]:checked').val();
      const shouldShow = usingAch && bankAccount && bankAccount !== 'ach-new' && selectedSubscription;

      if (!shouldShow) {
        currentAchAuthorization = null;
        $('#ach-authorization').hide();
        $('#ach-authorization-acceptance').prop('checked', false);
        updateOneTimePaymentButton();
        return;
      }

      const nextAuthorization = buildOneTimeAchAuthorization(selectedSubscription);
      if (currentAchAuthorization?.authorizationText !== nextAuthorization.authorizationText) {
        $('#ach-authorization-acceptance').prop('checked', false);
      }
      currentAchAuthorization = nextAuthorization;
      $('#ach-authorization-text').text(currentAchAuthorization.authorizationText);
      $('#ach-authorization').show();
      updateOneTimePaymentButton();
    }

    $(document).on('ach-discount-updated', function () {
      updateTotals(thisCreditCardFeePrice, thisAchDiscountAmount);
      updateOneTimeAchAuthorization();
    });

    function getInvoicesBySubscription(subscriptionId) {
      var thisSubscription = subscriptionId;
      $('.card-content-overlay').addClass('card-content-overlay-active');
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          graphql_operation_name: 'get_invoices_by_subscription',
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: `
            query getSubscription($subscription_id: String!) {
                getSubscription(subscription_id: $subscription_id) {
                    id,
                    achDisabled,
                    allowCreditCardPayments,
                    auto_pay,
                    mail_invoices,
                    billing_profile_id,
                    billing_profile {
                        id,
                        facility {
                            id,
                            facility_name,
                            address,
                            timezone,
                            use_ach,
                            use_credit_card
                            payment_provider
                            facilitySettings {
                              achAuthorizationOperatorLegalName
                              achAuthorizationAccountLast4
                              achAuthorizationAbaLast4
                            }
                        }
                    },
                    parkers {
                        id,
                        first_name,
                        last_name
                    },
                    payor {
                        id,
                        cognito_sub,
                        billing_firstname,
                        billing_lastname
                    },
                    invoices {
                        id,
                        readable_id,
                        due_on,
                        balance,
                        parking_period_month,
                        parking_period_year
                    }
                }
          }`,
          graphql_variables: JSON.stringify({
            "subscription_id": thisSubscription
          })
        },
        success: function (results) {
          let { data, errors } = JSON.parse(results);
          if (errors) {
            $('#invoice').empty();
            $('.card-content-message').empty().text('Something went wrong. Please try again?');
          } else {
            if (data.getSubscription) {
              selectedSubscription = data.getSubscription;
              const { invoices, billing_profile, billing_profile_id, allowCreditCardPayments } = data.getSubscription;
              thisBillingProfile = billing_profile_id;
              displayAch = billing_profile.facility.use_ach;
              thisPaymentProvider = billing_profile.facility.payment_provider;
              if (data.getSubscription.billing_profile.facility.use_ach) {
                displayAch = !data.getSubscription.achDisabled
              }
              displayCreditCard = data.getSubscription.billing_profile.facility.use_credit_card && allowCreditCardPayments;
              // you have subscriptions!
              if (data.getSubscription.invoices.length > 0) {
                $('#invoice').empty();
                var defaultOption = '<option value="#" selected disabled>Choose One...</option>';
                $('#invoice').append(defaultOption);
                var invoicesWithBalance = 0;
                $(invoices).each(function () {
                  if (this.balance > 0) {
                    var invoiceDueDate = moment(this.due_on).utc().format('MM-DD-YYYY');
                    var invoiceAmountDue = Number(this.balance / 100).toFixed(2);
                    var parkingPeriodMonth = this.parking_period_month;
                    var parkingPeriodYear = this.parking_period_year;
                    var invoiceText = (parkingPeriodMonth && parkingPeriodYear) ? parkingPeriodMonth + ' ' + parkingPeriodYear : 'Carryover';
                    var option = '<option value="' + this.id + '"data-payment-provider="' + thisPaymentProvider + '" data-due-date="' + invoiceDueDate + '" data-amount-due="' + invoiceAmountDue + '">' + invoiceText + ' Invoice - $' + invoiceAmountDue + '</option>';
                    $('#invoice').append(option);
                    invoicesWithBalance = invoicesWithBalance + 1;
                  }
                });
                if (invoicesWithBalance > 0) {
                  $('#invoices').show();
                } else {
                  // you have no invoices with a balance
                  $('#invoice').empty();
                  $('.card-content-message').empty().text('There are no invoices with a balance for this subscription.');
                }

                if (thisInvoice) {
                  $('#invoice option[value="' + thisInvoice + '"]').prop('selected', true);

                  var invoiceAmountDue = $('#invoice option:selected').attr('data-amount-due');
                  var invoiceAmountDueCents = Math.round(invoiceAmountDue * 100);
                  thisInvoicePrice = invoiceAmountDueCents;

                  thisPaymentProvider = $('#invoice option:selected').attr('data-payment-provider');
                  var useSlidePay = thisPaymentProvider === '2';
                  
                  hidePaymentProviderPaymentMethods(thisPaymentProvider);

                  $('#invoice-amount').text(invoiceAmountDue);
                  $('#price').val(invoiceAmountDueCents);
                  $('#otp-payment-amount').val(invoiceAmountDueCents);
                  setupCurrencyMask(invoiceAmountDue);

                  // show payment options
                  $('#payment-types').show();

                  // show payment amount selector
                  if ($('#payment-amount').is(':hidden')) {
                    $('#payment-amount').show();
                  }

                  if (displayCreditCard) {
                    $('#credit-card-radio-button').show();

                    if (!$('#bank-account').is(':checked')) {
                      if ($('#card-new').is(':checked')) {
                        displayNewCardForm(useSlidePay);
                      }

                      $('#credit-card-fields').show();
                    } else {
                      hideBankAccountForms();
                    }
                  } else {
                    $('input[id=credit-card]').prop('checked', false);
                    $('#credit-card-radio-button').hide();
                    $('#credit-card-fields').hide();
                  }

                  if (displayAch) {
                    $('#ach-radio-button').show();
                  }

                  if ((displayCreditCard || displayAch)) {
                    $('#one-time-payment').show();
                  } else {
                    $('#one-time-payment').hide();
                  }

                  if (!displayCreditCard && !displayAch) {
                    $('#location-does-not-accept-online-payments').show();
                    $('#hide-choose-a-payment-type').hide();
                  } else {
                    $('#hide-choose-a-payment-type').show();
                    $('#location-does-not-accept-online-payments').hide();
                  }

                  // Show/hide credit card disclaimer and update total payment amount
                  getCreditCardFeePrice(thisBillingProfile, invoiceAmountDueCents, thisSubscription, invoiceAmountDue);

                  // Show/hide ACH discount based on eligibility
                  getAchDiscountEligibility(thisSubscription, thisInvoice);
                  updateOneTimeAchAuthorization();
                } else {
                  $('.card-content-overlay').removeClass('card-content-overlay-active');
                }
              } else {
                // you have no invoices
                $('#invoice').empty();
                $('.card-content-message').empty().text('You don\'t have any invoices to pay right now.');
                $('.card-content-overlay').removeClass('card-content-overlay-active');
              }
            } else {
              // error?
              $('.card-content-message').empty().text('You don\'t have any subscriptions.');
              $('.card-content-overlay').removeClass('card-content-overlay-active');
            }
          }
        },
        error: function () {
          // error
          $('.card-content-message').empty().text('You don\'t have any subscriptions.');
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        }
      });
    }

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'chirp_graphql',
        authorization: graphQLAuth,
        nonce: graphQLNonce,
        graphql_request: `
          query listUserSubscriptions($paymentProviderId: Int) {
              listUserSubscriptions(paymentProviderId: $paymentProviderId) {
                  id
                  account_id
                  billing_profile {
                      facility {
                          id
                          facility_name
                          address
                          timezone
                          uid
                      }
                  }
              }
          }
        `,
        graphql_variables: JSON.stringify(listUserSubscriptionsVariables())
      },
      success: function (results) {
        let { data, errors } = JSON.parse(results);
        console.log('success!', data);
        if (errors) {
          $('.card-content-message').empty().text('Something went wrong. Please try again?');
        } else {
          if (data && data.listUserSubscriptions.length > 0) {
            // you have subscriptions
            var subscriptions = data.listUserSubscriptions;
            // loop through subscriptions and add to dropdown
            $(subscriptions).each(function (index, subscription) {
              var facilityName = 'FACILITY NAME';
              var facilityId = '';
              if (subscription?.billing_profile?.facility) {
                facilityName = subscription?.billing_profile?.facility?.facility_name;
                facilityId = subscription?.billing_profile?.facility?.uid;
              }
              var option = '<option value="' + subscription.id + '" data-facility-id="' +
                facilityId + '">' + 'Monthly Parking at ' + facilityName +
                ' (AC-' + subscription.account_id + ')' + '</option>';
              $('#subscription').append(option);
            });
            if (subscriptions.length == 1) {
              // if you only have one subscription, automatically select it
              $('#subscription option:not([disabled])').prop('selected', true);
              var onlySubscription = $('#subscription option:selected').val();
              thisSubscription = onlySubscription;
              getInvoicesBySubscription(onlySubscription);
              window.history.replaceState('', '', '?subscription=' + onlySubscription);
            } else if (subscriptions.length > 1) {
              // if you have multiple subscriptions, choose from the dropdown
              if (thisSubscription) {
                $('#subscription option[value="' + thisSubscription + '"]').prop('selected', true);
                getInvoicesBySubscription(thisSubscription);
              } else {
                $('.card-content-overlay').removeClass('card-content-overlay-active');
              }
            }
          } else {
            $('#one-time-payment').hide();
            $('.card-content-message').empty().text('You don\'t have any subscriptions.');
            $('.card-content-overlay').removeClass('card-content-overlay-active');
          }
        }
      },
      error: function (results) {
        console.log('error!', results);
        $('#one-time-payment').hide();
        $('.card-content-message').empty().text('Something went wrong. Please try again?');
        $('.card-content-overlay').removeClass('card-content-overlay-active');
      }
    });

    /*** switching subscriptions ***/
    $('#subscription').change(function () {
      thisSubscription = this.value;
      // hide invoices dropdown
      $('#invoices').hide();
      // hide payment options
      displayAch = false;
      selectedSubscription = null;
      thisPaymentProvider = null;
      $('#invoice').empty();
      updateOneTimeAchAuthorization();
      $('#payment-types').hide();
      $('#bank-account-fields').hide();
      $('#ach-radio-button').hide();
      $('input[id="credit-card"]').prop('checked', true);
      $('#credit-card-fields').show();
      // clear error messages
      $('.card-content-message').empty();
      // update url
      var parameters = new URLSearchParams(window.location.search);
      parameters.set('subscription', thisSubscription);
      parameters.delete('invoice');
      thisInvoice = null;
      window.history.replaceState({}, '', location.pathname + '?' + parameters);
      // get invoices
      getInvoicesBySubscription(thisSubscription);

      // Show/hide ACH discount based on eligibility
      getAchDiscountEligibility(thisSubscription);
    });

    /*** switching invoices ***/
    $('#invoice').change(function () {
      hideBankAccountForms();
      var thisInvoice = this.value;

      // clear error messages
      $('.card-content-message').empty();

      // update price fields
      var invoiceAmountDue = $('option:selected', this).attr('data-amount-due');
      var invoiceAmountDueCents = Math.round(invoiceAmountDue * 100);
      thisInvoicePrice = invoiceAmountDueCents;
      $('#invoice-amount').text(invoiceAmountDue);
      $('#price').val(invoiceAmountDueCents);
      $('#otp-payment-amount').val(invoiceAmountDueCents);
      setupCurrencyMask(invoiceAmountDue);

      // get payment provider info
      thisPaymentProvider  = $('option:selected', this).attr('data-payment-provider');
      var useSlidePay = thisPaymentProvider === '2';

      hidePaymentProviderPaymentMethods(thisPaymentProvider);

      // update url
      var parameters = new URLSearchParams(window.location.search);
      parameters.set('invoice', thisInvoice);
      window.history.replaceState({}, '', location.pathname + '?' + parameters);

      // show payment options
      if ($('#payment-types').is(':hidden')) {
        $('#payment-types').show();
      }

      // show payment amount selector
      if ($('#payment-amount').is(':hidden')) {
        $('#payment-amount').show();
      }

      if (displayCreditCard) {
        $('#credit-card-radio-button').show();
        $('#credit-card-fields').show();

        if ($('#card-new').is(':checked')) {
          displayNewCardForm(useSlidePay);
        } else {
          $('#gpi-card-form-container').hide();
          $('#slidepay-card-form-container').hide();
          $('#new-credit-card-fields').hide();
        }
      } else {
        $('input[id=credit-card]').prop('checked', false);
        $('#credit-card-radio-button').hide();
        $('#credit-card-fields').hide();
      }

      if (displayAch) {
        $('#ach-radio-button').show();
      } else {
        $('#ach-radio-button').hide();
      }

      if (displayCreditCard || displayAch) {
        $('#one-time-payment').show();

        if ($('#bank-account').is(':checked')) {
          $('#credit-card-fields').hide();
        }

        if ($('#credit-card').is(':checked')) {
          $('#bank-account-fields').hide();
        }
      } else {
        $('#one-time-payment').hide();
      }

      if (!displayCreditCard && !displayAch) {
        $('#location-does-not-accept-online-payments').show();
        $('#hide-choose-a-payment-type').hide();
      } else {
        $('#hide-choose-a-payment-type').show();
        $('#location-does-not-accept-online-payments').hide();
      }

      // Show/hide credit card disclaimer
      getCreditCardFeePrice(
        thisBillingProfile,
        invoiceAmountDueCents,
        thisSubscription,
      );

      // Show/hide ACH discount based on eligibility
      getAchDiscountEligibility(thisSubscription, thisInvoice);
      updateOneTimeAchAuthorization();
    });

    $('input[name="payment-types"]').change(function () {
      if (this.value == 'credit-card') {
        $('#bank-account-fields').hide();
        $('#credit-card-fields').show();
      } else if (this.value == 'bank-account') {
        $('#credit-card-fields').hide();
        $('#bank-account-fields').show();
      } else {
        $('#credit-card-fields').hide();
        $('#bank-account-fields').hide();
      }

      updateTotals(thisCreditCardFeePrice, thisAchDiscountAmount);
      updateOneTimeAchAuthorization();
    });

    $('input[name="credit-cards"]').change(function () {
      if (this.value == 'card-new') {
        const useSlidePay = thisPaymentProvider === '2';
        displayNewCardForm(useSlidePay);
        $('#new-credit-card-fields').show();
      } else {
        $('#gpi-card-form-container').hide();
        $('#slidepay-card-form-container').hide();
        $('#new-credit-card-fields').hide();
      }
      updateOneTimePaymentButton();
    });

    $('input[name="bank-accounts"]').change(function () {
      if (this.value == 'ach-new') {
        const useSlidePay = thisPaymentProvider === '2';
        displayNewBankAccountForm(useSlidePay);
        $('#new-bank-account-fields').show();
      } else {
        hideBankAccountForms();
      }
      updateOneTimeAchAuthorization();
    });

    $('input[name="payment-amount"]').change(function() {
      if (this.value === 'full-balance') {
        $('#partial-amount-container').hide();
        $('#partial-amount-input').val(thisInvoicePrice);
        if (thisAchDiscountAmount > 0) {
          $('.bank-account-discount-notice').show();
        }
      } else {
        $('#partial-amount-container').show();
        $('.bank-account-discount-notice').hide();
      }

      getCreditCardFeePrice(
        thisBillingProfile,
        thisInvoicePrice,
        thisSubscription,
      );

      updateTotals(thisCreditCardFeePrice, thisAchDiscountAmount);
      updateOneTimeAchAuthorization();
    })

    $('input[name="partial-amount-input"]').change(function() {
      const amount = $(this).inputmask('unmaskedvalue') * 100;

      getCreditCardFeePrice(
        thisBillingProfile,
        amount,
        thisSubscription,
      );

      updateTotals(thisCreditCardFeePrice, thisAchDiscountAmount);
      updateOneTimeAchAuthorization();
    })

    /*** submit one-time payment ***/
    $('#one-time-payment').validate({
      errorElement: 'span',
      errorClass: 'form-field-error',
      validClass: 'form-field-valid',
      errorPlacement: function (error, element) {
        error.appendTo(element.parents('.form-field'));
      },
      highlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
      },
      rules: {
        'invoice': {
          required: true
        },
        'ach-authorization-acceptance': {
          required: function () {
            return $('#ach-authorization').is(':visible');
          }
        }
      },
      messages: {
        'invoice': {
          required: 'Please choose an invoice to pay.'
        },
        'ach-authorization-acceptance': {
          required: 'You must authorize the ACH debit before submitting.'
        }
      },
      submitHandler: function (form) {
        if (paymentSubmitting) {
          return;
        }
        const selection = getOneTimePaymentSelection();
        if (!selection) {
          $('.form-card-message', form).empty().addClass('form-card-message-error').text('Please select a payment type and a saved payment method.');
          updateOneTimePaymentButton();
          return;
        }
        const { invoiceId, paymentSource, paymentType } = selection;
        if (paymentType === 'bank-account' && (!$('#ach-authorization-acceptance').is(':checked') || !currentAchAuthorization)) {
          $('.form-card-message', form).empty().addClass('form-card-message-error').text('You must authorize the ACH debit before submitting.');
          return;
        }
        paymentSubmitting = true;
        updateOneTimePaymentButton();
        makePayment(invoiceId, paymentSource, paymentType, paymentType === 'bank-account' ? currentAchAuthorization : null, () => {
          paymentSubmitting = false;
          updateOneTimePaymentButton();
        });
      }
    });
  }

  /*** monthly :: recurring payments ***/
  if ($('body').hasClass('page-template-page-account-monthly-recurring-payments')) {

    /* get subscription id from url, if it exists */
    var thisSubscription = getUrlParameter('subscription');
    var thisBillingProfile = null;
    let displayAch = false;
    let displayCreditCard;
    let useSlidePay = false;
    let selectedSubscription = null;
    let currentAchAuthorization = null;

    function recurringAmountInCents(subscription) {
      const rates = subscription?.billing_profile?.rates || [];
      const parkers = subscription?.parkers || [];

      return parkers
        .filter(parker => parker.termination_status !== 'TERMINATED')
        .reduce((total, parker) => {
          const rate = rates.find(candidate => candidate.id === parker.rate_id);
          return total + Number(rate?.current_monthly_fee?.gross_price || 0);
        }, 0);
    }

    function nextRecurringPaymentDate(paymentDueDay) {
      const today = moment().startOf('day');
      const dayOfMonth = Number(paymentDueDay) || 1;
      const dateInMonth = month => month.clone().date(Math.min(dayOfMonth, month.daysInMonth()));
      const thisMonth = dateInMonth(today);

      return thisMonth.isAfter(today, 'day')
        ? thisMonth
        : dateInMonth(today.clone().add(1, 'month').startOf('month'));
    }

    function buildRecurringAchAuthorization(subscription) {
      const bankAccount = $('input[name="bank-accounts"]:checked');
      const settings = subscription?.billing_profile?.facility?.facilitySettings || {};
      const operatorLegalName = settings.achAuthorizationOperatorLegalName || 'the parking operator';
      const identifiers = [
        settings.achAuthorizationAccountLast4 && `Account ID ${settings.achAuthorizationAccountLast4}`,
        settings.achAuthorizationAbaLast4 && `ABA ${settings.achAuthorizationAbaLast4}`,
      ].filter(Boolean);
      const operatorDescription = `${operatorLegalName}${identifiers.length ? ` (${identifiers.join(', ')})` : ''}`;
      const accountType = String(bankAccount.data('account-type') || 'bank').toLowerCase();
      const amountInCents = recurringAmountInCents(subscription);
      const amountDescription = amountInCents > 0
        ? `$${(amountInCents / 100).toFixed(2)}`
        : 'the amount shown on each monthly invoice';
      const effectiveDate = nextRecurringPaymentDate(subscription?.billing_profile?.payment_due_day);
      const cancellationMethod = settings.achAuthorizationCancellationMethod || `contacting ${operatorLegalName}`;
      const revocationNoticeDays = settings.achAuthorizationRevocationNoticeDays ?? 5;

      return {
        authorizationType: 'Recurring',
        authorizationText: `This ACH transaction is governed by NACHA rules and regulations. I authorize ${operatorDescription} to electronically debit my ${accountType} account identified above in the amount of ${amountDescription}, beginning ${effectiveDate.format('M/D/YYYY')} and recurring each month. This authorization will remain in effect until I revoke it by ${cancellationMethod}. I understand that to revoke this authorization, ${operatorLegalName} must receive notice at least ${revocationNoticeDays} business days before the next scheduled debit to prevent that debit. If necessary, I also authorize ${operatorLegalName} to electronically credit my account to correct an erroneous debit.`,
        accountType,
        amountInCents,
        effectiveDate: effectiveDate.format('YYYY-MM-DD'),
        recurrenceFrequency: 'Monthly',
      };
    }

    function updateAchAuthorization() {
      const enablingRecurring = $('#recurring-payments-true').is(':checked');
      const usingAch = $('input[name="payment-types"]:checked').val() === 'bank-account';
      const bankAccount = $('input[name="bank-accounts"]:checked').val();
      const shouldShow = enablingRecurring && usingAch && bankAccount && bankAccount !== 'ach-new' && selectedSubscription;

      if (!shouldShow) {
        currentAchAuthorization = null;
        $('#ach-authorization').hide();
        $('#ach-authorization-acceptance').prop('checked', false);
        return;
      }

      const nextAuthorization = buildRecurringAchAuthorization(selectedSubscription);
      if (currentAchAuthorization?.authorizationText !== nextAuthorization.authorizationText) {
        $('#ach-authorization-acceptance').prop('checked', false);
      }
      currentAchAuthorization = nextAuthorization;
      $('#ach-authorization-text').text(currentAchAuthorization.authorizationText);
      $('#ach-authorization').show();
    }

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'chirp_graphql',
        authorization: graphQLAuth,
        nonce: graphQLNonce,
        graphql_request: `
          query listUserSubscriptions($paymentProviderId: Int) {
            listUserSubscriptions(paymentProviderId: $paymentProviderId) {
              id
              achDisabled
              allowCreditCardPayments
              account_id
              paymentMethod { 
                id 
              }
              auto_pay
              mail_invoices
              created_at
              billing_profile_id
              billing_profile { 
                payment_due_day
                rates {
                  id
                  current_monthly_fee { gross_price }
                }
                facility {
                  id
                  uid
                  facility_name
                  address
                  timezone 
                  use_ach
                  use_credit_card
                  payment_provider 
                  facilitySettings {
                    achAuthorizationOperatorLegalName
                    achAuthorizationAccountLast4
                    achAuthorizationAbaLast4
                    achAuthorizationCancellationMethod
                    achAuthorizationRevocationNoticeDays
                  }
                }
              } 
              parkers { rate_id termination_status }
              payor { 
                id
                cognito_sub
                billing_firstname
                billing_lastname
              }
            }
          }
        `,
        graphql_variables: JSON.stringify(listUserSubscriptionsVariables())
      },
      success: function (results) {
        const { data } = JSON.parse(results);

        if (data && data.listUserSubscriptions.length > 0) {
          /* if this user has subscriptions... */
          var subscriptions = data.listUserSubscriptions;

          $(subscriptions).each(function (_index, subscription) {
            var facilityName = 'FACILITY NAME';
            var facilityId = '';
            if (subscription.billing_profile.facility) {
              facilityName = subscription.billing_profile.facility.facility_name;
              facilityId = subscription.billing_profile.facility.uid;
            }
            var option = '<option value="' + subscription.id + '" data-facility-id="' +
              facilityId + '">' + 'Monthly Parking at ' + facilityName +
              ' (AC-' + subscription.account_id + ')' + '</option>';
            $('select[name="subscription"]').append(option);

            if (thisSubscription == subscription.id) {
              selectedSubscription = subscription;
              displayAch = subscription.billing_profile.facility.use_ach;
              if (subscription.billing_profile.facility.use_ach) {
                displayAch = !subscription.achDisabled
              }
              displayCreditCard = subscription.billing_profile.facility.use_credit_card && subscription.allowCreditCardPayments;
              thisBillingProfile = subscription.billing_profile_id;
              const facilityPaymentProvider = subscription.billing_profile.facility.payment_provider;
              useSlidePay = facilityPaymentProvider === 2;

              hidePaymentProviderPaymentMethods(facilityPaymentProvider.toString());

              /* set this subscription as 'selected' */
              $('#subscription option[value="' + subscription.id + '"]').prop('selected', true);

              /* show recurring payments fields */
              $('#recurring-payments-fields').show();

              /* check for `auto_pay` status */
              if (subscription.auto_pay == true) {

                /* set 'Enable Recurring Payments?' checkbox to TRUE */
                $('#recurring-payments-true').prop('checked', true);

                if (subscription.paymentMethod?.id) {
                  var found = false;
                  $('input[name="credit-cards"]').each(function () {
                    if ($(this).attr('id') == subscription.paymentMethod.id) {
                      $('#credit-card').prop('checked', true);
                      $('#credit-card-fields').show();
                      $('#bank-account-fields').hide();
                      $(this).prop('checked', true);
                      found = true;
                    }
                  });

                  if (!found) {
                    $('input[name="bank-accounts"]').each(function () {
                      if ($(this).attr('id') == subscription.paymentMethod.id) {
                        $('#bank-account').prop('checked', true);
                        $('#credit-card-fields').hide();
                        $('#bank-account-fields').show();
                        $(this).prop('checked', true);
                      }
                    });
                  }
                }

                /* show payment options fields */
                $('#payment-types').show();
                displayAch = subscription.billing_profile.facility.use_ach && !subscription.achDisabled;
                displayCreditCard = subscription.billing_profile.facility.use_credit_card && subscription.allowCreditCardPayments;
                if (!displayAch) {
                  $('#ach-radio-button').hide();
                  hideBankAccountForms();
                } else {
                  $('#ach-radio-button').show();
                }

                if (displayCreditCard) {
                  $('#credit-card-radio-button').show();

                  if (!$('#bank-account').is(':checked')) {
                    if ($('#card-new').is(':checked')) {
                      displayNewCardForm(useSlidePay);
                    }

                    $('#credit-card-fields').show();
                  } else {
                      hideBankAccountForms();
                  }
                } else {
                  $('input[id=credit-card]').prop('checked', false);
                  $('#credit-card-radio-button').hide();
                  $('#credit-card-fields').hide();
                }
                if (displayCreditCard || displayAch) {
                  $('#recurring-payments').show();
                } else {
                  $('#recurring-payments').hide();
                }
                
                if (!displayCreditCard && !displayAch) {
                  $('#location-does-not-accept-online-payments').show();
                  $('#hide-choose-a-payment-type').hide();
                } else {
                  $('#location-does-not-accept-online-payments').hide();
                  $('#hide-choose-a-payment-type').show();
                }

              } else if (subscription.auto_pay == false) {
                /* set 'Enable Recurring Payments?' checkbox to FALSE */
                $('#recurring-payments-true').prop('checked', false);

                /* hide payment options fields */
                $('#payment-types').hide();
              }
              updateAchAuthorization();
            }
          });

          if (subscriptions.length == 1) {
            $('#subscription option:not([disabled])').prop('selected', true);
            var subscription = subscriptions[0];
            selectedSubscription = subscription;
            thisSubscription = subscription.id;
            thisBillingProfile = subscription.billing_profile_id;
            displayAch = subscription.billing_profile.facility.use_ach && !subscription.achDisabled;
            displayCreditCard = subscription.billing_profile.facility.use_credit_card && subscription.allowCreditCardPayments;

            const facilityPaymentProvider = subscription.billing_profile.facility.payment_provider;
            useSlidePay = facilityPaymentProvider === 2;

            hidePaymentProviderPaymentMethods(facilityPaymentProvider.toString());

            /* show recurring payments fields */
            $('#recurring-payments-fields').show();

            /* check for `auto_pay` status */
            if (subscription.auto_pay == true) {

              /* set 'Enable Recurring Payments?' checkbox to TRUE */
              $('#recurring-payments-true').prop('checked', true);

              if (subscription.paymentMethod?.id) {
                var found = false;
                $('input[name="credit-cards"]').each(function () {
                  if ($(this).attr('id') == subscription.paymentMethod.id) {
                    $('#credit-card').prop('checked', true);
                    $('#credit-card-fields').show();
                    $('#bank-account-fields').hide();
                    $(this).prop('checked', true);
                    found = true;
                  }
                });

                if (!found) {
                  $('input[name="bank-accounts"]').each(function () {
                    if ($(this).attr('id') == subscription.paymentMethod.id) {
                      $('#bank-account').prop('checked', true);
                      $('#credit-card-fields').hide();
                      $('#bank-account-fields').show();
                      $(this).prop('checked', true);
                    }
                  });
                }
              }

              /* show payment options fields */
              $('#payment-types').show();
              if (!displayAch) {
                $('#ach-radio-button').hide();
                $('#bank-account-fields').hide();
              } else {
                $('#ach-radio-button').show();
              }
              if (displayCreditCard) {
                $('#credit-card-radio-button').show();

                if (!$('#bank-account').is(':checked')) {
                  $('#credit-card-fields').show();
                }
              } else {
                $('input[id=credit-card]').prop('checked', false);
                $('#credit-card-radio-button').hide();
                $('#credit-card-fields').hide();
              }
              if (displayCreditCard || displayAch) {
                $('#recurring-payments').show();
              } else {
                $('#recurring-payments').hide();
              }
              if (!displayCreditCard && !displayAch) {
                $('#location-does-not-accept-online-payments').show();
                $('#hide-choose-a-payment-type').hide();
              } else {
                $('#location-does-not-accept-online-payments').hide();
                $('#hide-choose-a-payment-type').show();
              }

            } else if (subscription.auto_pay == false) {

              /* set 'Enable Recurring Payments?' checkbox to FALSE */
              $('#recurring-payments-true').prop('checked', false);

              /* hide payment options fields */
              $('#payment-types').hide();

            }

            /* update url with new subscription id */
            window.history.replaceState('', '', '?subscription=' + subscription.id);
            updateAchAuthorization();
          }

          if (thisSubscription) {
            // Show/hide credit card disclaimer
            getCreditCardFeePrice(
              thisBillingProfile,
              100, // Since no payment is actually being made this can be any positive integer
              thisSubscription,
            );
          } else {
            /* remove loading overlay */
            $('.card-content-overlay').removeClass('card-content-overlay-active');
          }
        } else {

          /* this user has no subscriptions */
          /* inject error message */
          $('.card-content-message').text('You don\'t have any subscriptions.');

          /* remove loading overlay */
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        }
      },
      error: function () {
        /* inject error message */
        $('.card-content-message').text('Something went wrong. Try again?');

        /* remove loading overlay */
        $('.card-content-overlay').removeClass('card-content-overlay-active');
      }
    });

    /*** switching subscriptions ***/
    $('#subscription').change(function () {
      var thisSubscription = $(this).val();

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: `
            query getSubscription($subscription_id: String!) { 
              getSubscription(subscription_id: $subscription_id) { 
                id 
                paymentMethod { 
                  id 
                } 
                achDisabled 
                allowCreditCardPayments
                auto_pay 
                mail_invoices 
                billing_profile_id 
                billing_profile { 
                  payment_due_day
                  rates {
                    id
                    current_monthly_fee { gross_price }
                  }
                  facility { 
                    use_ach 
                    use_credit_card
                    payment_provider
                    facilitySettings {
                      achAuthorizationOperatorLegalName
                      achAuthorizationAccountLast4
                      achAuthorizationAbaLast4
                      achAuthorizationCancellationMethod
                      achAuthorizationRevocationNoticeDays
                    }
                  } 
                } 
                parkers { rate_id termination_status }
                payor { 
                  id 
                  cognito_sub 
                  billing_firstname 
                  billing_lastname 
                } 
              } 
            }
          `,
          graphql_variables: JSON.stringify({
            "subscription_id": thisSubscription
          })
        },
        success: function (results) {
          const { data } = JSON.parse(results);

          /* empty error message */
          $('.card-content-message').empty();
          $('.form-card-message').empty().removeClass('form-card-message-error')

          /* hide disclaimers */
          $('.credit-card-disclaimer').hide();
          $('.bank-account-disclaimer').hide();

          if (data.getSubscription) {
            var subscription = data.getSubscription;
            selectedSubscription = subscription;
            const facility = subscription.billing_profile.facility;

            displayAch = facility.use_ach && !subscription.achDisabled;
            displayCreditCard = subscription.billing_profile.facility.use_credit_card && subscription.allowCreditCardPayments;
            const facilityPaymentProvider = subscription.billing_profile.facility.payment_provider;
            useSlidePay = facilityPaymentProvider === 2;

            hidePaymentProviderPaymentMethods(facilityPaymentProvider.toString());

            /* show recurring payments fields */
            $('#recurring-payments-fields').show();

            // Show/hide credit card disclaimer
            getCreditCardFeePrice(
              subscription.billing_profile_id,
              100, // Since no payment is actually being made this can be any positive integer
              subscription.id,
            );

            /* check for `auto_pay` status */
            if (subscription.auto_pay == true) {

              /* set 'Enable Recurring Payments?' checkbox to TRUE */
              $('#recurring-payments-true').prop('checked', true);

              if (subscription.paymentMethod?.id) {
                var found = false;
                $('input[name="credit-cards"]').each(function () {
                  if ($(this).attr('id') == subscription.paymentMethod.id) {
                    $('#credit-card').prop('checked', true);
                    $('#credit-card-fields').show();
                    $('#bank-account-fields').hide();
                    $(this).prop('checked', true);
                    found = true;
                  }
                });

                if (!found) {
                  $('input[name="bank-accounts"]').each(function () {
                    if ($(this).attr('id') == subscription.paymentMethod.id) {
                      $('#bank-account').prop('checked', true);
                      $('#credit-card-fields').hide();
                      $('#bank-account-fields').show();
                      $(this).prop('checked', true);
                    }
                  });
                }
              }

              /* show payment options fields */
              $('#payment-types').show();

              hideBankAccountForms();

              if (!displayAch) {
                $('#ach-radio-button').hide();
                $('#bank-account-fields').hide();
              } else {
                $('#ach-radio-button').show();
              }

              if (displayCreditCard) {
                $('#credit-card-radio-button').show();

                if($('#card-new').is(':checked')) {
                  displayNewCardForm(useSlidePay);
                } else {
                  $('#credit-card-fields').hide();
                }

                if (!$('#bank-account').is(':checked')) {
                  $('#credit-card-fields').show();
                }
              } else {
                $('input[id=credit-card]').prop('checked', false);
                $('#credit-card-radio-button').hide();
                $('#credit-card-fields').hide();
              }

              if (displayCreditCard || displayAch) {
                $('#recurring-payments').show();
              } else {
                $('#recurring-payments').hide();
              }

              if (!displayCreditCard && !displayAch) {
                $('#location-does-not-accept-online-payments').show();
                $('#hide-choose-a-payment-type').hide();
              } else {
                $('#location-does-not-accept-online-payments').hide();
                $('#hide-choose-a-payment-type').show();
              }
            } else {
              /* set 'Enable Recurring Payments?' checkbox to FALSE */
              $('#recurring-payments-true').prop('checked', false);

              /* hide payment options fields */
              $('#payment-types').hide();
            }

            /* update url with new subscription id */
            window.history.replaceState('', '', '?subscription=' + thisSubscription);
            updateAchAuthorization();
          } else {
            /* inject error message */
            $('.card-content-message').text('You don\'t have any subscriptions.');

            /* remove loading overlay */
            $('.card-content-overlay').removeClass('card-content-overlay-active');
          }
        },
        error: function () {
          /* inject error message */
          $('.card-content-message').text('Something went wrong. Try again?');

          /* remove loading overlay */
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        }
      });
    });

    /* toggle recurring payment on/off */
    $('input[name="recurring-payments"]').change(function () {
      hideBankAccountForms();
      if ($(this).is(':checked')) {
        $('#payment-types').show();
        if (!displayAch) {
          $('#ach-radio-button').hide();
          $('#bank-account-fields').hide();
        } else {
          $('#ach-radio-button').show();
        }
        if (displayCreditCard) {
          $('#credit-card-radio-button').show();

          if (!$('#bank-account').is(':checked')) {
            $('#credit-card-fields').show();
          }
        } else {
          $('input[id=credit-card]').prop('checked', false);
          $('#credit-card-radio-button').hide();
          $('#credit-card-fields').hide();
        }
        if (!displayCreditCard && !displayAch) {
          $('#location-does-not-accept-online-payments').show();
          $('#hide-choose-a-payment-type').hide();
        } else {
          $('#location-does-not-accept-online-payments').hide();
          $('#hide-choose-a-payment-type').show();
        }
      } else {
        $('#payment-types').hide();
      }
      updateAchAuthorization();
    });

    $('input[name="payment-types"]').change(function () {
      if (this.value == 'credit-card') {
        $('#credit-card-fields').show();
        $('#bank-account-fields').hide();
        hideBankAccountForms();
      } else if (this.value == 'bank-account') {
        $('#credit-card-fields').hide();
        $('#bank-account-fields').show();
      } else {
        $('#credit-card-fields').hide();
        $('#bank-account-fields').hide();
        hideBankAccountForms();
      }
      updateAchAuthorization();
    });

    $('input[name="credit-cards"]').change(function () {
      if (this.value == 'card-new') {
        displayNewCardForm(useSlidePay);
        $('#new-credit-card-fields').show();
        $('#bank-account-fields').hide();
        hideBankAccountForms();
      } else {
        $('#gpi-card-form-container').hide();
        $('#slidepay-card-form-container').hide();
        $('#new-credit-card-fields').hide();
      }
    });

    $('input[name="bank-accounts"]').change(function () {
      if (this.value == 'ach-new') {
        displayNewBankAccountForm(useSlidePay);
        $('#new-bank-account-fields').show();
      } else {
        hideBankAccountForms();
      }
      $('#ach-authorization-acceptance').prop('checked', false);
      updateAchAuthorization();
    });

    /* save recurring payments settings */
    function saveRecurringPayment(subscriptionId, subscription, form) {
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          api_version: 'v2',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "mutation myAccountUpdateRecurringPayments($subscriptionId: String!, $autoPay: Boolean!, $paymentMethodId: Int, $achAuthorizationAcceptance: CheckoutAchAuthorizationAcceptanceInput) { myAccountUpdateRecurringPayments(subscriptionId: $subscriptionId, autoPay: $autoPay, paymentMethodId: $paymentMethodId, achAuthorizationAcceptance: $achAuthorizationAcceptance) }",
          graphql_variables: JSON.stringify({
            subscriptionId,
            autoPay: subscription.auto_pay,
            paymentMethodId: subscription.payment_method_id ? Number(subscription.payment_method_id) : null,
            achAuthorizationAcceptance: subscription.ach_authorization_acceptance || null,
          })
        },
        success: function (results) {
          const { errors } = JSON.parse(results);
          console.log('success!');
          if (errors) {
            $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(errors[0].message);
          } else {
            $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text('This subscription has been updated!');
          }

          $('.button-spinner', form).prop('disabled', false);
        },
        error: function () {
          $('.button-spinner', form).prop('disabled', false);
          $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(errorMessage);
        }
      });
    };

    $('#recurring-payments').validate({
      errorElement: 'span',
      errorClass: 'form-field-error',
      validClass: 'form-field-valid',
      errorPlacement: function (error, element) {
        error.appendTo(element.parents('.form-field'));
      },
      highlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
      },
      rules: {
        'subscription': {
          required: true
        },
        'payment-types': {
          required: {
            depends: function () {
              return $('input[name="recurring-payments"]').val() == true;
            }
          }
        },
        'credit-cards': {
          required: {
            depends: function () {
              return $('input[name="payment-types"]').val() == 'credit-card';
            }
          }
        },
        'bank-accounts': {
          required: {
            depends: function () {
              return $('input[name="payment-types"]').val() == 'bank-account';
            }
          }
        },
        'ach-authorization-acceptance': {
          required: {
            depends: function () {
              return $('#ach-authorization').is(':visible');
            }
          }
        }
      },
      messages: {
        'subscription': {
          required: 'Please choose a subscription.'
        },
        'payment-types': {
          required: 'Please choose a payment type.'
        },
        'credit-cards': {
          required: 'Please choose a credit card.'
        },
        'bank-accounts': {
          required: 'Please choose a bank account.'
        },
        'ach-authorization-acceptance': {
          required: 'You must accept the recurring ACH authorization.'
        }
      },
      submitHandler: function (form) {
        $('.button-spinner', form).prop('disabled', true);

        var subscriptionId = $('#subscription').val();
        var subscription = new Object();

        if ($('#recurring-payments-true').is(':checked')) {
          subscription.auto_pay = true;
          var paymentType = $('input[name="payment-types"]:checked').val();
          if (paymentType == 'credit-card') {
            var creditCard = $('input[name="credit-cards"]:checked').val();
            if (creditCard == 'card-new') {
              $('.form-card-message', form).empty().addClass('form-card-message-error').text('Please select a credit card');
              $('.button-spinner', form).prop('disabled', false);
            } else {
              subscription.payment_method_id = creditCard;
              saveRecurringPayment(subscriptionId, subscription, form);
            }
          } else if (paymentType == 'bank-account') {
            var bankAccount = $('input[name="bank-accounts"]:checked').val();
            if (bankAccount == 'ach-new') {
              $('.form-card-message', form).empty().addClass('form-card-message-error').text('Please select a bank account');
              $('.button-spinner', form).prop('disabled', false);
            } else if (!$('#ach-authorization-acceptance').is(':checked') || !currentAchAuthorization) {
              $('.form-card-message', form).empty().addClass('form-card-message-error').text('You must accept the recurring ACH authorization.');
              $('.button-spinner', form).prop('disabled', false);
            } else {
              subscription.payment_method_id = bankAccount;
              subscription.ach_authorization_acceptance = currentAchAuthorization;
              saveRecurringPayment(subscriptionId, subscription, form);
            }
          }
        } else {
          subscription.auto_pay = false;
          saveRecurringPayment(subscriptionId, subscription, form);
        }
      }
    });

  }

  /*** monthly :: account activity ***/
  if ($('body').hasClass('page-template-page-account-monthly-activity')) {

    var thisSubscription = getUrlParameter('subscription');
    var thisInvoice = getUrlParameter('invoice');
    var currentInvoiceAction = null;

    function clearInvoices(target) {
      $('.transactions-group', target).empty();
      $(target).hide();
    }

    function listInvoices(invoices, target, invoiceType) {
      var target = target;
      var invoices = invoices;
      var pastDueInvoiceIndex = 0;
      var today = moment().valueOf();
      $('.transactions-group', target).empty();
      if (invoices.length > 0) {
        $(target).show();
        $('.transactions-group', target).append('<ol />');
        $(invoices).each(function (index) {
          var invoiceDueDate = moment(this.due_on).utc().format('MMMM D, YYYY');
          var invoiceBalanceDue = Number(this.balance / 100).toFixed(2);
          var invoiceStatus = null;
          if (this.balance > 0 && today > moment(this.due_on).valueOf()) {
            invoiceStatus = 'Past Due';
          }
          var dataCyInvoiceType = invoiceStatus !== null ? 'past-due' : invoiceType
          var dataCyInvoiceIndex = invoiceStatus !== null ? pastDueInvoiceIndex : index
          var template = `<li class="transaction" data-cy="${dataCyInvoiceType}-invoice-${dataCyInvoiceIndex}">`;
          template += '<div class="transaction-title">';
          template += `<a href="?invoice=${this.id}" title="View Invoice # ${this.id}" data-cy="invoice-link">`;
          if (this.parking_period_month && this.parking_period_year) {
            var invoicePeriod = moment().month(this.parking_period_month).format('MMMM');
            var invoiceYear = this.parking_period_year;
            template += invoicePeriod + ' ' + invoiceYear + ' ';
          } else {
            template += 'Carryover' + ' ';
          }
          template += 'Invoice'
          template += '</a>';
          if (invoiceStatus != null) {
            template += ' <span class="transaction-status" data-cy="past-due-text">' + invoiceStatus + '<span>';
            pastDueInvoiceIndex++;
          }
          template += '</div>';
          template += '<div class="transaction-total" data-cy="invoice-value-text">$' + invoiceBalanceDue + '</div>';
          template += '<div class="transaction-meta">';
          template += '<div data-cy="invoice-due-date-text">Due: ' + invoiceDueDate + '</div>';
          template += '<div data-cy="invoice-number-text">Invoice #: ' + this.readable_id + '</div>';
          template += '</div>';
          template += '</li>';
          $('.transactions-group ol', target).append(template);
        });
      } else {
        $(target).hide();
      }
    }

    function listInvoicesBySubscription(subscriptionId) {
      var subscriptionId = subscriptionId;
      $('.card-content-overlay').addClass('card-content-overlay-active');
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "query getSubscription($subscription_id: String!) { getSubscription(subscription_id: $subscription_id) { id, invoices { id, readable_id, due_on, balance, parking_period_month, parking_period_year } } }",
          graphql_variables: JSON.stringify({
            "subscription_id": subscriptionId
          })
        },
        success: function (results) {

          let { data, errors } = JSON.parse(results);

          console.log('success!', data);
          if (errors) {
            clearInvoices('#invoices-unpaid');
            clearInvoices('#invoices-paid');
            $('.card-content-message').empty().text('Something went wrong. Try again?');
          } else {
            if (data.getSubscription.invoices.length > 0) {
              var invoices = data.getSubscription.invoices;
              var paidInvoices = new Array();
              var unpaidInvoices = new Array();
              $(invoices).each(function () {
                if (this.balance > 0) {
                  unpaidInvoices.push(this);
                } else {
                  paidInvoices.push(this);
                }
              });
              listInvoices(unpaidInvoices, '#invoices-unpaid', 'unpaid');
              listInvoices(paidInvoices, '#invoices-paid', 'paid');
            } else {
              clearInvoices('#invoices-unpaid');
              clearInvoices('#invoices-paid');
              $('.card-content-message').empty().text('This subscription has no invoices.');
            }
          }
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        },
        error: function (results) {
          console.log('error!', results);

          clearInvoices('#invoices-unpaid');
          clearInvoices('#invoices-paid');
          $('.card-content-message').empty().text('Something went wrong. Try again?');
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        }
      });
    }

    function getInvoicePDF(invoiceId) {
      var invoiceId = invoiceId;

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          api_version: 'v2',
          graphql_request: `
            query getInvoicePDFFromMyAccount($invoiceId: String!) {
              getInvoicePDFFromMyAccount(invoiceId: $invoiceId) {
                pdfUrl
              }
          }`,
          graphql_variables: JSON.stringify({
            invoiceId,
          }),
        },
        success: function (results) {
          const { data, errors } = JSON.parse(results);
          if (errors) {
            console.log(errors);
            return;
          }
          if (results) {
            downloadInvoicePDF(data);
          } else {
            $('.form-card-message').empty().text('Something went wrong. Try again?');
          }
          setInvoiceActionLoadingState(null);
        },
        error: function (results) {

          if (results.status == '200' && results.responseText.length > 0) {
            const { data, errors } = JSON.parse(results.responseText);
            if (errors) {
              console.log(errors);
              $('.form-card-message').empty().text('Something went wrong. Try again?');
              setInvoiceActionLoadingState(null);
              return;
            }
            downloadInvoicePDF(data);
          } else {
            $('.form-card-message').empty().text('Something went wrong. Try again?');
          }
          setInvoiceActionLoadingState(null);
        }
      });

    }

    function getInvoiceReceipt(groupId) {

      return new Promise(function (resolve, reject) {
        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_graphql',
            authorization: graphQLAuth,
            nonce: graphQLNonce,
            api_version: 'v2',
            graphql_request: `
              query getReceipt($groupId: Int!) {
                getReceipt(groupId: $groupId) {
                  pdf
                  fileName
                }
            }`,
            graphql_variables: JSON.stringify({
              groupId,
            }),
          },
          success: function (results) {
            const { data, errors } = JSON.parse(results);
            if (errors) {
              console.log(errors);
              reject(errors);
              return;
            }
            if (results) {
              resolve(data);
            } else {
              reject(new Error('No receipt returned.'));
            }
          },
          error: function (results) {

            if (results.status == '200' && results.responseText.length > 0) {
              const { data, errors } = JSON.parse(results.responseText);
              if (errors) {
                console.log(errors);
                reject(errors);
                return;
              }
              resolve(data);
            } else {
              reject(results);
            }
          }
        });
      });

    }

    function downloadInvoicePDF(content) {
      var content = content;
      var pdf = content.getInvoicePDFFromMyAccount.pdfUrl;
      var downloadLink = document.createElement('a');
      var fileName = 'invoice.pdf';
      downloadLink.href = pdf;
      downloadLink.target = '_blank';
      downloadLink.download = fileName;
      downloadLink.click();
    }

    function downloadInvoiceReceipt(content) {
      var content = content;
      var pdf = content.getReceipt.pdf;
      var fileName = content.getReceipt.fileName;
      var downloadLink = document.createElement('a');
      downloadLink.href = pdf;
      downloadLink.download = fileName;
      downloadLink.click();
    }

    function renderInvoiceReceiptButton(invoice) {
      var groupIds = [
        ...new Set(
          invoice.payments
            .map(function (payment) {
              return payment.payment_group_id;
            })
            .filter(Boolean)
        ),
      ];

      if (!groupIds.length) {
        $('#invoice-receipt-actions').empty();
        return;
      }

      var buttonLabel = groupIds.length > 1 ? 'Download Receipts' : 'Download Receipt';
      var button = $('<button />', {
        id: 'invoice-receipt',
        type: 'button',
        class: 'button invoice-action-button',
        text: buttonLabel,
        'data-cy': 'download-receipt-button',
      }).data('group-ids', groupIds);

      $('#invoice-receipt-actions')
        .empty()
        .append(button);
    }

    function setInvoiceActionLoadingState(action) {
      currentInvoiceAction = action;

      const isPdfLoading = action === 'pdf';
      const isReceiptLoading = action === 'receipt';

      $('#invoice-pdf')
        .prop('disabled', Boolean(action))
        .toggleClass('invoice-action-button-loading', isPdfLoading);

      $('#invoice-receipt')
        .prop('disabled', Boolean(action))
        .toggleClass('invoice-action-button-loading', isReceiptLoading);
    }

    let formatEntryValue = function (amount, type) {
      let formatedAmount = '$' + Number(amount / 100).toFixed(2);
      return ['CHARGE', 'REFUND'].includes(type) ? formatedAmount : '(' + formatedAmount + ')';
    }

    if (thisInvoice) {
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          graphql_operation_name: 'get_invoice',
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "query getInvoice($invoice_id: String!) { getInvoice(invoice_id: $invoice_id) { id, readable_id, subscription_id, type, due_on, balance, amount, notes, parking_period_month, parking_period_year, line_items { id, invoice_id, balance, adjusted_gross_amount, parker { id, first_name, last_name, group, vehicles, selected_start_date, selected_end_date }, rate { id, name }, fee { type }, entries { id, type, amount, amount_tax_1, amount_tax_2, amount_tax_3, amount_tax_4, gross_amount, payment_id } created_at }, subscription { id, payor { id, type, status, cognito_sub, billing_firstname, billing_lastname, billing_street, billing_city, billing_state, billing_zip, billing_phone, billing_email } }, parkers { id, first_name, last_name, email }, payments { id, type, payment_meta, amount, payment_group_id } } }",
          graphql_variables: JSON.stringify({
            "invoice_id": thisInvoice
          })
        },
        success: function (results) {

          let { data, errors } = JSON.parse(results);

          console.log('success!', data);
          if (errors) {

            console.log('invoice not found?');

          } else {

            var invoice = data.getInvoice;
            renderInvoiceReceiptButton(invoice);

            var invoiceDueDate = moment(invoice.due_on).utc().format('MM/DD/YYYY');

            let formattedTitle = 'Invoice';
            if (invoice.parking_period_month && invoice.parking_period_year) {
              formattedTitle = moment().month(invoice.parking_period_month).format('MMMM') + ' ' + invoice.parking_period_year + ' Invoice';
            } else {
              formattedTitle = 'Carryover Invoice';
            }
            $('.card-header-title').text(formattedTitle);
            $('.invoice-due-on').text(invoiceDueDate);
            $('.invoice-id').text(invoice.readable_id);
            $('.invoice-balance').text('$' + Number(invoice.balance / 100).toFixed(2))

            var content = '<p data-cy="billing-address-text">' +
              '<strong>Bill To:</strong><br />' +
              invoice.subscription.payor.billing_firstname + ' ' + invoice.subscription.payor.billing_lastname + '<br/>' +
              invoice.subscription.payor.billing_street + '<br/>' +
              invoice.subscription.payor.billing_city + ', ' + invoice.subscription.payor.billing_state + ' ' + invoice.subscription.payor.billing_zip + '<br/>' +
              invoice.subscription.payor.billing_phone + '<br/>' +
              invoice.subscription.payor.billing_email +
              '</p>';

            if (invoice.line_items.length > 0) {

              content += '<div class="invoice-line-items">';
              invoice.line_items.forEach(function (item) {
                let title = '';
                if (item.fee) {
                  if (item.fee.name) {
                    title += item.fee.name;
                  } else {
                    title += item.fee.type + ' Fee';
                  }
                } else if (invoice.type === 'CARRYOVER_INVOICE') {
                  title += 'Carryover';
                } else if (invoice.type === 'VALIDATION_INVOICE') {
                  title += 'Validation'
                }

                let selected_dates = '';
                if (item.parker) {
                  title += ' for ' + item.parker.first_name + ' ' + item.parker.last_name;
                }

                let start_date = item.parker && item.parker.selected_start_date ? moment.utc(item.parker.selected_start_date, 'x').format('MM/DD/YYYY') : null;
                let end_date = item.parker && item.parker.selected_end_date ? moment.utc(item.parker.selected_end_date, 'x').format('MM/DD/YYYY') : null;
                if (start_date || end_date) {
                  selected_dates += `<strong data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-charge-selected-dates">Selected Dates:</strong> ` + start_date + ' to ' + end_date;
                }

                content +=
                  '<div class="invoice-line-item">' +
                  '<p>' +
                  `<strong data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-charge-title-text">` + title + '</strong><br />' +
                  `<strong data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-charge-creation-date">Created:</strong> ` + moment(item.created_at, 'x').format('MM/DD/YYYY') + '<br />' +
                  selected_dates
                '</p>';

                content +=
                  '<table>' +
                  '<thead>' +
                  '<tr>' +
                  '<th>Type</th>' +
                  '<th>Net</th>' +
                  '<th>Tax #1</th>' +
                  '<th>Tax #2</th>' +
                  '<th>Tax #3</th>' +
                  '<th>Tax #4</th>' +
                  '<th>Total</th>' +
                  '</tr>' +
                  '</thead>' +
                  '<tbody>';

                item.entries.forEach(function (entry) {
                  content +=
                    '<tr>' +
                    `<td data-title="Type" data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-${GetSlugFromStr(lineItemEntryTypeMap[entry.type])}-charge-type-text">` + lineItemEntryTypeMap[entry.type] + '</td>' +
                    `<td data-title="Net" data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-${GetSlugFromStr(lineItemEntryTypeMap[entry.type])}-net-value-text">` + formatEntryValue(entry.amount, entry.type) + '</td>' +
                    `<td data-title="Tax #1" data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-${GetSlugFromStr(lineItemEntryTypeMap[entry.type])}-tax-1-text">` + formatEntryValue(entry.amount_tax_1, entry.type) + '</td>' +
                    `<td data-title="Tax #2" data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-${GetSlugFromStr(lineItemEntryTypeMap[entry.type])}-tax-2-text">` + formatEntryValue(entry.amount_tax_2, entry.type) + '</td>' +
                    `<td data-title="Tax #3" data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-${GetSlugFromStr(lineItemEntryTypeMap[entry.type])}-tax-3-text">` + formatEntryValue(entry.amount_tax_3, entry.type) + '</td>' +
                    `<td data-title="Tax #4" data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-${GetSlugFromStr(lineItemEntryTypeMap[entry.type])}-tax-4-text">` + formatEntryValue(entry.amount_tax_4, entry.type) + '</td>' +
                    `<td data-title="Total" data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-${GetSlugFromStr(lineItemEntryTypeMap[entry.type])}-charge-total-text">` + formatEntryValue(entry.gross_amount, entry.type) + '</td>' +
                    '</tr>';
                });

                content +=
                  '</tbody>' +
                  '</table>' +
                  '</div>';
              });
              content += '</div>';
            }
            if (invoice.balance > 0) {
              var footer = '<a href="/account/monthly/one-time-payment/?subscription=' + invoice.subscription_id + '&invoice=' + invoice.id + '" title="Pay Invoice #' + invoice.readable_id + '" class="button button-green" data-cy="submit-button">Pay This Invoice</a>';
              $('.invoice-footer').prepend(footer).show();
            }

            $('.invoice-content').append(content);

          }

          $('.card-content-overlay').removeClass('card-content-overlay-active');

        },
        error: function (results) {
          console.log('error!', results);
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        }
      });

    } else {
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "query listUserSubscriptions($paymentProviderId: Int) { listUserSubscriptions(paymentProviderId: $paymentProviderId) { id, account_id, billing_profile { facility { id, facility_name, address, timezone } } } }",
          graphql_variables: JSON.stringify(listUserSubscriptionsVariables())
        },
        success: function (results) {

          let { data, errors } = JSON.parse(results);

          console.log('success!', data);
          if (errors) {
            $('.card-content-message').empty().text('Something went wrong. Try again?');
          } else {
            if (data && data.listUserSubscriptions.length > 0) {
              // you have subscriptions
              var subscriptions = data.listUserSubscriptions;
              $(subscriptions).each(function (index, subscription) {
                var facilityName = 'FACILITY NAME';
                if (subscription.billing_profile.facility) {
                  facilityName = subscription.billing_profile.facility.facility_name;
                }
                var option = '<option value="' + subscription.id + '">' + 'Monthly Parking at ' + facilityName + ' (AC-' + subscription.account_id + ')' + '</option>';
                $('#subscription').append(option);
              });
              if (thisSubscription) {
                $('#subscription option[value="' + thisSubscription + '"]').prop('selected', true);
                listInvoicesBySubscription(thisSubscription);
              } else if (subscriptions.length == 1) {
                $('#subscription option:not([disabled])').prop('selected', true);
                var onlySubscription = $('#subscription option:selected').val();
                listInvoicesBySubscription(onlySubscription);
                window.history.replaceState('', '', '?subscription=' + onlySubscription);
              } else {
                $('.card-content-overlay').removeClass('card-content-overlay-active');
              }
            } else {
              // you have no subscriptions
              $('.card-content-message').empty().text('You don\'t have any subscriptions.');
              $('.card-content-overlay').removeClass('card-content-overlay-active');
            }
          }
        },
        error: function (results) {
          console.log('error!', results);
          $('.card-content-message').empty().text('Something went wrong. Try again?');
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        }
      });

    }

    $('#subscription').change(function () {
      var thisSubscription = this.value;
      var parameters = new URLSearchParams(window.location.search);
      parameters.set('subscription', thisSubscription);
      parameters.delete('invoice');
      window.history.replaceState({}, '', location.pathname + '?' + parameters);
      listInvoicesBySubscription(thisSubscription);
    });

    $('#invoice-pdf').on('click', function () {
      if (currentInvoiceAction) {
        return;
      }

      setInvoiceActionLoadingState('pdf');
      var invoiceId = getUrlParameter('invoice');
      getInvoicePDF(invoiceId);
    });

    $(document).on('click', '#invoice-receipt', async function () {
      if (currentInvoiceAction) {
        return;
      }

      var groupIds = $(this).data('group-ids');

      if (!groupIds || !groupIds.length) {
        $('.form-card-message').empty().text('Receipt unavailable for this invoice.');
        return;
      }

      setInvoiceActionLoadingState('receipt');
      const receiptResults = await Promise.allSettled(
        groupIds.map(function (groupId) {
          return getInvoiceReceipt(Number(groupId));
        }),
      );

      var hasErrors = false;
      receiptResults.forEach(function (result) {
        if (result.status === 'fulfilled') {
          downloadInvoiceReceipt(result.value);
          return;
        }

        hasErrors = true;
      });

      if (hasErrors) {
        $('.form-card-message').empty().text('One or more receipts could not be downloaded.');
      }

      setInvoiceActionLoadingState(null);
    });

  }

  /*** monthly :: billing information ***/
  if ($('body').hasClass('page-template-page-account-monthly-billing')) {

    var thisSubscription = getUrlParameter('subscription');
    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'chirp_graphql',
        authorization: graphQLAuth,
        nonce: graphQLNonce,
        graphql_request: "query listUserSubscriptions($paymentProviderId: Int) { listUserSubscriptions(paymentProviderId: $paymentProviderId) { id, account_id, billing_profile { facility { id, facility_name, address, timezone } } } }",
        graphql_variables: JSON.stringify(listUserSubscriptionsVariables())
      },
      success: function (results) {
        let { data } = JSON.parse(results);

        if (data && data.listUserSubscriptions.length > 0) {
          var subscriptions = data.listUserSubscriptions;

          $(subscriptions).each(function (index, subscription) {
            var facilityName = 'FACILITY NAME';
            if (subscription.billing_profile.facility) {
              facilityName = subscription.billing_profile.facility.facility_name;
            }
            var option = '<option value="' + subscription.id + '">' + 'Monthly Parking at ' + facilityName + ' (AC-' + subscription.account_id + ')' + '</option>';
            $('select[name="subscription"]').append(option);

            if (thisSubscription == subscription.id || subscriptions.length == 1) {

              if (thisSubscription == subscription.id) {
                $('#subscriptions option[value="' + subscription.id + '"]').prop('selected', true);
              } else if (subscriptions.length == 1) {
                $('#subscription option:not([disabled])').prop('selected', true);
                thisSubscription = $('#subscription option:selected').val();
              }

              $.ajax({
                type: 'post',
                url: '/wp-admin/admin-ajax.php',
                data: {
                  action: 'chirp_graphql',
                  authorization: graphQLAuth,
                  nonce: graphQLNonce,
                  graphql_request: "query getSubscription($subscription_id: String!) { getSubscription(subscription_id: $subscription_id) { id, payor { id, type, status, contact_notes, cognito_sub, billing_firstname, billing_lastname, billing_phone, billing_email, billing_street, billing_city, billing_state, billing_zip, info_name, info_attn, info_street, info_city, info_state, info_zip, created_at, updated_at } } }",
                  graphql_variables: JSON.stringify({
                    "subscription_id": thisSubscription
                  })
                },
                success: function (results) {

                  let { data, errors } = JSON.parse(results);

                  console.log('success!', data);

                  $('#subscription option[value="' + data.getSubscription.id + '"]').prop('selected', true);

                  var payor = data.getSubscription.payor;

                  $('#payor-fields').show();

                  $('#payor-id').val(payor.id);
                  $('#payor-type').val(payor.type);
                  $('#first-name').val(payor.billing_firstname);
                  $('#last-name').val(payor.billing_lastname);
                  $('#email-address').val(payor.billing_email);
                  $('#phone-number').val(payor.billing_phone);
                  $('#street-address').val(payor.billing_street);
                  $('#city').val(payor.billing_city);
                  $('#state').val(payor.billing_state);
                  $('#zip-code').val(payor.billing_zip);

                  if (payor.info_name || payor.info_attn || payor.info_street || payor.info_city || payor.info_state || payor.info_zip) {

                    $('#show-business-information').prop('checked', true);
                    $('#business-information').show();
                    $('#business-name').val(payor.info_name);
                    $('#business-attention').val(payor.info_attn);
                    $('#business-address').val(payor.info_street);
                    $('#business-city').val(payor.info_city);
                    $('#business-state').val(payor.info_state);
                    $('#business-zip-code').val(payor.info_zip);

                  } else {

                    $('#show-business-information').prop('checked', false);
                    $('#business-information').hide();
                    $('#business-information input').removeAttr('value');

                  }

                  if (payor.type == 'BUSINESS') {

                    $('#contact-information-checkbox').show();
                    $('#business-attention').parent('.form-field').show();

                    $('#show-contact-information').prop('checked', false);
                    $('#contact-information').hide();
                    $('#contact-information input').removeAttr('value');

                  } else {

                    $('#contact-information-checkbox').hide();
                    $('#business-attention').parent('.form-field').hide();

                  }

                  window.history.replaceState('', '', '?subscription=' + thisSubscription);
                  $('.card-content-overlay').removeClass('card-content-overlay-active');

                },
                error: function (results) {
                  console.log('error!', results);
                  $('.card-content-overlay').removeClass('card-content-overlay-active');
                }
              });

            } else {
              $('.card-content-overlay').removeClass('card-content-overlay-active');
            }
          });

        } else {

          $('.card-content').append('<div class="card-content-error">You don\'t have any subscriptions.</div>');
          $('.card-content-overlay').removeClass('card-content-overlay-active');

        }

      },
      error: function (results) {
        console.log(results);
      }
    });

    $('#subscription').change(function () {

      var thisSubscription = this.value;
      $('.card-content-overlay').addClass('card-content-overlay-active');

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "query getSubscription($subscription_id: String!) { getSubscription(subscription_id: $subscription_id) { id, payor { id, type, status, contact_notes, cognito_sub, billing_firstname, billing_lastname, billing_phone, billing_email, billing_street, billing_city, billing_state, billing_zip, info_name, info_attn, info_street, info_city, info_state, info_zip, created_at, updated_at } } }",
          graphql_variables: JSON.stringify({
            "subscription_id": thisSubscription
          })
        },
        success: function (results) {

          let { data, errors } = JSON.parse(results);

          console.log('success!', data);

          $('#subscription option[value="' + data.getSubscription.id + '"]').prop('selected', true);

          var payor = data.getSubscription.payor;

          $('#payor-fields').show();

          $('#payor-id').val(payor.id);
          $('#payor-type').val(payor.type);
          $('#first-name').val(payor.billing_firstname);
          $('#last-name').val(payor.billing_lastname);
          $('#email-address').val(payor.billing_email);
          $('#phone-number').val(payor.billing_phone);
          $('#street-address').val(payor.billing_street);
          $('#city').val(payor.billing_city);
          $('#state').val(payor.billing_state);
          $('#zip-code').val(payor.billing_zip);

          if (payor.info_name || payor.info_attn || payor.info_street || payor.info_city || payor.info_state || payor.info_zip) {

            $('#show-business-information').prop('checked', true);
            $('#business-information').show();
            $('#business-name').val(payor.info_name);
            $('#business-attention').val(payor.info_attn);
            $('#business-address').val(payor.info_street);
            $('#business-city').val(payor.info_city);
            $('#business-state').val(payor.info_state);
            $('#business-zip-code').val(payor.info_zip);

          } else {

            $('#show-business-information').prop('checked', false);
            $('#business-information').hide();
            $('#business-information input').removeAttr('value');

          }

          if (payor.type == 'BUSINESS') {

            $('#contact-information-checkbox').show();
            $('#business-attention').parent('.form-field').show();

            $('#show-contact-information').prop('checked', false);
            $('#contact-information').hide();
            $('#contact-information input').removeAttr('value');

          } else {

            $('#contact-information-checkbox').hide();
            $('#business-attention').parent('.form-field').hide();

          }

          window.history.replaceState('', '', '?subscription=' + thisSubscription);
          $('.card-content-overlay').removeClass('card-content-overlay-active');

        },
        error: function (results) {
          console.log('error!', results);
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        }
      });

    });

    // toggle alternate contact information fields
    $('#show-contact-information').change(function () {
      if ($(this).is(':checked')) {
        $('#contact-information').show();
      } else {
        $('#contact-information').hide();
      }
    });
    $('#show-business-information').change(function () {
      if ($(this).is(':checked')) {
        $('#business-information').show();
      } else {
        $('#business-information').hide();
      }
    });

    // update billing information
    $('#update-payor').validate({
      // debug: true,
      errorElement: 'span',
      errorClass: 'form-field-error',
      validClass: 'form-field-valid',
      errorPlacement: function (error, element) {
        error.appendTo(element.parent('.form-field'));
      },
      highlight: function (element, errorClass, validClass) {
        $(element).parent('.form-field').addClass(errorClass).removeClass(validClass);
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).parent('.form-field').removeClass(errorClass).addClass(validClass);
      },
      rules: {
        'subscription': {
          required: true
        },
        'first-name': {
          required: true,
          minlength: 2
        },
        'last-name': {
          required: true,
          minlength: 2
        },
        'email-address': {
          required: true,
          email: true
        },
        'phone-number': {
          required: true,
          phoneUS: true
        },
        'street-address': {
          required: true,
          minlength: 2
        },
        'city': {
          required: true,
          minlength: 2
        },
        'state': {
          required: true,
        },
        'zip-code': {
          required: true,
          zipcodeUS: true
        }
      },
      messages: {
        'subscription': {
          required: 'Please choose a subscription.'
        },
        'first-name': {
          required: 'Please enter your first name.',
          minlength: 'Your first name must be at least 2 characters long.'
        },
        'last-name': {
          required: 'Please enter your last name.',
          minlength: 'Your last name must be at least 2 characters long.'
        },
        'email-address': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.'
        },
        'phone-number': {
          required: 'Please enter your phone number.',
          phoneUS: 'Please enter a valid phone number.'
        },
        'street-address': {
          required: 'Please enter your street address.',
          minlength: '2'
        },
        'city': {
          required: 'Please enter your city.',
          minlength: '2'
        },
        'state': {
          required: 'Please enter your state.',
        },
        'zip-code': {
          required: 'Please enter your zip code.',
          zipcodeUS: 'Please enter a valid zip code. '
        }
      },
      submitHandler: function (form) {

        $('.button-spinner', form).prop('disabled', true);

        var payor = new Object();
        payor.id = $('#payor-id').val();
        payor.type = $('#payor-type').val();
        payor.billing_firstname = $('#first-name').val();
        payor.billing_lastname = $('#last-name').val();
        payor.billing_phone = $('#phone-number').val();
        payor.billing_street = $('#street-address').val();
        payor.billing_city = $('#city').val();
        payor.billing_state = $('#state').val();
        payor.billing_zip = $('#zip-code').val();

        if ($('#show-business-information').is(':checked')) {
          payor.billing_company_name = $('#business-name').val();
          payor.billing_attn = $('#business-attention').val();
          payor.info_street = $('#business-address').val();
          payor.info_city = $('#business-city').val();
          payor.info_state = $('#business-state').val();
          payor.info_zip = $('#business-zip-code').val();
        }

        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_graphql',
            authorization: graphQLAuth,
            nonce: graphQLNonce,
            graphql_request: 'mutation updatePayor($payor: UpdatePayorInput!) { updatePayor(payor: $payor) { id, type, status, contact_notes, cognito_sub, billing_firstname, billing_lastname, billing_phone, billing_email, billing_street, billing_city, billing_state, billing_zip, billing_company_name, billing_attn, info_street, info_city, info_state, info_zip, created_at, updated_at } }',
            graphql_variables: JSON.stringify({
              'payor': payor
            })
          },
          success: function (results) {

            let { data, errors } = JSON.parse(results);

            console.log('success!', data);

            if (data.updatePayor) {

              $('.button-spinner', form).prop('disabled', false);
              $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(payor.billing_firstname + ' ' + payor.billing_lastname + '\'s profile has been updated!');

            } else {

              $('.button-spinner', form).prop('disabled', false);
              $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text('Something went wrong? Please try again.');

            }

          },
          error: function (results) {
            console.log('error!', results);
            $('.button-spinner', form).prop('disabled', false);
            $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text('Something went wrong? Please try again.');
          }
        });

      }
    });
  }

  /*** monthly :: manage parkers ***/
  if ($('body').hasClass('page-template-page-account-monthly-parkers')) {
    function surveyQuestionFunctionality() {

      var form = $('#termination-survey');

      // show 'next question' when you choose the corresponding select option
      $(form).on('change', '.form-field-parent select', function () {
        var question = this.name;
        var id = $('option:selected', this).attr('id');
        $('.form-field-child[data-parent-question="' + question + '"]').hide();
        $('.form-field-child[data-parent-option="' + id + '"]').show();
      });

      // show 'next question' when you choose the corresponding radio button
      $(form).on('change', '.form-field-parent input[type="radio"]', function () {
        var question = this.name;
        var id = this.id;
        $('.form-field-child[data-parent-question="' + question + '"]').hide();
        $('.form-field-child[data-parent-option="' + id + '"]').show();
      });

    }

    function surveyQuestions(questions, type, target) {

      var questions = questions;
      var type = type;

      // get templates from html
      var radioTemplate = $('#termination-survey-radio').html();
      var radioButtonTemplate = $('#termination-survey-radio-button').html();
      var selectTemplate = $('#termination-survey-select').html();
      var selectOptionTemplate = $('#termination-survey-select-option').html();
      var textTemplate = $('#termination-survey-text').html();

      // loop through questions and apply correct template
      $(questions).each(function (index) {
        if (this.type == type) {
          var questionCount = index;
          var nextQuestions = new Array();
          var nextQuestionCount = 0;
          if (this.structure.type == 'RADIO') {
            var question = $(radioTemplate);
            question.addClass('form-field-parent');
            $('.prompt', question).text(this.structure.prompt);
            $(this.structure.options).each(function (index) {
              var optionCount = index;
              var option = $(radioButtonTemplate);
              $('input[type="radio"]', option).attr({ name: 'question-' + questionCount, id: 'question-' + questionCount + '-option-' + optionCount, value: this.response });
              $('.radio-button-label', option).attr('for', 'question-' + questionCount + '-option-' + optionCount).text(this.response);
              if (optionCount == 0) {
                $('input[type="radio"]', option).prop('checked', true);
              }
              $('.radio-buttons-group', question).append(option);
              if (this.next_question) {
                if (this.next_question.type == 'RADIO') {
                  var nextQuestion = $(radioTemplate);
                  $(nextQuestion).addClass('form-field-child form-field-optional').attr({ 'data-parent-question': 'question-' + questionCount, 'data-parent-option': 'question-' + questionCount + '-option-' + optionCount });
                  if (optionCount == 0) {
                    $(nextQuestion).css('display', 'block');
                  }
                  $('.prompt', nextQuestion).text(this.next_question.prompt);
                  $(this.next_question.options).each(function (index) {
                    var optionCount = index;
                    var option = $(radioButtonTemplate);
                    $('input[type="radio"]', option).attr({ name: 'question-' + questionCount + '-' + nextQuestionCount, id: 'question-' + questionCount + '-' + nextQuestionCount + '-option-' + optionCount, value: this.response });
                    $('.radio-button-label', option).attr('for', 'question-' + questionCount + '-' + nextQuestionCount + '-option-' + optionCount).text(this.response);
                    if (optionCount == 0) {
                      $('input[type="radio"]', option).prop('checked', true);
                    }
                    $('.radio-buttons-group', nextQuestion).append(option);
                  });
                  nextQuestions.push(nextQuestion);
                } else if (this.next_question.type == 'SELECT') {
                  var nextQuestion = $(selectTemplate);
                  $(nextQuestion).addClass('form-field-child form-field-optional').attr({ 'data-parent-question': 'question-' + questionCount, 'data-parent-option': 'question-' + questionCount + '-option-' + optionCount });
                  if (optionCount == 0) {
                    $(nextQuestion).css('display', 'block');
                  }
                  $('.prompt', nextQuestion).text(this.next_question.prompt).attr('for', 'question-' + questionCount + '-' + nextQuestionCount);
                  $('select', nextQuestion).attr('name', 'question-' + questionCount + '-' + nextQuestionCount).attr('id', 'question-' + questionCount + '-' + nextQuestionCount);
                  $(this.next_question.options).each(function (index) {
                    var option = $(selectOptionTemplate);
                    $(option).attr('value', this.response).text(this.response);
                    $('select', nextQuestion).append(option);
                  });
                  nextQuestions.push(nextQuestion);
                } else if (this.next_question.type == 'TEXT') {
                  var nextQuestion = $(textTemplate);
                  $(nextQuestion).addClass('form-field-child form-field-optional').attr({ 'data-parent-question': 'question-' + questionCount, 'data-parent-option': 'question-' + questionCount + '-option-' + optionCount });
                  if (optionCount == 0) {
                    $(nextQuestion).css('display', 'block');
                  }
                  $('.prompt', nextQuestion).text(this.next_question.prompt).attr('for', 'question-' + questionCount + '-' + nextQuestionCount);
                  $('input[type="text"]', nextQuestion).attr({ name: 'question-' + questionCount + '-' + nextQuestionCount, id: 'question-' + questionCount + '-' + nextQuestionCount });
                  nextQuestions.push(nextQuestion);
                }
                nextQuestionCount++;
              }
            });
          } else if (this.structure.type == 'SELECT') {
            var question = $(selectTemplate);
            question.addClass('form-field-parent');
            $('.prompt', question).text(this.structure.prompt).attr('for', 'question-' + questionCount);
            $('select', question).attr('name', 'question-' + questionCount).attr('id', 'question-' + questionCount);
            $(this.structure.options).each(function (index) {
              var optionCount = index;
              var option = $(selectOptionTemplate);
              $(option).attr({ value: this.response, id: 'question-' + questionCount + '-option-' + optionCount }).text(this.response);
              $('select', question).append(option);
              if (this.next_question) {
                if (this.next_question.type == 'RADIO') {
                  var nextQuestion = $(radioTemplate);
                  $(nextQuestion).addClass('form-field-child form-field-optional').attr({ 'data-parent-question': 'question-' + questionCount, 'data-parent-option': 'question-' + questionCount + '-option-' + optionCount });
                  $('.prompt', nextQuestion).text(this.next_question.prompt);
                  $(this.next_question.options).each(function (index) {
                    var optionCount = index;
                    var option = $(radioButtonTemplate);
                    $('input[type="radio"]', option).attr({ name: 'question-' + questionCount + '-' + nextQuestionCount, id: 'question-' + questionCount + '-' + nextQuestionCount + '-option-' + optionCount, value: this.response });
                    $('.radio-button-label', option).attr('for', 'question-' + questionCount + '-' + nextQuestionCount + '-option-' + optionCount).text(this.response);
                    if (optionCount == 0) {
                      $('input[type="radio"]', option).prop('checked', true);
                    }
                    $('.radio-buttons-group', nextQuestion).append(option);
                  });
                  nextQuestions.push(nextQuestion);
                } else if (this.next_question.type == 'SELECT') {
                  var nextQuestion = $(selectTemplate);
                  $(nextQuestion).addClass('form-field-child form-field-optional').attr({ 'data-parent-question': 'question-' + questionCount, 'data-parent-option': 'question-' + questionCount + '-option-' + optionCount });
                  $('.prompt', nextQuestion).text(this.next_question.prompt).attr('for', 'question-' + questionCount + '-' + nextQuestionCount);
                  $('select', nextQuestion).attr('name', 'question-' + questionCount + '-' + nextQuestionCount).attr('id', 'question-' + questionCount + '-' + nextQuestionCount);
                  $(this.next_question.options).each(function (index) {
                    var option = $(selectOptionTemplate);
                    $(option).attr('value', this.response).text(this.response);
                    $('select', nextQuestion).append(option);
                  });
                  nextQuestions.push(nextQuestion);
                } else if (this.next_question.type == 'TEXT') {
                  var nextQuestion = $(textTemplate);
                  $(nextQuestion).addClass('form-field-child form-field-optional').attr({ 'data-parent-question': 'question-' + questionCount, 'data-parent-option': 'question-' + questionCount + '-option-' + optionCount });
                  $('.prompt', nextQuestion).text(this.next_question.prompt).attr('for', 'question-' + questionCount + '-' + nextQuestionCount);
                  $('input[type="text"]', nextQuestion).attr({ name: 'question-' + questionCount + '-' + nextQuestionCount, id: 'question-' + questionCount + '-' + nextQuestionCount });
                  nextQuestions.push(nextQuestion);
                }
                nextQuestionCount++;
              }
            });
          } else if (this.structure.type == 'TEXT') {
            var question = $(textTemplate);
            question.addClass('form-field-parent');
            $('.prompt', question).text(this.structure.prompt).attr('for', 'question-' + questionCount);
            $('input[type="text"]', question).attr({ name: 'question-' + questionCount, id: 'question-' + questionCount });
          }
        }
        $(target).append(question);
        if (nextQuestions) {
          $(target).append(nextQuestions);
        }
      });
      surveyQuestionFunctionality();
    }

    var thisSubscription = getUrlParameter('subscription');
    var thisParker = getUrlParameter('parker');
    var thisAdd = getUrlParameter('add');
    var thisEdit = getUrlParameter('edit');
    var thisBarcode = getUrlParameter('barcode');
    var accessDevices = [];

    if (thisSubscription.length > 0) {

      if (thisParker.length > 0) {

        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_graphql',
            authorization: graphQLAuth,
            nonce: graphQLNonce,
            graphql_request: "query getSubscription($subscription_id: String!) { getSubscription(subscription_id: $subscription_id) { id, auto_pay, mail_invoices, vehicleSurchargeFees, billing_profile { id, billing_day, termination_notice_day, facility { id, uid, facility_name, timezone, integration, facilitySettings { maxActiveVehicles, minActiveVehicles } }, survey_questions { id, billing_profile_id, order, type, structure } }, parkers { id, barcode, subscription_id, rate_id, first_name, last_name, email, address, city, state, zip, country_code, phone }, payor { id, cognito_sub, billing_firstname, billing_lastname } } }",
            graphql_variables: JSON.stringify({
              subscription_id: thisSubscription
            })
          },
          success: function (results) {

            let { data, errors } = JSON.parse(results);

            console.log('success!', data);

            if (data.getSubscription.parkers.length > 0) {

              var subscription = data.getSubscription;
              var parkers = subscription.parkers;
              var matchIndex;

              parkers.forEach(function (parker, index) {
                if (thisParker == parker.id) {
                  return matchIndex = index;
                }
              });

              if (matchIndex > -1) {
                var matchParker = parkers[matchIndex];

                if (thisEdit.length > 0) {

                  // edit parker functionality
                  $('#first-name').val(matchParker.first_name);
                  $('#last-name').val(matchParker.last_name);
                  $('#email-address').val(matchParker.email);
                  $('#country-code').val(matchParker.country_code);
                  $('#phone-number').val(matchParker.phone);
                  $('#street-address').val(matchParker.address);
                  $('#city').val(matchParker.city);
                  $('#state').val(matchParker.state);
                  $('#zip-code').val(matchParker.zip);

                  const facilityIntegration = subscription?.billing_profile?.facility.integration;
                  const maxActiveVehicleCount = subscription?.billing_profile?.facility.facilitySettings.maxActiveVehicles || 1000000;
                  const minActiveVehicleCount = subscription?.billing_profile?.facility?.facilitySettings?.minActiveVehicles ?? 0;
                  $('.vehicle-add').data('max-active', maxActiveVehicleCount);
                  $('.vehicle-add').data('min-active', minActiveVehicleCount);
                  setVehicleSurchargeConfig({
                    facilityId: subscription?.billing_profile?.facility?.uid,
                    vehicleSurchargeFees: subscription?.vehicleSurchargeFees,
                  });
                  updateVehicleAddDisabled();

                  $('#facility-integration').val(facilityIntegration);
                  $('#rate-id').val(matchParker.rate_id);
                  $('#parking-reason').val(matchParker.parking_reason);

                  const apiUrl = getV2GraphQLApiUrl();

                  const endpoint = `${apiUrl}/graphql`;
                  const query = `
                    query getMonthlyParkerDetails(
                        $parkerId: String!
                        $subscriptionId: String!
                    ) {
                        getMonthlyParkerVehicles(
                            parkerId: $parkerId
                        ) {
                            id
                            make
                            model
                            license
                            modelId
                            state
                            color
                            decal
                            endDate
                            surchargeFeeNames
                        }
                        getMonthlyAccountSubscription(
                            subscriptionId: $subscriptionId
                        ) {
                            approvedDriversEnabled
                            parkers {
                                id
                                approvedDrivers
                            }
                        }
                    }
                  `;
                  var id_token = getCookie('aws_cognito_id_token');
                  fetch(endpoint, {
                    method: 'POST',
                    headers: {
                      Authorization: 'Bearer ' + id_token,
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      query,
                      variables: {
                        parkerId: matchParker.id,
                        subscriptionId: thisSubscription
                      },
                      context: {
                        apiVersion: 'v2',
                        appName: 'WORDPRESS'
                      }
                    })
                  })
                  .then(response => response.json())
                  .then(vehicleData => {
                    const monthlySubscription = vehicleData.data.getMonthlyAccountSubscription;
                    if (monthlySubscription?.approvedDriversEnabled) {
                      const monthlyParker = monthlySubscription.parkers.find(parker => parker.id === matchParker.id);
                      $('#approved-drivers').val(monthlyParker?.approvedDrivers?.join(', ') ?? '');
                      $('#approved-drivers-field').show();
                    }

                    if (vehicleData.data.getMonthlyParkerVehicles.length > 0) {
                    var vehicles = vehicleData.data.getMonthlyParkerVehicles;
                    $('.vehicle-add').data('current-active', countCurrentlyActiveVehicles(vehicles));
                    if (maxActiveVehicleCount === vehicles.length) {
                      $('.vehicle-add').prop('disabled', true).addClass('disabled');
                    } else {
                      $('.vehicle-add').prop('disabled', false).removeClass('disabled');
                    }
                    vehicles.forEach(function (vehicle, index) {
                      if (index == 0) {
                        const $vehicleGroup = $('#vehicle-' + index);
                        populateAndDisableVehicleDropdowns(index, vehicle);
                        $vehicleGroup
                          .data('vehicleId', vehicle.id ?? null)
                          .data('modelId', vehicle.modelId ?? null);
                        $('#vehicle-state-' + index).val(vehicle.state).prop('disabled', false);
                        $('#vehicle-plate-number-' + index).val(vehicle.license).prop('disabled', false);
                        $('#vehicle-color-' + index).val(vehicle.color).prop('disabled', false);
                        $('#vehicle-decal-' + index).val(vehicle.decal).prop('disabled', false);
                        if(vehicle.endDate && vehicle.surchargeFeeNames.length > 0) {
                            const btn = document.querySelector(`[data-cy="edit-parker-vehicle-delete-button-${index}"]`);
                            if (btn) {
                              btn.disabled = true;
                            }
                        }
                      } else {
                        var template = '<div class="form-field form-field-group form-field-group-vehicle" ' +
                            'id="vehicle-' + index + '" ' +
                            'data-vehicle-id="' + vehicle.id + '" ' +
                            'data-model-id="' + vehicle.modelId + '">' +
                          '<div class="form-field">' +
                          '<label class="form-field-label" for="vehicle-make-' + index + '">Vehicle Make</label>' +
                          '<div class="select-wrapper">' +
                          '<select disabled name="vehicle-make" id="vehicle-make-' + index + '">' +
                          '<option value="" selected disabled>Select a make</option>' +
                          '</select>' +
                          '</div>' +
                          '</div>' +
                          '<div class="form-field">' +
                          '<label class="form-field-label" for="vehicle-model-' + index + '">Vehicle Model</label>' +
                          '<div class="select-wrapper">' +
                          '<select disabled name="vehicle-model" id="vehicle-model-' + index + '">' +
                          '<option value="" selected disabled>Select a model</option>' +
                          '</select>' +
                          '</div>' +
                          '</div>' +
                          '<div class="form-field">' +
                          '<label class="form-field-label" for="vehicle-state-' + index + '">License Plate State</label>' +
                          '<div class="select-wrapper">' +
                          `<select name="vehicle-state" id="vehicle-state-${index}" data-cy="vehicle-state-select-${index}"/>

                            <option value="" ${!vehicle.state ? 'selected' : ''}>Select a state/province</option>
                                    <option value="AL" ${vehicle.state === 'AL' ? 'selected' : ''}>Alabama</option>
                                    <option value="AB" ${vehicle.state === 'AB' ? 'selected' : ''}>Alberta</option>
                                    <option value="AK" ${vehicle.state === 'AK' ? 'selected' : ''}>Alaska</option>
                                    <option value="AZ" ${vehicle.state === 'AZ' ? 'selected' : ''}>Arizona</option>
                                    <option value="AR" ${vehicle.state === 'AR' ? 'selected' : ''}>Arkansas</option>
                                    <option value="BC" ${vehicle.state === 'BC' ? 'selected' : ''}>British Columbia</option>
                                    <option value="CA" ${vehicle.state === 'CA' ? 'selected' : ''}>California</option>
                                    <option value="CO" ${vehicle.state === 'CO' ? 'selected' : ''}>Colorado</option>
                                    <option value="CT" ${vehicle.state === 'CT' ? 'selected' : ''}>Connecticut</option>
                                    <option value="DE" ${vehicle.state === 'DE' ? 'selected' : ''}>Delaware</option>
                                    <option value="DC" ${vehicle.state === 'DC' ? 'selected' : ''}>District of Columbia</option>
                                    <option value="FL" ${vehicle.state === 'FL' ? 'selected' : ''}>Florida</option>
                                    <option value="GA" ${vehicle.state === 'GA' ? 'selected' : ''}>Georgia</option>
                                    <option value="HI" ${vehicle.state === 'HI' ? 'selected' : ''}>Hawaii</option>
                                    <option value="ID" ${vehicle.state === 'ID' ? 'selected' : ''}>Idaho</option>
                                    <option value="IL" ${vehicle.state === 'IL' ? 'selected' : ''}>Illinois</option>
                                    <option value="IN" ${vehicle.state === 'IN' ? 'selected' : ''}>Indiana</option>
                                    <option value="IA" ${vehicle.state === 'IA' ? 'selected' : ''}>Iowa</option>
                                    <option value="KS" ${vehicle.state === 'KS' ? 'selected' : ''}>Kansas</option>
                                    <option value="KY" ${vehicle.state === 'KY' ? 'selected' : ''}>Kentucky</option>
                                    <option value="LA" ${vehicle.state === 'LA' ? 'selected' : ''}>Louisiana</option>
                                    <option value="ME" ${vehicle.state === 'ME' ? 'selected' : ''}>Maine</option>
                                    <option value="MB" ${vehicle.state === 'MB' ? 'selected' : ''}>Manitoba</option>
                                    <option value="MD" ${vehicle.state === 'MD' ? 'selected' : ''}>Maryland</option>
                                    <option value="MA" ${vehicle.state === 'MA' ? 'selected' : ''}>Massachusetts</option>
                                    <option value="MI" ${vehicle.state === 'MI' ? 'selected' : ''}>Michigan</option>
                                    <option value="MN" ${vehicle.state === 'MN' ? 'selected' : ''}>Minnesota</option>
                                    <option value="MS" ${vehicle.state === 'MS' ? 'selected' : ''}>Mississippi</option>
                                    <option value="MO" ${vehicle.state === 'MO' ? 'selected' : ''}>Missouri</option>
                                    <option value="MT" ${vehicle.state === 'MT' ? 'selected' : ''}>Montana</option>
                                    <option value="NE" ${vehicle.state === 'NE' ? 'selected' : ''}>Nebraska</option>
                                    <option value="NV" ${vehicle.state === 'NV' ? 'selected' : ''}>Nevada</option>
                                    <option value="NB" ${vehicle.state === 'NB' ? 'selected' : ''}>New Brunswick</option>
                                    <option value="NL" ${vehicle.state === 'NL' ? 'selected' : ''}>Newfoundland and Labrador</option>
                                    <option value="NH" ${vehicle.state === 'NH' ? 'selected' : ''}>New Hampshire</option>
                                    <option value="NJ" ${vehicle.state === 'NJ' ? 'selected' : ''}>New Jersey</option>
                                    <option value="NM" ${vehicle.state === 'NM' ? 'selected' : ''}>New Mexico</option>
                                    <option value="NY" ${vehicle.state === 'NY' ? 'selected' : ''}>New York</option>
                                    <option value="NT" ${vehicle.state === 'NT' ? 'selected' : ''}>Northwest Territories</option>
                                    <option value="NC" ${vehicle.state === 'NC' ? 'selected' : ''}>North Carolina</option>
                                    <option value="ND" ${vehicle.state === 'ND' ? 'selected' : ''}>North Dakota</option>
                                    <option value="NS" ${vehicle.state === 'NS' ? 'selected' : ''}>Nova Scotia</option>
                                    <option value="NU" ${vehicle.state === 'NU' ? 'selected' : ''}>Nunavut</option>
                                    <option value="OH" ${vehicle.state === 'OH' ? 'selected' : ''}>Ohio</option>
                                    <option value="OK" ${vehicle.state === 'OK' ? 'selected' : ''}>Oklahoma</option>
                                    <option value="ON" ${vehicle.state === 'ON' ? 'selected' : ''}>Ontario</option>
                                    <option value="OR" ${vehicle.state === 'OR' ? 'selected' : ''}>Oregon</option>
                                    <option value="PE" ${vehicle.state === 'PE' ? 'selected' : ''}>Prince Edward Island</option>
                                    <option value="PA" ${vehicle.state === 'PA' ? 'selected' : ''}>Pennsylvania</option>
                                    <option value="QC" ${vehicle.state === 'QC' ? 'selected' : ''}>Quebec</option>
                                    <option value="RI" ${vehicle.state === 'RI' ? 'selected' : ''}>Rhode Island</option>
                                    <option value="SK" ${vehicle.state === 'SK' ? 'selected' : ''}>Saskatchewan</option>
                                    <option value="SC" ${vehicle.state === 'SC' ? 'selected' : ''}>South Carolina</option>
                                    <option value="SD" ${vehicle.state === 'SD' ? 'selected' : ''}>South Dakota</option>
                                    <option value="TN" ${vehicle.state === 'TN' ? 'selected' : ''}>Tennessee</option>
                                    <option value="TX" ${vehicle.state === 'TX' ? 'selected' : ''}>Texas</option>
                                    <option value="UT" ${vehicle.state === 'UT' ? 'selected' : ''}>Utah</option>
                                    <option value="VT" ${vehicle.state === 'VT' ? 'selected' : ''}>Vermont</option>
                                    <option value="VA" ${vehicle.state === 'VA' ? 'selected' : ''}>Virginia</option>
                                    <option value="WA" ${vehicle.state === 'WA' ? 'selected' : ''}>Washington</option>
                                    <option value="WV" ${vehicle.state === 'WV' ? 'selected' : ''}>West Virginia</option>
                                    <option value="WI" ${vehicle.state === 'WI' ? 'selected' : ''}>Wisconsin</option>
                                    <option value="WY" ${vehicle.state === 'WY' ? 'selected' : ''}>Wyoming</option>
                                    <option value="YT" ${vehicle.state === 'YT' ? 'selected' : ''}>Yukon</option>
                          </select>` +
                          '</div>' +
                          '</div>' +
                          '<div class="form-field">' +
                          '<label class="form-field-label" for="vehicle-plate-number-' + index + '">License Plate</label>' +
                          '<input type="text" name="vehicle-plate-number" id="vehicle-plate-number-' + index + '" value="' + (vehicle.license ?? '') + '" />' +
                          '</div>' +
                          '<div class="form-field">' +
                          '<label class="form-field-label" for="vehicle-color-' + index + '">Vehicle Color</label>' +
                          '<input type="text" name="vehicle-color" id="vehicle-color-' + index + '" value="' + (vehicle.color ?? '') + '" />' +
                          '</div>' +
                          '<div class="form-field">' +
                          '<label class="form-field-label" for="vehicle-decal-' + index + '">Vehicle Decal</label>' +
                          '<input type="text" name="vehicle-decal" id="vehicle-decal-' + index + '" value="' + (vehicle.decal ?? '') + '" />' +
                          '</div>' +
                          '<div class="form-field">' +
                          '<button class="button button-small button-red vehicle-delete" ' + (vehicle.endDate && vehicle.surchargeFeeNames.length > 0 ? 'disabled' : '') + '>Delete This Vehicle</button>' +
                          '</div>' +
                          '</div>';
                        var $vehicleGroup = $(template);
                        $vehicleGroup
                          .data('vehicleId', vehicle.id ?? null)
                          .data('modelId', vehicle.modelId ?? null);

                        $('.form-field-group-vehicles').append($vehicleGroup);
                        populateAndDisableVehicleDropdowns(index, vehicle);
                      }
                    });
                  }
                    updateVehicleSurchargeMessage();
                  })
                } else if (thisBarcode.length > 0) {
                  // View Barcode functionality
                  var facilityName = 'FACILITY NAME';
                  if (subscription.billing_profile.facility) {
                    facilityName = subscription.billing_profile.facility.facility_name;
                  }

                  $('.card-header-title').text(matchParker.first_name + ' ' + matchParker.last_name);
                  $('.card-header-text p').text('Monthly Parking at ' + facilityName);

                  if (matchParker.barcode.length) {
                    var target = document.getElementById('barcode');
                    new QRCode(target, {
                      text: matchParker.barcode,
                      width: 150,
                      height: 150,
                      colorDark: '#000000',
                      colorLight: '#FFFFFF',
                      correctLevel: QRCode.CorrectLevel.H
                    });

                    $('#email-barcode-email').val(matchParker.email);

                    function getBarcodePass(passType) {
                      $(`#add-to-${passType}-wallet`).hide();
                      $('#apple-wallet-error').hide();
                      $('#google-wallet-error').hide();
                      $(`#${passType}-wallet-spinner`).prop('disabled', true);

                      $.ajax({
                        type: 'post',
                        url: '/wp-admin/admin-ajax.php',
                        data: {
                          action: 'chirp_download_barcode_pass',
                          authorization: graphQLAuth,
                          nonce: graphQLNonce,
                          passType,
                          parkerId: matchParker.id,
                        },
                        success: function (results) {
                          const { isError, body } = JSON.parse(results);
                          if (isError) {
                            console.log(body);
                            $(`#${passType}-wallet-error`).show();
                            return;
                          }

                          const link = document.createElement('a');
                          if (passType === 'apple') {
                            link.href = `data:application/vnd.apple.pkpass;base64,${body}`;
                            link.download = 'Barcode.pkpass';
                          } else if (passType === 'google') {
                            link.href = body;
                          }
                          link.click();
                        },
                        error: function () {
                          console.log(`Ajax error retrieving ${passType} wallet pass`);
                          $(`#${passType}-wallet-error`).show();
                        },
                        complete: function () {
                          $(`#add-to-${passType}-wallet`).show();
                          $(`#${passType}-wallet-spinner`).prop('disabled', false);
                        }
                      });
                    }

                    $('#add-to-apple-wallet').on('click', function () {
                      getBarcodePass('apple');
                    });

                    $('#add-to-google-wallet').on('click', function () {
                      getBarcodePass('google');
                    });

                    $('#send-barcode-email').on('click', function () {
                      $('#send-barcode-email').hide();
                      $('#email-barcode-spinner').show();
                      $('#email-barcode-success').hide();
                      $('#email-barcode-error').hide();

                      $.ajax({
                        type: 'post',
                        url: '/wp-admin/admin-ajax.php',
                        data: {
                          action: 'chirp_graphql',
                          authorization: graphQLAuth,
                          nonce: graphQLNonce,
                          graphql_request: 'mutation sendBarcodeEmail($parkerId: String!, $emailAddress: String!) { sendBarcodeEmail(parkerId: $parkerId, emailAddress: $emailAddress) }',
                          graphql_variables: JSON.stringify({
                            parkerId: matchParker.id,
                            emailAddress: $('#email-barcode-email').val()
                          }),
                        },
                        success: function (results) {
                          const { errors } = JSON.parse(results);

                          if (errors) {
                            console.log(errors);
                            $('#email-barcode-error').show().attr('data-cy', 'email-barcode-error-text');
                          } else {
                            $('#email-barcode-success').show().attr('data-cy', 'email-barcode-success-text');
                            $('#email-barcode-email').val('');
                          }
                        },
                        error: function (results) {
                          console.log(results);
                          $('#email-barcode-error').show();
                        },
                        complete: function () {
                          $('#send-barcode-email').show();
                          $('#email-barcode-spinner').hide();
                        }
                      });
                    });
                  }
                }
                $('.card-content-overlay').removeClass('card-content-overlay-active');
              } else {
                console.log('No parkers matched the supplied Parker ID?');
                $('.card-content-overlay').removeClass('card-content-overlay-active');
              }
            } else {
              console.log('There are no parkers for this subscription.');
            }
          },
          error: function (results) {
            console.log('error!', results);
          }
        });
      } else if (thisAdd) {
        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_graphql',
            authorization: graphQLAuth,
            nonce: graphQLNonce,
            api_version: 'v2',
            // graphql_request: "query($subscription_id: String!) { getAvailableRatesForSubscription(subscription_id: $subscription_id) { id, name } }",
            graphql_request: "query GetRatesForSubscriptionViaMyAccountPage($subscriptionId: String!, $display: RateDisplayEnum2) { getRatesBySubscription(subscriptionId: $subscriptionId, display: $display) { id, name, childRateStartDate, childRateEndDate, active, onlineEndDate, requireCarInfo, isSoldOut } }",
            graphql_variables: JSON.stringify({
              "subscriptionId": thisSubscription,
              "display": "Yes"
            })
          },
          success: function (results) {

            let { data, errors } = JSON.parse(results);

            console.log('success!', data);
            if (data.getRatesBySubscription.length > 0) {
              var rates = data.getRatesBySubscription;

              const filteredRateData = rates.filter((rate) => {
                if (rate.childRateStartDate) {
                  const childStartDate = moment.utc(rate.childRateStartDate).startOf('day');
                  const childEndDate = rate.childEndDate ? moment.utc(rate.childRateEndDate).endOf('day') : moment().add(1, 'years');
                  const isBillingStartDateBetweenChildRateStartAndEnd = moment().isBetween(
                    childStartDate,
                    childEndDate,
                    'day',
                    '[]',
                  );
                  
                  return isBillingStartDateBetweenChildRateStartAndEnd;
                }

                if (!rate.active || (rate.onlineEndDate && moment.utc(rate.onlineEndDate).isSameOrBefore(moment()))) {
                  return false;
                }

                return true;
              });

              filteredRateData.forEach(function (rate) {
                const option = $('<option>')
                  .val(rate.id)
                  .text(rate.name)
                  .attr('data-requires-car-info', rate.requireCarInfo === 'REQUIRED')
                  .attr('data-is-sold-out', rate.isSoldOut === true);

                $('select[name="rate"]').append(option);
              });

              $('select[name="rate"]').change(function () {
              const selectedOption = $(this).find('option:selected');
              const requiresCarInfo = selectedOption.data('requires-car-info') === true;
              const isSoldOut = selectedOption.data('is-sold-out') === true;
              if (requiresCarInfo) {
                $('.form-field-group-title').html('Vehicles <span style="color: red;">*</span>');
              } else {
                $('.form-field-group-title').text('Vehicles');
              }

              if (requiresCarInfo) {
                $('.vehicle-delete').hide();
              } else {
                $('.vehicle-delete').show();
              }

              const fieldsToToggle = [
                '#vehicle-make-0',
                '#vehicle-model-0',
                '#vehicle-state-0',
                '#vehicle-plate-number-0',
                '#vehicle-color-0'
              ];

              fieldsToToggle.forEach(function (selector) {
                if (requiresCarInfo) {
                  $(selector).attr('required', true);
                } else {
                  $(selector).removeAttr('required');
                }
              });
              if (isSoldOut) {
                $('#sold-out-helper').show();
              } else {
                $('#sold-out-helper').hide();
              }
            });

              $('#start-date').change(function () {
                const dateSelected = $(this).val();
                $('select[name="rate"]').empty();
                const filteredRateData = rates.filter((rate) => {
                  const dateToCompareTo = moment.utc(dateSelected).startOf('day').format();

                  if (rate.childRateStartDate) {
                    const childStartDate = moment.utc(rate.childRateStartDate).startOf('day');
                    const childEndDate = rate.childRateEndDate ? moment.utc(rate.childRateEndDate).endOf('day') : moment().add(1, 'years');
                    const isBillingStartDateBetweenChildRateStartAndEnd = moment.utc(dateToCompareTo).isBetween(
                      childStartDate,
                      childEndDate,
                      'day',
                      '[]',
                    );
                    return isBillingStartDateBetweenChildRateStartAndEnd
                  }

                  if (!rate.active || (rate.onlineEndDate && moment.utc(rate.onlineEndDate).isSameOrBefore(dateToCompareTo))) {
                    return false;
                  }

                  return true;
                });
                $('select[name="rate"]').append('<option value="#" selected disabled>Choose One...</option>');

                filteredRateData.forEach(function (rate) {

                  var option = '<option value="' + rate.id + '">' + rate.name + '</option>';

                  $('select[name="rate"]').append(option);

                });
              });


            } else {
              console.log('No rates available.')
              $('.card-content').append('<div class="card-content-error">No rates available.</div>');
            }
            $('.card-content-overlay').removeClass('card-content-overlay-active');
          },
          error: function (results) {
            console.log('error!', results);
          }
        });

        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_graphql',
            authorization: graphQLAuth,
            nonce: graphQLNonce,
            graphql_request: "query getSubscription($subscription_id: String!) { getSubscription(subscription_id: $subscription_id) { id, paymentMethod { token }, auto_pay, mail_invoices, vehicleSurchargeFees, billing_profile { id, billing_day, termination_notice_day, facility { id, uid, facility_name, address, timezone, access_devices, facilitySettings { maxActiveVehicles, minActiveVehicles } }, survey_questions { id, billing_profile_id, order, type, structure } }, parkers { id, barcode, first_name, last_name }, payor { id, cognito_sub, billing_firstname, billing_lastname } } }",
            graphql_variables: JSON.stringify({
              "subscription_id": thisSubscription
            })
          },
          success: function (results) {

            let { data, errors } = JSON.parse(results);

            console.log('success!', data);
            const maxActiveVehicleCount =
              data.getSubscription?.billing_profile?.facility?.facilitySettings?.maxActiveVehicles || 1000000;
            const minActiveVehicleCount =
              data.getSubscription?.billing_profile?.facility?.facilitySettings?.minActiveVehicles ?? 0;

            $('.vehicle-add').data('max-active', maxActiveVehicleCount);
            $('.vehicle-add').data('min-active', minActiveVehicleCount);
            setVehicleSurchargeConfig({
              facilityId: data.getSubscription?.billing_profile?.facility?.uid,
              vehicleSurchargeFees: data.getSubscription?.vehicleSurchargeFees,
            });
            updateVehicleAddDisabled();
            $('#payor-id').val(data.getSubscription.payor.id);
            $('#subscription-auto-pay').val(data.getSubscription.auto_pay);
            $('#subscription-mail-invoices').val(data.getSubscription.mail_invoices);
            $('#subscription-payment-method-id').val(data.getSubscription.paymentMethod?.token);

            accessDevices = data.getSubscription.billing_profile.facility.access_devices || [];
          },
          error: function (results) {
            console.log('error!', results);
          }
        });

      } else {
        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_graphql',
            authorization: graphQLAuth,
            nonce: graphQLNonce,
            graphql_request: "query listUserSubscriptions($exclude_validation_only: Boolean, $paymentProviderId: Int) { listUserSubscriptions(exclude_validation_only: $exclude_validation_only, paymentProviderId: $paymentProviderId) { id, account_id, billing_profile { id, validation_only, billing_day, termination_notice_day, terminationRule, facility { id, facility_name, address, timezone, myAccountFacilitySettings { showParkerTermination, showParkerAddition } } survey_questions { id, billing_profile_id, order, type, structure } }, parkers { id, suspension_status, termination_status, barcode, first_name, last_name, parker_status_history {action, start_date}}, payor { id, cognito_sub, billing_firstname, billing_lastname } } }",
            graphql_variables: JSON.stringify({
              ...listUserSubscriptionsVariables(),
              exclude_validation_only: true,
            })
          },
          success: function (results) {
            let { data } = JSON.parse(results);

            console.log('success!', data);

            if (data && data.listUserSubscriptions.length > 0) {
              var subscriptions = data.listUserSubscriptions;

              subscriptions.forEach(function (subscription) {
                var facilityName = 'FACILITY NAME';
                if (subscription.billing_profile.facility) {
                  facilityName = subscription.billing_profile.facility.facility_name;
                }
                var option = '<option value="' + subscription.id + '" data-termination-day="' + subscription.billing_profile.termination_notice_day + '">' + 'Monthly Parking at ' + facilityName + '(AC-' + subscription.account_id + ')</option>';

                $('select[name="subscription"]').append(option);

                if (thisSubscription == subscription.id) {
                  $('select[name="subscription"]').val(subscription.id);

                  $('.parker-add').attr('href', '?subscription=' + thisSubscription + '&add=1').show();

                  var parkers = subscription.parkers;

                  const showParkerAddition = subscription.billing_profile.facility.myAccountFacilitySettings.showParkerAddition;

                   $('.parker-add')
                     .attr('href', `?subscription=${subscription.id}&add=1`)
                     .toggle(showParkerAddition);
                  if (parkers.length > 0) {

                    $('.transactions-group').prepend('<ol />');


                    parkers.forEach(function (parker, index) {
                      const isActive = (parker.suspension_status === 'ACTIVE' || parker.termination_status === 'ACTIVE')
                      const isTerminationPending = parker.termination_status === 'TERMINATION_PENDING';
                      const isShowTerminateButton = isActive && subscription.billing_profile.facility.myAccountFacilitySettings.showParkerTermination && (!feature_flags.FEATURE_MYACCOUNT || !isTerminationPending);

                      var template = `<li class="transaction" data-termination-day=${subscription.billing_profile.termination_notice_day} data-termination-rule=${subscription.billing_profile.terminationRule} data-subscription-id="${subscription.id}" data-parker-id="${parker.id}" data-parker-name="${parker.first_name} ${parker.last_name}" data-cy="parker-row-${index}">` +
                        '<div class="transaction-title">' +
                        '<a href="?subscription=' + subscription.id + '&parker=' + parker.id + '&edit=1" title="Edit ' + parker.first_name + ' ' + parker.last_name + '" data-cy="parker-name-link">' + parker.first_name + ' ' + parker.last_name + '</a>' +
                        '</div>' +
                        '<div class="transaction-actions">' +
                        (parker.barcode ? '<a href="?subscription=' + subscription.id + '&parker=' + parker.id + '&barcode=true" title="View ' + parker.first_name + ' ' + parker.last_name + '\'s Barcode" class="parker-barcode" data-cy="parker-barcode-link">View Barcode</a>' : '') +
                        (isShowTerminateButton ? '<a href="#" title="Delete ' + parker.first_name + ' ' + parker.last_name + '" class="parker-delete" data-cy="parker-terminate-link">Terminate</a>' : '') +
                        '</div>' +
                        '<div class="transaction-meta">' +
                        '<p data-cy="parker-status-text">' + getParkerStatusText(parker); + '</p>' +
                          '</div>' +
                          '</li>';

                      $('.transactions-group ol').append(template);

                    });

                    var questions = subscription.billing_profile.survey_questions;
                    if (questions.length) {
                      surveyQuestions(questions, 'TERMINATION', '#termination-survey-questions');
                    }

                  } else {

                    console.log('Successfully retrieved the subscription, but there are no parkers to display!');
                    $('.transactions-group').empty().append('<div class="card-content-error">There are no parkers for this subscription.</div>');

                  }

                }

              });

            } else {

              console.log('You don\'t have any subscriptions.')
              $('.card-content').append('<div class="card-content-error">You don\'t have any subscriptions.</div>')

            }

            $('.card-content-overlay').removeClass('card-content-overlay-active');

          },
          error: function (results) {
            console.log(results);
          }
        });

      }

    } else {
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "query listUserSubscriptions($exclude_validation_only: Boolean, $paymentProviderId: Int) { listUserSubscriptions(exclude_validation_only: $exclude_validation_only, paymentProviderId: $paymentProviderId) { id, account_id, billing_profile { id, validation_only, billing_day, termination_notice_day, terminationRule, facility { id, facility_name, address, timezone, myAccountFacilitySettings { showParkerTermination } } survey_questions { id, billing_profile_id, order, type, structure } }, parkers { id, suspension_status, termination_status, barcode, first_name, last_name, parker_status_history {action, start_date}}, payor { id, cognito_sub, billing_firstname, billing_lastname } } }",
          graphql_variables: JSON.stringify({
            ...listUserSubscriptionsVariables(),
            exclude_validation_only: true,
          })
        },
        success: function (results) {
          let { data } = JSON.parse(results);

          console.log('success!', data);
          if (data && data.listUserSubscriptions.length > 0) {
            var subscriptions = data.listUserSubscriptions;

            $(subscriptions).each(function (_, subscription) {
              var facilityName = 'FACILITY NAME';
              if (subscription.billing_profile.facility) {
                facilityName = subscription.billing_profile.facility.facility_name;
              }
              var option = '<option value="' + subscription.id + '" data-termination-day="' + subscription.billing_profile.termination_notice_day + '">' + 'Monthly Parking at ' + facilityName + ' (AC-' + subscription.account_id + ')' + '</option>';
              $('select[name="subscription"]').append(option);

            });

            if (subscriptions.length == 1) {

              $('#subscription option:not([disabled])').prop('selected', true);
              var subscription = subscriptions[0];
              $('.parker-add').attr('href', '?subscription=' + thisSubscription + '&add=1').show();

              var parkers = subscription.parkers;

              if (parkers.length > 0) {

                $('.transactions-group').prepend('<ol />');

                parkers.forEach(function (parker) {
                  const isActive = (parker.suspension_status === 'ACTIVE' || parker.termination_status === 'ACTIVE');
                  const isTerminationPending = parker.termination_status === 'TERMINATION_PENDING';
                  const isShowTerminateButton = isActive && subscription.billing_profile.facility.myAccountFacilitySettings.showParkerTermination && (!feature_flags.FEATURE_MYACCOUNT || !isTerminationPending);

                  var template = `<li class="transaction" data-termination-day=${subscription.billing_profile.termination_notice_day} data-termination-rule=${subscription.billing_profile.terminationRule} data-subscription-id="${subscription.id}" data-parker-id="${parker.id}" data-parker-name="${parker.first_name} ${parker.last_name}">` +
                    '<div class="transaction-title">' +
                    `<a href="?subscription=${subscription.id}&parker=${parker.id}&edit=1" title="Edit ${parker.first_name} ${parker.last_name}" data-cy="parker-name-link">${parker.first_name} ${parker.last_name}</a>` +
                    '</div>' +
                    '<div class="transaction-actions">' +
                    (parker.barcode ? '<a href="?subscription=' + subscription.id + '&parker=' + parker.id + '&barcode=true" title="View ' + parker.first_name + ' ' + parker.last_name + '\'s Barcode" class="parker-barcode" data-cy="parker-barcode-link">View Barcode</a>' : '') +
                    (isShowTerminateButton ? '<a href="#" title="Delete ' + parker.first_name + ' ' + parker.last_name + '" class="parker-delete" data-cy="parker-terminate-link">Terminate</a>' : '') +
                    '</div>' +
                    '<div class="transaction-meta">' +
                    '<p data-cy="parker-status-text">' + getParkerStatusText(parker); + '</p>' +
                      '</div>' +
                      '</li>';

                  $('.transactions-group ol').append(template);

                });

                var questions = subscription.billing_profile.survey_questions;
                if (questions.length) {
                  surveyQuestions(questions, 'TERMINATION', '#termination-survey-questions');
                }

              } else {

                console.log('Successfully retrieved the subscription, but there are no parkers to display!');
                $('.transactions-group').empty().append('<div class="card-content-error">There are no parkers for this subscription.</div>');

              }
              window.history.replaceState('', '', '?subscription=' + subscription.id);
              $('.parker-add').attr('href', '?subscription=' + subscription.id + '&add=1').show();

            }

          } else {

            console.log('You don\'t have any subscriptions.')
            $('.card-content').append('<div class="card-content-error">You don\'t have any subscriptions.</div>');

          }

          $('.card-content-overlay').removeClass('card-content-overlay-active');

        },
        error: function (results) {
          console.log(results);
        }
      });

    }
    /*** lookup rates via promo code functionality */
    $('#promo-code').on('input', function (event) {
      // if there is a promo code entered, enable the promo code submit button
      $('#submit-promo-code').prop('disabled', !event.target.value);
    });

    $('#submit-promo-code').on('click', function () {
      // if the promo code input is disabled when the
      // button was pressed, then we were in the state where
      // the user wishes to clear the entered promo code
      const isInCancelState = $('#promo-code').prop('disabled');
      if (isInCancelState) {
        let nonPromoCodeOptions = [];
        $("#rate > option").each(function (_, element) {
          // If the option wasn't specified as a promo code rate
          // and isn't the default value, append it to the list
          if (!$(element).attr("data-is-promo-code-rate")
            && $(element).val() !== "#") {
            nonPromoCodeOptions.push(
              $('<option></option>')
                .attr("value", $(element).val())
                .text($(element).text())
            );
          }
        });

        $('#rate').empty();
        const defaultOption = '<option value="#" selected disabled>Choose One...</option>';
        $('#rate').append(defaultOption);

        nonPromoCodeOptions.forEach(function (element) {
          $('#rate').append(
            $('<option></option>')
              .attr("value", $(element).val())
              .text($(element).text())
          );
        });
        $('#submit-promo-code').text('Apply Promo Code');
        $('#promo-code').prop('disabled', false);
        $('#promo-code').val("").trigger('input');
        return;
      }
      const enteredPromoCode = $('#promo-code').val();
      if (!enteredPromoCode) {
        return;
      }
      $('#submit-promo-code').prop('disabled', true);
      const urlParameters = new URLSearchParams(window.location.search);
      subscriptionId = urlParameters.get('subscription');
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "query getPromoCodeByText($text: String!, $subscription_id: String!) { getPromoCodeByText(text: $text, subscription_id: $subscription_id) { id, name, require_car_info } }",
          graphql_variables: JSON.stringify({
            "text": enteredPromoCode,
            "subscription_id": subscriptionId,
          })
        },
        success: function (results) {
          let { data, errors } = JSON.parse(results);
          const promoCodeValid = !errors && data?.getPromoCodeByText?.length > 0;
          if (promoCodeValid) {
            const { getPromoCodeByText } = data;
            const fieldsToToggle = [
              '#vehicle-make-0',
              '#vehicle-model-0',
              '#vehicle-state-0',
              '#vehicle-plate-number-0',
              '#vehicle-color-0'
            ];

            const toggleVehicleRequiredUI = (isRequired) => {
              fieldsToToggle.forEach((selector) => {
                const $field = $(selector);
                const $label = $field.closest('.form-field').find('label .required');

                if (isRequired) {
                  if (!$label.length) {
                    $field.closest('.form-field')
                      .find('label')
                      .append(' <span class="required">*</span>');
                  }
                } else {
                  $label.remove();
                }
              });
            };

            getPromoCodeByText.forEach(({ id, name, require_car_info }) => {
              $('#rate').append(
                $('<option></option>')
                  .attr('value', id)
                  .attr('data-is-promo-code-rate', true)
                  .attr('data-requires-car-info', require_car_info === 'REQUIRED')
                  .attr('data-is-sold-out', false)
                  .text(name)
              );

              $('#rate').val(id);

              const isRequired = require_car_info === 'REQUIRED';

              fieldsToToggle.forEach(function (selector) {
                if (isRequired) {
                  $(selector).attr('required', true);
                } else {
                  $(selector).removeAttr('required');
                }
              });

              // NEW: keep the asterisks in sync
              toggleVehicleRequiredUI(isRequired);
            });


            $('.card-content-error').remove();
            $('#rate').trigger('change');

            $('#submit-promo-code').text('Promo code valid!');
            $('#promo-code').prop('disabled', true);
          }else {
            $('#submit-promo-code').text('Promo code invalid');
          }
          setTimeout(() => {
            if (promoCodeValid) {
              $('#submit-promo-code').text('Clear Promo Code');
              $('.card-content-error').remove();
            } else {
              $('#submit-promo-code').text('Apply Promo Code');
            }
            $('#submit-promo-code').prop('disabled', false);
          }, 2500);
        },
        error: function (error) {
          console.log('error fetching rate from promo code', error);
          $('#submit-promo-code').text('Promo code invalid');
          setTimeout(() => {
            $('#submit-promo-code').text('Apply Promo Code');
            $('#submit-promo-code').prop('disabled', false);
          }, 2500);
        }
      });
    });
    // look up subscription and display parkers in list
    $('#subscription').change(function () {

      $('.card-content-overlay-loading').addClass('card-content-overlay-active');

      var subscriptionId = this.value;

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "query getSubscription($subscription_id: String!) { getSubscription(subscription_id: $subscription_id) { id, billing_profile { id, billing_day, terminationRule, termination_notice_day, facility { id, facility_name, address, timezone, myAccountFacilitySettings { showParkerTermination, showParkerAddition } } survey_questions { id, billing_profile_id, order, type, structure } }, parkers { id, barcode, suspension_status, termination_status, first_name, last_name, parker_status_history {action, start_date}}, payor { id, cognito_sub, billing_firstname, billing_lastname } } }", graphql_variables: JSON.stringify({
            "subscription_id": subscriptionId
          })
        },
        success: function (results) {

          let { data, errors } = JSON.parse(results);

          console.log('success!', data);

          window.history.replaceState('', '', '?subscription=' + subscriptionId);
          $('.parker-add').attr('href', '?subscription=' + subscriptionId + '&add=1').show();

          if (data.getSubscription) {

            var subscription = data.getSubscription;
            var parkers = subscription.parkers;

          const showParkerAddition = subscription.billing_profile.facility.myAccountFacilitySettings.showParkerAddition;
                $('.parker-add')
                  .attr('href', `?subscription=${subscription.id}&add=1`)
                  .toggle(showParkerAddition);
            if (parkers.length > 0) {

              if ($('.transactions-group ol').length) {
                $('.transactions-group ol').empty();
              } else {
                $('.transactions-group').append('<ol />');
              }


              parkers.forEach(function (parker) {

                const isActive = (parker.suspension_status === 'ACTIVE' || parker.termination_status === 'ACTIVE');
                const isTerminationPending = parker.termination_status === 'TERMINATION_PENDING';
                const isShowTerminateButton = isActive && subscription.billing_profile.facility.myAccountFacilitySettings.showParkerTermination && (!feature_flags.FEATURE_MYACCOUNT || !isTerminationPending);

                var template = '<li class="transaction" data-subscription-id="' + subscription.id + '" data-parker-id="' + parker.id + '" data-parker-name="' + parker.first_name + ' ' + parker.last_name + '"' + ` data-termination-day=${subscription.billing_profile.termination_notice_day} data-termination-rule=${subscription.billing_profile.terminationRule} ` + '>' +
                  '<div class="transaction-title">' +
                  `<a href="?subscription=${subscription.id}&parker=${parker.id}&edit=1" title="Edit ${parker.first_name} ${parker.last_name}" data-cy="parker-name-link">` + parker.first_name + ' ' + parker.last_name + '</a>' +
                  '</div>' +
                  '<div class="transaction-actions">' +
                  (parker.barcode ? '<a href="?subscription=' + subscription.id + '&parker=' + parker.id + '&barcode=true" title="View ' + parker.first_name + ' ' + parker.last_name + '\'s Barcode" class="parker-barcode" data-cy="parker-barcode-link">View Barcode</a>' : '') +
                  (isShowTerminateButton ? '<a href="#" title="Delete ' + parker.first_name + ' ' + parker.last_name + '" class="parker-delete" data-cy="parker-terminate-link">Terminate</a>' : '') +
                  '</div>' +
                  '<div class="transaction-meta">' +
                  '<p data-cy="parker-status-text">' + getParkerStatusText(parker); + '</p>' +
                    '</div>' +
                    '</li>';

                $('.transactions-group ol').append(template);

              });

            } else {

              console.log('Successfully retrieved the subscription, but there are no parkers to display!');
              $('.transactions-group').empty().append('<div class="card-content-error">There are no parkers for this subscription.</div>');

            }

            var questions = subscription.billing_profile.survey_questions;
            if (questions.length) {
              surveyQuestions(questions, 'TERMINATION', '#termination-survey-questions');
            }

          }

          $('.card-content-overlay-loading').removeClass('card-content-overlay-active');

        },
        error: function (results) {
          console.log('error!', results);
          $('.card-content-overlay-loading').removeClass('card-content-overlay-active');
          // display error message
        }
      });

    });

    /* remove this set of vehicle fields */
      $('#vehicles').on('click', '.vehicle-delete', function (e) {
        e.preventDefault();
        $(this).closest('.form-field-group-vehicle').remove();
        updateVehicleAddDisabled();
        updateVehicleSurchargeMessage();
      });

    function updateVehicleAddDisabled() {
      var currentCount = $('#vehicles').find('.form-field-group-vehicle').length;
      var maxActiveVehicleCount = Number($('.vehicle-add').data('max-active'));
      var atMax = maxActiveVehicleCount && currentCount >= maxActiveVehicleCount;

      $('.vehicle-add')
        .prop('disabled', atMax)
        .toggleClass('disabled', atMax)
        .attr(
          'title',
          atMax
            ? `This facility has a max active vehicle restriction of ${maxActiveVehicleCount} vehicles.`
            : ''
        );
    }

    function getMinimumActiveVehicleMessage(minActiveVehicleCount) {
      return `This facility requires at least ${minActiveVehicleCount} active vehicle${
        minActiveVehicleCount === 1 ? '' : 's'
      } per parker.`;
    }

    function countCurrentlyActiveVehicles(vehicles) {
      const now = moment();

      return vehicles.filter(function (vehicle) {
        if (!vehicle?.endDate) {
          return true;
        }

        return moment(vehicle.endDate).endOf('day').isAfter(now);
      }).length;
    }

    /* add another set of vehicle fields */
    $('.vehicle-add').click(function (e) {
       e.preventDefault();
      var currentCount = $('#vehicles').find('.form-field-group-vehicle').length;
      var maxActiveVehicleCount = Number($(this).data('max-active'));
      var atMax = maxActiveVehicleCount && currentCount >= maxActiveVehicleCount;

      if (atMax) {
        $(this)
          .prop('disabled', true)
          .addClass('disabled')
          .attr('title', `This facility has a max active vehicle restriction of ${maxActiveVehicleCount} vehicles.`);
        return;
      }

      var index = $('#vehicles').find('.form-field-group-vehicle').length;

      var template =  '<div class="form-field form-field-group form-field-group-vehicle" ' + 'id="vehicle-' + index + '">' +
        '<div class="form-field">' +
        '<label class="form-field-label" for="vehicle-make-' + index + '" data-cy="">Vehicle Make <span class="required">*</span></label>' +
        '<div class="select-wrapper">' +
        `<select name="vehicle-make" id="vehicle-make-${index}" data-cy="vehicle-make-input-${index}" required>` + 
        '<option value="" selected disabled>Select a make</option>' +
        '</select>' +
        '</div>' +
        '</div>' +
        '<div class="form-field">' +
        `<label class="form-field-label" for="vehicle-model-${index}">Vehicle Model <span class="required">*</span></label>` +
        '<div class="select-wrapper">' +
        `<select name="vehicle-model" id="vehicle-model-${index}" data-cy="vehicle-model-input-${index}" required disabled>` +
        '<option value="" selected disabled>Select a model</option>' +
        '</select>' +
        '</div>' +
        '</div>' +
        '<div class="form-field">' +
        '<label class="form-field-label" for="vehicle-state-' + index + '">License Plate State</label>' +
        '<div class="select-wrapper">' +
        `<select name="vehicle-state" id="vehicle-state-${index}" data-cy="vehicle-state-select-${index}"/>
          <option value="" <?php echo (empty($state)) ? 'selected' : ''; ?>Select a state/province</option>
            <option value="AB" <?php echo ($state == 'AB') ? 'selected' : ''; ?>Alberta</option>
            <option value="AK" <?php echo ($state == 'AK') ? 'selected' : ''; ?>Alaska</option>
            <option value="AZ" <?php echo ($state == 'AZ') ? 'selected' : ''; ?>Arizona</option>
            <option value="AR" <?php echo ($state == 'AR') ? 'selected' : ''; ?>Arkansas</option>
            <option value="BC" <?php echo ($state == 'BC') ? 'selected' : ''; ?>British Columbia</option>
            <option value="CA" <?php echo ($state == 'CA') ? 'selected' : ''; ?>California</option>
            <option value="CO" <?php echo ($state == 'CO') ? 'selected' : ''; ?>Colorado</option>
            <option value="CT" <?php echo ($state == 'CT') ? 'selected' : ''; ?>Connecticut</option>
            <option value="DE" <?php echo ($state == 'DE') ? 'selected' : ''; ?>Delaware</option>
            <option value="DC" <?php echo ($state == 'DC') ? 'selected' : ''; ?>District of Columbia</option>
            <option value="FL" <?php echo ($state == 'FL') ? 'selected' : ''; ?>Florida</option>
            <option value="GA" <?php echo ($state == 'GA') ? 'selected' : ''; ?>Georgia</option>
            <option value="HI" <?php echo ($state == 'HI') ? 'selected' : ''; ?>Hawaii</option>
            <option value="ID" <?php echo ($state == 'ID') ? 'selected' : ''; ?>Idaho</option>
            <option value="IL" <?php echo ($state == 'IL') ? 'selected' : ''; ?>Illinois</option>
            <option value="IN" <?php echo ($state == 'IN') ? 'selected' : ''; ?>Indiana</option>
            <option value="IA" <?php echo ($state == 'IA') ? 'selected' : ''; ?>Iowa</option>
            <option value="KS" <?php echo ($state == 'KS') ? 'selected' : ''; ?>Kansas</option>
            <option value="KY" <?php echo ($state == 'KY') ? 'selected' : ''; ?>Kentucky</option>
            <option value="LA" <?php echo ($state == 'LA') ? 'selected' : ''; ?>Louisiana</option>
            <option value="ME" <?php echo ($state == 'ME') ? 'selected' : ''; ?>Maine</option>
            <option value="MB" <?php echo ($state == 'MB') ? 'selected' : ''; ?>Manitoba</option>
            <option value="MD" <?php echo ($state == 'MD') ? 'selected' : ''; ?>Maryland</option>
            <option value="MA" <?php echo ($state == 'MA') ? 'selected' : ''; ?>Massachusetts</option>
            <option value="MI" <?php echo ($state == 'MI') ? 'selected' : ''; ?>Michigan</option>
            <option value="MN" <?php echo ($state == 'MN') ? 'selected' : ''; ?>Minnesota</option>
            <option value="MS" <?php echo ($state == 'MS') ? 'selected' : ''; ?>Mississippi</option>
            <option value="MO" <?php echo ($state == 'MO') ? 'selected' : ''; ?>Missouri</option>
            <option value="MT" <?php echo ($state == 'MT') ? 'selected' : ''; ?>Montana</option>
            <option value="NE" <?php echo ($state == 'NE') ? 'selected' : ''; ?>Nebraska</option>
            <option value="NV" <?php echo ($state == 'NV') ? 'selected' : ''; ?>Nevada</option>
            <option value="NB" <?php echo ($state == 'NB') ? 'selected' : ''; ?>New Brunswick</option>
            <option value="NL" <?php echo ($state == 'NL') ? 'selected' : ''; ?>Newfoundland and Labrador</option>
            <option value="NH" <?php echo ($state == 'NH') ? 'selected' : ''; ?>New Hampshire</option>
            <option value="NJ" <?php echo ($state == 'NJ') ? 'selected' : ''; ?>New Jersey</option>
            <option value="NM" <?php echo ($state == 'NM') ? 'selected' : ''; ?>New Mexico</option>
            <option value="NY" <?php echo ($state == 'NY') ? 'selected' : ''; ?>New York</option>
            <option value="NT" <?php echo ($state == 'NT') ? 'selected' : ''; ?>Northwest Territories</option>
            <option value="NC" <?php echo ($state == 'NC') ? 'selected' : ''; ?>North Carolina</option>
            <option value="ND" <?php echo ($state == 'ND') ? 'selected' : ''; ?>North Dakota</option>
            <option value="NS" <?php echo ($state == 'NS') ? 'selected' : ''; ?>Nova Scotia</option>
            <option value="NU" <?php echo ($state == 'NU') ? 'selected' : ''; ?>Nunavut</option>
            <option value="OH" <?php echo ($state == 'OH') ? 'selected' : ''; ?>Ohio</option>
            <option value="OK" <?php echo ($state == 'OK') ? 'selected' : ''; ?>Oklahoma</option>
            <option value="ON" <?php echo ($state == 'ON') ? 'selected' : ''; ?>Ontario</option>
            <option value="OR" <?php echo ($state == 'OR') ? 'selected' : ''; ?>Oregon</option>
            <option value="PE" <?php echo ($state == 'PE') ? 'selected' : ''; ?>Prince Edward Island</option>
            <option value="PA" <?php echo ($state == 'PA') ? 'selected' : ''; ?>Pennsylvania</option>
            <option value="QC" <?php echo ($state == 'QC') ? 'selected' : ''; ?>Quebec</option>
            <option value="RI" <?php echo ($state == 'RI') ? 'selected' : ''; ?>Rhode Island</option>
            <option value="SK" <?php echo ($state == 'SK') ? 'selected' : ''; ?>Saskatchewan</option>
            <option value="SC" <?php echo ($state == 'SC') ? 'selected' : ''; ?>South Carolina</option>
            <option value="SD" <?php echo ($state == 'SD') ? 'selected' : ''; ?>South Dakota</option>
            <option value="TN" <?php echo ($state == 'TN') ? 'selected' : ''; ?>Tennessee</option>
            <option value="TX" <?php echo ($state == 'TX') ? 'selected' : ''; ?>Texas</option>
            <option value="UT" <?php echo ($state == 'UT') ? 'selected' : ''; ?>Utah</option>
            <option value="VT" <?php echo ($state == 'VT') ? 'selected' : ''; ?>Vermont</option>
            <option value="VA" <?php echo ($state == 'VA') ? 'selected' : ''; ?>Virginia</option>
            <option value="WA" <?php echo ($state == 'WA') ? 'selected' : ''; ?>Washington</option>
            <option value="WV" <?php echo ($state == 'WV') ? 'selected' : ''; ?>West Virginia</option>
            <option value="WI" <?php echo ($state == 'WI') ? 'selected' : ''; ?>Wisconsin</option>
            <option value="WY" <?php echo ($state == 'WY') ? 'selected' : ''; ?>Wyoming</option>
            <option value="YT" <?php echo ($state == 'YT') ? 'selected' : ''; ?>Yukon</option>
        </select>` +  
        '</div>' +
        '</div>' +
        '<div class="form-field">' +
        '<label class="form-field-label" for="vehicle-plate-number-' + index + '">License Plate</label>' +
        `<input type="text" name="vehicle-plate-number" id="vehicle-plate-number-${index}" data-cy="vehicle-plate-input-${index}"/>` +
        '</div>' +
        '<div class="form-field">' +
        '<label class="form-field-label" for="vehicle-color-' + index + '">Vehicle Color</label>' +
        `<input type="text" name="vehicle-color" id="vehicle-color-${index}" data-cy="vehicle-color-input-${index}" />` +
        '</div>' +
        '<div class="form-field">' +
        '<label class="form-field-label" for="vehicle-decal-' + index + '">Vehicle Decal</label>' +
        `<input type="text" name="vehicle-decal" id="vehicle-decal-${index}" data-cy="vehicle-decal-input-${index}" />` +
        '</div>' +
        '<div class="form-field">' +
        `<button class="button button-small button-red vehicle-delete" data-cy="vehicle-delete-button-${index}">Delete This Vehicle</button>` +
        '</div>' +
        '</div>';

      $('.form-field-group-vehicles').append(template);
      const $newVehicle = $('#vehicle-' + index);
      const $makeSelect = $newVehicle.find('select[name="vehicle-make"]');
      const $modelSelect = $newVehicle.find('select[name="vehicle-model"]');
      populateVehicleMakeDropdown($makeSelect);
      $makeSelect.on('change', function () {
        const selectedMakeId = $(this).val();
        const selectedMakeName = $(this).find('option:selected').data('name');
        populateVehicleModelDropdown($modelSelect, selectedMakeId);
        $(this).data('make-name', selectedMakeName);
        updateVehicleSurchargeMessage();
      });
      $modelSelect.on('change', function () {
        const selectedModelName = $(this).find('option:selected').data('name');
        $(this).data('model-name', selectedModelName);
        updateVehicleSurchargeMessage();
      });
      updateVehicleAddDisabled();
      updateVehicleSurchargeMessage();
    });

    /* delete this parker */
    $('.transactions-group').on('click', '.parker-delete', function (e) {
      e.preventDefault();

      var subscriptionId = $(this).parents('.transaction').attr('data-subscription-id');
      var parkerId = $(this).parents('.transaction').attr('data-parker-id');
      var parkerName = $(this).parents('.transaction').attr('data-parker-name');
      var terminationRule = $(this).parents('.transaction').attr('data-termination-rule');
      var terminationDay = $(this).parents('.transaction').attr('data-termination-day');

      // trigger #termination-confirm overlay
      var terminationConfirm = $('#termination-confirm');
      var isThirtyDayNotice = ['HALF_MONTH', 'DAILY_PRORATION'].includes(terminationRule);
      if (isThirtyDayNotice) {
        $('#parker-termination-confirm').html(`
          <input type="date" id="parker-termination-date-picker" name="datemin" value="${createTerminationDate(true)}" min="${createTerminationDate(true)}">
          <br>
          <br>
          <p>
            Please select the desired Termination Date. This Facility requires 30-day Termination Notice. The earliest available
            Termination Date is
            <span class="parker-earliest-termination-day" data-cy="parker-earliest-termination-day-text"></span>.
          </p>
          <p>
            You will be responsible for <span class="parker-termination-proration-percentage"
              data-cy="parker-termination-proration-percentage"></span>% of
            fees for <span class="parker-termination-month-year" data-cy="parker-termination-month-year-text"></span> per the
            Terms and Conditions
            for this parking facility.
          </p>
          `);
        $('#parker-termination-date-picker').on('change', function (e) {
          // e.target.value is '' if the date is invalud
          if (!e.target.value) {
            return;
          }
          const valueAsMoment = moment(e.target.value, 'YYYY-MM-DD')
          $('.parker-termination-month-year', terminationConfirm).empty().text(valueAsMoment.format("MMMM YYYY"));
          $('.parker-termination-proration-percentage', terminationConfirm).empty().text(getTerminationProrationPercentage(terminationRule, terminationDay));
        })
        // the initial month and year is whatever the month and year of the current moment
        $('.parker-termination-month-year', terminationConfirm).empty().text(getTerminationMonthAndYear(true));
        $('.parker-termination-proration-percentage', terminationConfirm)
          .empty()
          .text(
            getTerminationProrationPercentage(terminationRule, terminationDay)
          );
        $('.parker-earliest-termination-day', terminationConfirm).empty().text(getTerminationDate(null, isThirtyDayNotice));
      } else {
        $('#parker-termination-confirm').html(
          'Are you sure you want to delete <span class="parker-name" data-cy="parker-name-text"></span>? Their last day to park would be <span class="parker-last-day" data-cy="parker-last-day-text"></span>.'
        );
        $('.parker-name', terminationConfirm).empty().text(parkerName);
        $('.parker-last-day', terminationConfirm).empty().text(getTerminationDate(null, isThirtyDayNotice));
      }

      $(terminationConfirm).addClass('card-content-overlay-active');

      $('#termination-confirm-cancel').off('click.termination').on('click.termination', function () {
        $(terminationConfirm).removeClass('card-content-overlay-active');
        $('.form-card-message').empty();
      });

      $('#termination-confirm-ok').off('click.termination').on('click.termination', function () {
        const $confirmButton = $(this);
        if ($confirmButton.prop('disabled')) {
          return;
        }
        $confirmButton.prop('disabled', true);

        function enableTerminationButtons() {
          $confirmButton.prop('disabled', false);
          $('.button-spinner', $confirmButton).prop('disabled', false);
          $('.button-spinner', $confirmButton).css('display', '');
          $('#termination-confirm-cancel').prop('disabled', false);
        }
        if (isThirtyDayNotice) {
          const earliestTerminationDayAsMoment = moment(getTerminationDate(null, isThirtyDayNotice), '"MMMM D, YYYY"');

          const terminationDayAsMoment = moment($('#parker-termination-date-picker').val(), 'YYYY-MM-DD');
          if (!terminationDayAsMoment.isValid()) {
            enableTerminationButtons();
            $('.form-card-message')
              .empty()
              .removeClass('form-card-message-success')
              .addClass('form-card-message-error')
              .text('Please enter a valid termination date.');
            return;
          }
          if (terminationDayAsMoment.isBefore(earliestTerminationDayAsMoment)) {
            enableTerminationButtons();
            $('.form-card-message')
              .empty()
              .removeClass('form-card-message-success')
              .addClass('form-card-message-error')
              .text('The date entered cannot be before the earliest available Termination Date.');
            return;
          }
        }
        $('.form-card-message').empty();

        // var terminationDate = moment().add(1, 'day').format('YYYY-MM-DD');
        var terminationDate = createTerminationDate();
        if (isThirtyDayNotice) {
          terminationDate = $('#parker-termination-date-picker').val();
        }
        var surveyResponses = new Array();

        if ($('#termination-survey-questions .form-field').length > 0) {

          $('#manage-parkers-card').addClass('card-collapsed');
          $('#termination-survey-card').removeClass('card-collapsed');

          $('#termination-survey').off('submit.termination').on('submit.termination', function (e) {
            e.preventDefault();
            $('.button-spinner', this).prop('disabled', true);
            $('#termination-survey-submit').prop('disabled', true);
            $('#termination-survey-skip').prop('disabled', true);
            $('#termination-survey-skip').css('display', 'none');
            $(this).prop('disabled', true);

            // loop through questions, gather prompts and responses, and add to array
            $('#termination-survey-questions .form-field').each(function () {
              var question = new Object();
              question.prompt = $('.prompt', this).text();
              var questionType = $(this).attr('data-question-type');
              if (questionType == 'radio') {
                question.response = $('input[type="radio"]:checked', this).val();
              } else if (questionType == 'select') {
                question.response = $('select', this).val();
              } else if (questionType == 'text') {
                question.response = $('input[type="text"]', this).val();
              }
              surveyResponses.push(question);
            });

            $.ajax({
              type: 'post',
              url: '/wp-admin/admin-ajax.php',
              data: {
                action: 'chirp_graphql',
                api_version: 'v2',
                authorization: graphQLAuth,
                nonce: graphQLNonce,
                graphql_request: "mutation myAccountTerminateParker($parkerId: String!, $terminationDate: String!, $surveyResponses: [MyAccountTerminateParkerSurveyResponseInput!]) { myAccountTerminateParker(parkerId: $parkerId, terminationDate: $terminationDate, surveyResponses: $surveyResponses) }",
                graphql_variables: JSON.stringify({
                  parkerId,
                  terminationDate,
                  surveyResponses
                })
              },
              success: function (results) {

                let { data, errors } = JSON.parse(results);

                console.log('success!', data);
                window.location.reload();
              },
              error: function (results) {
                console.log('error!', results);
                $('.button-spinner', this).prop('disabled', false);
                $('#termination-survey-submit').prop('disabled', false);
                $('#termination-survey-skip').prop('disabled', false);
                $('#termination-survey-skip').css('display', '');
              }
            });

          });

        } else {

          $(this).prop('disabled', true);
          $('.button-spinner', this).prop('disabled', true);
          $('#termination-confirm-cancel').prop('disabled', true);

          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'chirp_graphql',
              api_version: 'v2',
              authorization: graphQLAuth,
              nonce: graphQLNonce,
              graphql_request: "mutation myAccountTerminateParker($parkerId: String!, $terminationDate: String!, $surveyResponses: [MyAccountTerminateParkerSurveyResponseInput!]) { myAccountTerminateParker(parkerId: $parkerId, terminationDate: $terminationDate, surveyResponses: $surveyResponses) }",
              graphql_variables: JSON.stringify({
                parkerId,
                terminationDate,
                surveyResponses
              })
            },
            success: function (results) {
              let { data, errors } = JSON.parse(results);
              console.log('success!', data);
              if (errors) {
                enableTerminationButtons();

                const errorMessage = errors[0]?.message || '';
                if (errorMessage.includes('exceeds')) {
                  $('.form-card-message')
                    .empty()
                    .removeClass('form-card-message-success')
                    .addClass('form-card-message-error')
                    .text('Please contact your parking manager to complete this termination.');
                  return;
                }
                $('.form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('An error occurred: ' + errors[0].message);
                return;
              }
              window.location.reload();
            },
            error: function (results) {
              console.log('error!', results);
              enableTerminationButtons();
            }
          });

        }

      });

    });

    /* submit #edit-parker form */
    $('#edit-parker').validate({
      // debug: true,
      errorElement: 'span',
      errorClass: 'form-field-error',
      validClass: 'form-field-valid',
      errorPlacement: function (error, element) {
        error.appendTo(element.parents('.form-field'));
      },
      highlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
      },
      rules: {
        'first-name': {
          required: true,
          minlength: 2
        },
        'last-name': {
          required: true,
          minlength: 2
        },
        'email-address': {
          required: true,
          email: true
        },
        'country-code': {
          required: {
            depends: function (element) {
              // Make country code required only if phone number has a value
              return $("#phone-number").val().length > 0;
            }
          },
          minlength: 1,
          maxlength: 3,
        },
        'phone-number': {
          // required: true,
          phoneUS: true
        },
        'street-address': {
          // required: true,
          minlength: 2
        },
        'city': {
          // required: true,
          minlength: 2
        },
        'zip-code': {
          // required: true,
          zipcodeUS: true
        }
      },
      messages: {
        'first-name': {
          required: 'Please enter your first name.',
          minlength: 'Your first name must be at least 2 characters long.'
        },
        'last-name': {
          required: 'Please enter your last name.',
          minlength: 'Your last name must be at least 2 characters long.'
        },
        'email-address': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.'
        },
        'street-address': {
          // required: 'Please enter your street address',
          minlength: 'Please enter a valid street address.'
        },
        'city': {
          // required: 'Please enter your city.',
          minlength: 'Please enter a valid city name.'
        },
        'zip-code': {
          // required: 'Please enter your zip code.',
          zipcodeUS: 'Please enter a valid zip code.'
        },
        'country-code': {
          required: 'Country code is required when phone number is provided.',
          minlength: 'Please enter a valid country code.',
          maxlength: 'Country code should not exceed 3 characters.'
        }
      },
      submitHandler: function (form) {
        $('.button-spinner', form).prop('disabled', true);

        var subscriptionId = getUrlParameter('subscription');
        var parkerId = getUrlParameter('parker');

        var parker = new Object();

        parker.id = parkerId;
        parker.firstName = $('#first-name').val();
        parker.lastName = $('#last-name').val();
        parker.email = $('#email-address').val();
        parker.countryCode = Number($('#country-code').val());
        parker.phone = $('#phone-number').val();
        parker.address = $('#street-address').val();
        parker.city = $('#city').val();
        parker.state = $('#state').val();
        parker.zip = $('#zip-code').val();
        var integration = $('#facility-integration').val();

        var vehiclesObject = $('#vehicles').find('.form-field-group-vehicle');

        var vehicles = new Array();
        let hasError = false;
        $(vehiclesObject).each(function () {
          var vehicle = new Object();
          vehicle.id = $(this).closest('.form-field-group-vehicle').data('vehicle-id') || null;
          vehicle.make = $('select[name="vehicle-make"]', this).find('option:selected').data('name');
          vehicle.model = $('select[name="vehicle-model"]', this).find('option:selected').data('name');
          vehicle.modelId = $(this).closest('.form-field-group-vehicle').data('model-id') || $('select[name="vehicle-model"]', this).find('option:selected').data('id');
          vehicle.state = $('select[name="vehicle-state"]', this).val();
          vehicle.license = $('input[name="vehicle-plate-number"]', this).val();
          vehicle.color = $('input[name="vehicle-color"]', this).val();
          vehicle.decal = $('input[name="vehicle-decal"]', this).val();

          const vehicleValues = Object.values(vehicle);
          if (integration === 'GET_MY_PARKING' && !vehicle.license) {
            const missingLicenseErrorMessage = 'A license is required for all vehicles.';
            
            $('.form-card-message', form)
              .empty()
              .removeClass('form-card-message-success')
              .addClass('form-card-message-error')
              .text(missingLicenseErrorMessage);
            $('.button-spinner', form).prop('disabled', false);

            hasError = true;
            return false; 
          }
          const vehicleHasValue = vehicleValues.some(value => value && value !== '');

          if (vehicleHasValue) vehicles.push(vehicle);
        });

        if (hasError) {
          return;
        }

        if (integration === 'GET_MY_PARKING' && !vehicles.length) {
          const errorMessage = 'At least one vehicle is required.';
          
          $('.form-card-message', form)
            .empty()
            .removeClass('form-card-message-success')
            .addClass('form-card-message-error')
            .text(errorMessage);

          $('.button-spinner', form).prop('disabled', false);

          return;
        }

        const minActiveVehicleCount = Number($('.vehicle-add').data('min-active')) || 0;
        const currentActiveVehicleCount = Number($('.vehicle-add').data('current-active')) || 0;
        if (
          minActiveVehicleCount &&
          currentActiveVehicleCount >= minActiveVehicleCount &&
          vehicles.length < minActiveVehicleCount
        ) {
          $('.form-card-message', form)
            .empty()
            .removeClass('form-card-message-success')
            .addClass('form-card-message-error')
            .text(getMinimumActiveVehicleMessage(minActiveVehicleCount));

          $('.button-spinner', form).prop('disabled', false);

          return;
        }
        parker.vehicles = vehicles;

        console.log(parker);

        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_graphql',
            authorization: graphQLAuth,
            nonce: graphQLNonce,
            graphql_request: "mutation myAccountUpdateParker($subscriptionId: String!, $parker: ParkerInputType!) { myAccountUpdateParker(subscriptionId: $subscriptionId, parker: $parker) }",
            graphql_variables: JSON.stringify({
              "parker": parker,
              "subscriptionId": subscriptionId
            }),
            api_version: 'v2',
          },
          success: function (results) {
            let { data, errors } = JSON.parse(results);
            console.log('success!');

            if (!errors?.length) {

              $('.button-spinner', form).prop('disabled', false);
              $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(parker.firstName + ' ' + parker.lastName + ' has been updated!');
              vehicles.forEach(function (vehicle, index) {
                $('#vehicle-make-' + index).prop('disabled', true);
                $('#vehicle-model-' + index).prop('disabled', true);
                $('#vehicle-state-' + index).val(vehicle.state).prop('disabled', false);
                $('#vehicle-color-' + index).val(vehicle.color).prop('disabled', false);
                $('#vehicle-decal-' + index).val(vehicle.decal).prop('disabled', false);
                $('#vehicle-plate-number-' + index).val(vehicle.license).prop('disabled', false);
              });
              setTimeout(function () {
                window.location.href = window.location.pathname + '?subscription=' + subscriptionId + '&parker=' + parker.id + '&edit=1';
              }, 500);
            } else {
              const errorMessage = errors?.[0]?.message || 'Something went wrong. Try again?';
              $('.button-spinner', form).prop('disabled', false);
              $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(errorMessage);

            }

          },
          error: function (results) {
            console.log('error!', results);
            $('.button-spinner', form).prop('disabled', false);
            $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong. Try again?');
          }
        });

      }
    });

    /* submit #add-parker form */
    $('#add-parker').validate({
      // debug: true,
      errorElement: 'span',
      errorClass: 'form-field-error',
      validClass: 'form-field-valid',
      errorPlacement: function (error, element) {
        error.appendTo(element.parent('.form-field'));
      },
      highlight: function (element, errorClass, validClass) {
        $(element).parent('.form-field').addClass(errorClass).removeClass(validClass);
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).parent('.form-field').removeClass(errorClass).addClass(validClass);
      },
      rules: {
        'start-date': {
          required: true
        },
        'rate': {
          required: true
        },
        'first-name': {
          required: true,
          minlength: 2
        },
        'last-name': {
          required: true,
          minlength: 2
        },
        'email-address': {
          required: true,
          email: true
        },
        'phone-number': {
          // required: true,
          minlength: 10,
          maxlength: 10
        },
        'street-address': {
          // required: true,
          minlength: 2
        },
        'city': {
          // required: true,
          minlength: 2
        },
        'zip-code': {
          // required: true,
          zipcodeUS: true
        },
      },
      messages: {
        'start-date': {
          required: 'Please choose a start date.'
        },
        'rate': {
          required: 'Please choose a rate.'
        },
        'first-name': {
          required: 'Please enter your first name.',
          minlength: 'Your first name must be at least 2 characters long.'
        },
        'last-name': {
          required: 'Please enter your last name.',
          minlength: 'Your last name must be at least 2 characters long.'
        },
        'email-address': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.'
        },
        'phone-number': {
          // required: 'Please enter your phone number.',
          minlength: 'Please provide a valid phone number',
          maxlength: 'Please provide a valid phone number'
        },
        'street-address': {
          // required: 'Please enter your street address',
          minlength: 'Please enter a valid street address.'
        },
        'city': {
          // required: 'Please enter your city.',
          minlength: 'Please enter a valid city name.'
        },
        'zip-code': {
          // required: 'Please enter your zip code.',
          zipcodeUS: 'Please enter a valid zip code.'
        }
      },
      submitHandler: function (form) {
        console.log('submitting');
        $('.button-spinner', form).prop('disabled', true);

        var subscriptionId = getUrlParameter('subscription');
        var rateId = $('#rate').val();
        console.log('RATEEEEE', $('#rate'));
        const startDate = $('#start-date').val();

        var parker = new Object();
        parker.first_name = $('#first-name').val();
        parker.last_name = $('#last-name').val();
        parker.email = $('#email-address').val();
        parker.country_code = $('#country-code').val();
        parker.phone = $('#phone-number').val();
        parker.address = $('#street-address').val();
        parker.city = $('#city').val();
        parker.state = $('#state').val();
        parker.zip = $('#zip-code').val();

        var vehiclesObject = $('#vehicles').find('.form-field-group-vehicle');

        var vehicles = new Array();
        $(vehiclesObject).each(function () {
          var vehicle = new Object();
          vehicle.make = $('select[name="vehicle-make"]', this).find('option:selected').data('name');
          vehicle.modelId = $('select[name="vehicle-model"]', this).find('option:selected').data('id');
          vehicle.model = $('select[name="vehicle-model"]', this).find('option:selected').data('name');
          vehicle.state = $('select[name="vehicle-state"]', this).val();
          vehicle.license = $('input[name="vehicle-plate-number"]', this).val();
          vehicle.color = $('input[name="vehicle-color"]', this).val();
          vehicle.decal = $('input[name="vehicle-decal"]', this).val();

          const vehicleValues = Object.values(vehicle);
          const vehicleHasValue = vehicleValues.some(value => value && value !== '');

          if (vehicleHasValue) vehicles.push(vehicle);
        });

        parker.vehicles = vehicles;

        parker.access_devices = accessDevices.reduce((acc, device) => {
          if (device.required) {
            return [...acc, { type: accessDeviceTypeMap[device.type] }];
          }
          return acc;
        }, []);

        console.log('parker: ', parker);
        console.log('rate_id:', rateId);
        console.log('subscription_id:', subscriptionId);

        var ratePurchase = new Object();
        ratePurchase.rate_id = rateId;
        ratePurchase.parkers = [{ ...parker, vehicles }]

        const maxActiveVehicleCount = Number($('.vehicle-add').data('max-active'));
        if (maxActiveVehicleCount && vehicles.length > maxActiveVehicleCount) {
          $('.form-card-message', form)
            .empty()
            .removeClass('form-card-message-success')
            .addClass('form-card-message-error')
            .text(`This facility allows at most ${maxActiveVehicleCount} active vehicles.`);
          $('.button-spinner', form).prop('disabled', false);
          return;
        }

        const minActiveVehicleCount = Number($('.vehicle-add').data('min-active')) || 0;
        if (minActiveVehicleCount && vehicles.length < minActiveVehicleCount) {
          $('.form-card-message', form)
            .empty()
            .removeClass('form-card-message-success')
            .addClass('form-card-message-error')
            .text(getMinimumActiveVehicleMessage(minActiveVehicleCount));
          $('.button-spinner', form).prop('disabled', false);
          return;
        }

        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_graphql',
            api_version: 'v2',
            authorization: graphQLAuth,
            nonce: graphQLNonce,
            graphql_request: "mutation myAccountCreateParker($subscriptionId: String!, $rateId: String!, $startDate: String!, $firstName: String!, $lastName: String!, $email: String, $address: String, $city: String, $state: String, $zip: String, $countryCode: String, $phone: String, $vehicles: [VehicleInputType]) { myAccountCreateParker(subscriptionId: $subscriptionId, rateId: $rateId, startDate: $startDate, firstName: $firstName, lastName: $lastName, email: $email, address: $address, city: $city, state: $state, zip: $zip, countryCode: $countryCode, phone: $phone, vehicles: $vehicles) }",
            graphql_variables: JSON.stringify({
              subscriptionId,
              rateId,
              startDate,
              firstName: parker.first_name,
              lastName: parker.last_name,
              email: parker.email,
              address: parker.address,
              street: parker.street,
              city: parker.city,
              state: parker.state,
              zip: parker.zip,
              countryCode: parker.country_code,
              phone: parker.phone,
              vehicles: parker.vehicles
            })
          },
          success: function (results) {
            let { data, errors } = JSON.parse(results);

            if (!errors?.length) {
              console.log('success!', data);
              console.log('results =', results);

              $('.button-spinner', form).prop('disabled', false);
              $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(parker.first_name + ' ' + parker.last_name + ' has been added!');

              setTimeout(function () {
                window.location.href = window.location.pathname + '?subscription=' + subscriptionId;
              }, 1000);
            } else {
              console.log('errors', errors);
              const errorMessage = errors?.[0]?.message || 'Something went wrong? Please try again.';
              $('.button-spinner', form).prop('disabled', false);
              $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(errorMessage);
            }
          },
          error: function (results) {
            console.log('error!', results);
            $('.button-spinner', form).prop('disabled', false);
            $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong? Please try again.');
          }
        });
      }
    });
  }

  /*** monthly :: cancel subscription ***/
  if ($('body').hasClass('page-template-page-account-monthly-cancel')) {

    var thisSubscription = getUrlParameter('subscription');

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'chirp_graphql',
        authorization: graphQLAuth,
        nonce: graphQLNonce,
        graphql_request: "query listUserSubscriptions($paymentProviderId: Int) { listUserSubscriptions(paymentProviderId: $paymentProviderId) { id, account_id, billing_profile { facility { id, facility_name, address, timezone } } } }",
        graphql_variables: JSON.stringify(listUserSubscriptionsVariables())
      },
      success: function (results) {
        let { data } = JSON.parse(results);

        if (data && data.listUserSubscriptions.length > 0) {
          var subscriptions = data.listUserSubscriptions;

          subscriptions.forEach(function (subscription) {
            var facilityName = 'FACILITY NAME';
            if (subscription.billing_profile.facility) {
              facilityName = subscription.billing_profile.facility.facility_name;
            }
            var option = '<option value="' + subscription.id + '">' + 'Monthly Parking at ' + facilityName + ' (AC-' + subscription.account_id + ')' + '</option>';

            $('select[name="subscription"]').append(option);

            if (thisSubscription == subscription.id) {
              $('select[name="subscription"]').val(subscription.id);
              // get subscription name from selected option
              var subscriptionName = $('#subscription option[value="' + thisSubscription + '"]').text();
              // change "Product Name at Facility Name" to name of chosen subscription
              $('#subscription-name').text(subscriptionName);
              // make rest of fields visible
              $('.form-field-optional').show();
            }

          });

        } else {

          console.log('You don\'t have any subscriptions.')
          $('.card-content').append('<div class="card-content-error">You don\'t have any subscriptions.</div>');

        }

        $('.card-content-overlay').removeClass('card-content-overlay-active');

      },
      error: function (results) {
        console.log(results);
      }
    });
  }

  /*** monthly :: SlidePay payment submitted ***/
  if ($('body').hasClass('page-template-page-account-monthly-payment-submitted')) {
    const thisInvoice = getUrlParameter('invoice');
    const thisStatus = getUrlParameter('status');
    const thisTransactionId = getUrlParameter('transactionId');

    function processExternalPayment(invoiceId, transactionId) {
      $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          api_version: 'v2',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: `
            mutation processExternalPayment($invoiceId: String!, $paymentMetaId: String!, $paymentType: String!) {
              processExternalPayment(invoiceId: $invoiceId, paymentMetaId: $paymentMetaId, paymentType: $paymentType) {
                invoiceId
              }
            }
          `,
          graphql_variables: JSON.stringify({
            invoiceId: thisInvoice,
            paymentMetaId: thisTransactionId,
            paymentType: 'card'
          })
        },
        success: function (response) {
          const { errors } = JSON.parse(response);

          if (errors) {
            $('#payment-status-title').text('Error');
            $('#payment-status-message').text('The payment was successful, but an error occurred updating the invoice. Please contact support.');
            return;
          }

          const activityUrl = `${window.location.host}/account/monthly/activity/?invoice=${thisInvoice}`;
          window.location.href = activityUrl;
        },
        error: function (err) {
          console.log('Error:', err);
          $('#payment-status-title').text('Error');
          $('#payment-status-message').text('The payment was successful, but an error occurred updating the invoice. Please contact support.');
        }
      })
    }

    switch (thisStatus.toLocaleLowerCase()) {
      case 'success':
        $('#payment-status-title').text('Payment Approved');
        $('#payment-status-message').text('Payment accepted. Please wait while we update your invoice.');
        processExternalPayment(thisInvoice, thisTransactionId);
        break;
      case 'declined':
        $('#payment-status-title').text('Payment Declined');
        $('#payment-status-message').text('Please wait and try again or choose a different payment method.');
        break;
      case 'cancelled':
        $('#payment-status-title').text('Payment Cancelled');
        $('#payment-status-message').text('You have cancelled this One-Time Payment. Please start over.')
        break;
      default:
        $('#payment-status-title').text('Error');
        $('#payment-status-message').text('There was an error processing your payment. Please retry the payment or select a different payment method.');
    }
  }

  // show rest of fields once a subscription is chosen
  $('#subscription').change(function () {
    // get subscription name from selected option
    var subscriptionName = $('option:selected', this).text();
    // change "Product Name at Facility Name" to name of chosen subscription
    $('#subscription-name').text(subscriptionName);
    // uncheck the "are you sure?" checkbox on subscription change
    $('input[id="are-you-sure-yes"]').prop('checked', false);
    // re-disable the submit button on subscription change
    $('#submit-button').prop('disabled', true);
    // make rest of fields visible
    $('.form-field-optional').show();
  });

  // enable submit button when checkbox is checked
  $('input[id="are-you-sure-yes"]').click(function () {
    if (this.checked) {
      $('#submit-button').prop('disabled', false);
      console.log(this.checked);
    } else {
      $('#submit-button').prop('disabled', true);
      console.log(this.checked);
    }
  });

  $('#cancel-subscription').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    rules: {
      'subscription': {
        required: true
      },
      'are-you-sure': {
        required: true
      }
    },
    messages: {
      'subscription': {
        required: 'Please choose a subscription to cancel.'
      },
      'are-you-sure': {
        required: 'Please confirm that you would like to cancel your subscription.'
      }
    },
    submitHandler: function (form) {
      console.log('form submitted!');

      var subscriptionId = $('#subscription').val();
      var areYouSure = $('input[name="are-you-sure"]').val();

      // TODO: figure out JSON string to submit to API to cancel this subscription

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "",
          graphql_variables: JSON.stringify({})
        },
        success: function (results) {
          let { data } = JSON.parse(results);
          console.log(data);
        },
        error: function (results) {
          console.log(results);
        }
      });

    }
  });

  /*** AWS Cognito Experiments ***/
  // get endpoint url from meta tag
  var aws_api_endpoint_url = $('meta[name="aws-api-endpoint-url"]').attr('content');

  $('#aws-cognito-create-account').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
      error.attr('data-cy', `${error[0].id}-text`);
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    'rules': {
      'create-first-name': {
        required: true,
        minlength: 2
      },
      'create-last-name': {
        required: true,
        minlength: 2
      },
      'create-email-address': {
        required: true,
        email: true
      },
      'create-country-code': {
        required: true,
        minlength: 1,
        maxlength: 3
      },
      'create-phone-number': {
        required: true,
        minlength: 10,
        maxlength: 15,
      },
      'create-password': {
        required: true,
        minlength: 12,
        maxlength: 99
      },
      'create-password-match': {
        required: true,
        minlength: 12,
        maxlength: 99,
        equalTo: '#create-password'
      }
    },
    'messages': {
      'create-first-name': {
        required: 'Please enter your first name.',
        minlength: 'Your first name must be at least 2 characters long.'
      },
      'create-last-name': {
        required: 'Please enter your last name.',
        minlength: 'Your last name must be at least 2 characters long.'
      },
      'create-email-address': {
        required: 'Please enter your email address.',
        email: 'Please enter a valid email address.'
      },
      'create-country-code': {
        required: 'Please enter your country code.',
        minlength: 'Your country code must be at least 1 character long.',
        maxlength: 'Your country code must be 3 characters or less.'
      },
      'create-phone-number': {
        required: 'Please enter your phone number.',
        minlength: 'Your phone number must be at least 10 characters long.',
        maxlength: 'Your phone number must be 15 characters or less.'
      },
      'create-password': {
        required: 'Please provide a password.',
        minlength: 'Your password must be at least 12 characters long.',
        maxlength: 'Your password must be 64 characters or less.'
      },
      'create-password-match': {
        required: 'Your password does not match the previous field.',
        minlength: 'Your password must be at least 12 characters long.',
        maxlength: 'Your password must be 64 characters or less.',
        equalTo: 'Your password does not match the previous field.'
      }
    },
    submitHandler: function (form) {
      // enable spinner animation on submit button
      $('.button-spinner', form).prop('disabled', true);

      grecaptcha.ready(function() {
        grecaptcha.execute(recaptcha_site_key, { action: 'aws_cognito_create_account' }).then(function(token) {
          // get all the variables
          var first_name = $('#create-first-name', form).val();
          var last_name = $('#create-last-name', form).val();
          var email_address = $('#create-email-address', form).val();
          var password = $('#create-password').val();
          var country_code = $('#create-country-code').val();
          var phone_number = $('#create-phone-number').val();
          // var nonce = $('#aws-cognito-create-account-nonce', form).val();

          // do something with them!
          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'aws_cognito_create_account',
              first_name: first_name,
              last_name: last_name,
              email_address: email_address,
              password: password,
              recaptcha_token: token,
              country_code: country_code,
              natl_phone: phone_number,
            },
            success: function (results) {
              var results = JSON.parse(results);
              // console.log(results);
              if (results.status === 'success') {
                $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
                // pre-fill email address field on next step
                $('#confirm-email-address').val(results.email_address);
                // hide this step and show next step
                setTimeout(function () {
                  $(form).removeClass('form-flow-active');
                  $(form).next().addClass('form-flow-active');
                }, 250);
              } else if (results.status === 'error') {
                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
              } else {
                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');
              }
              // disable spinner animation on submit button
              $('.button-spinner', form).prop('disabled', false);
            },
            error: function (results) {
              // var results = JSON.parse(results);
              console.log(results);
              // disable spinner animation on submit button
              $('.button-spinner', form).prop('disabled', false);
            }
          });
        });
      });
    }
  });

  $('#aws-cognito-confirm-account').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    'rules': {
      'confirmation-code': {
        required: true,
        number: true,
        minlength: 6,
        maxlength: 6
      }
    },
    'messages': {
      'confirmation-code': {
        required: 'Please enter your confirmation code',
        number: 'Your confirmation code is a six digit number.',
        minlength: 'Your confirmation code is too short.',
        maxlength: 'Your confirmation code is too long.'
      }
    },
    submitHandler: function (form) {
      // enable spinner animation on submit button
      $('.button-spinner', form).prop('disabled', true);

      grecaptcha.ready(function() {
        grecaptcha.execute(recaptcha_site_key, { action: 'aws_cognito_confirm_account' }).then(function(token) {
          // get all the variables
          var email_address = $('#confirm-email-address', form).val();
          var confirmation_code = $('#confirmation-code', form).val();
          // var nonce = $('#aws-cognito-confirm-account-nonce', form).val();

          // do something with them!
          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'aws_cognito_confirm_account',
              email_address: email_address,
              confirmation_code: confirmation_code,
              recaptcha_token: token
              // nonce: nonce
            },
            success: function (results) {
              var results = JSON.parse(results);
              // console.log(results);
              if (results.status === 'success') {
                $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
                var redirect_url = $(form).attr('data-redirect-url');
                if (redirect_url) {
                  if (redirect_url === 'reload') {
                    setTimeout(function () {
                      location.reload();
                    }, 250);
                  } else {
                    setTimeout(function () {
                      window.location.href = redirect_url;
                    }, 250);
                  }
                }
              } else if (results.status === 'error') {
                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
              } else {
                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');
              }
              // disable spinner animation on submit button
              $('.button-spinner', form).prop('disabled', false);
            },
            error: function (results) {
              console.log(results);
              // disable spinner animation on submit button
              $('.button-spinner', form).prop('disabled', false);
            }
          });
        });
      });
    }
  });

  $('#go-to-resend-confirmation-code-form').on('click', function (e) {
    e.preventDefault();
    // pre-fill email address on next form
    var email_address = $('#confirm-email-address').val();
    $('#resend-email-address').val(email_address);
    // get the current form
    var this_form = $(this).parents('form');
    // hide this form and show the next form
    $(this_form).removeClass('form-flow-active');
    $(this_form).next().addClass('form-flow-active');
  });

  $('#aws-cognito-resend-confirmation-code').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    'rules': {
      'resend-email-address': {
        required: true,
        email: true
      }
    },
    'messages': {
      'resend-email-address': {
        required: 'Please enter your email address.',
        email: 'Please enter a valid email address.'
      }
    },
    submitHandler: function (form) {
      // enable spinner animation on submit button
      $('.button-spinner', form).prop('disabled', true);

      grecaptcha.ready(function() {
        grecaptcha.execute(recaptcha_site_key, { action: 'aws_cognito_resend_confirmation_code' }).then(function(token) {

          // get all the variables
          var email_address = $('#resend-email-address').val();
          // var nonce = $('#aws-cognito-resend-confirmation-code-nonce', form).val();

          // do something with them!
          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'aws_cognito_resend_confirmation_code',
              email_address: email_address,
              recaptcha_token: token
              // nonce: nonce
            },
            success: function (results) {
              var results = JSON.parse(results);
              console.log(results);
              if (results.status === 'success') {

                $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

              } else if (results.status === 'error') {

                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);

              } else {

                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');

              }

              // go back to confirm account form
              setTimeout(function () {
                $(form).removeClass('form-flow-active');
                $(form).prev().addClass('form-flow-active');
              }, 3000);

              // disable spinner animation on submit button
              $('.button-spinner', form).prop('disabled', false);
            },
            error: function (results) {
              console.log(results);
              // disable spinner animation on submit button
              $('.button-spinner', form).prop('disabled', false);
            }
          });

        });
      });
    }
  });

  // show/hide ABM Single Sign-On button in Log In form
  if (feature_flags.FEATURE_ABM_SINGLE_SIGN_ON == true) {
    var testSSOEmails = [
      'jacob.greenwald@parkchirp.com',
      'caroline.sso@parkchirp.com',
      'nathan.sso@parkchirp.com',
      'abmssotest@parkchirp.com',
    ];

    var input = $('#login-email-address');
    if ($(input).length > 0) {
      var timeout = null;
      var match = false;
      var domains = ['abm.com'];
      $(input).on('input', function () {
        var value = $(this).val().toLowerCase();
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          $(domains).each(function (index, domain) {
            domain = domain.toLowerCase();
            if (value.includes('@' + domain)) {
              match = true;
            }
          });
          if (match === true || testSSOEmails.includes(value)) {
            var abm_sso_url = $('meta[name="abm-sso-url"]').attr('content');
            console.log('abm_sso_url:', abm_sso_url);
            $('#login-abm-sso-button .button').attr('href', abm_sso_url);
            $('#login-password-and-submit-fields').hide();
            $('#login-abm-sso-button').show();
            $('.login-boxes-footer').hide();
          }
        }, 125);
        $('#login-abm-sso-button').hide();
        $('#login-password-and-submit-fields').show();
        $('#login-abm-sso-button .button').attr('href', '#');
        $('.login-boxes-footer').show();
        match = false;
      });
    }
  }
  
  // toggle password field visibility
  $('.password-input-toggle').on('click', function(e) {
    e.preventDefault();
    var input = $(this).prev();
    if ($(input).is('[type="password"]')) {
      $(input).attr('type', 'text');
      $('.password-input-toggle-icon-hide', this).hide();
      $('.password-input-toggle-icon-show', this).show();
    } else if ($(input).is('[type="text"]')) {
      $(input).attr('type', 'password');
      $('.password-input-toggle-icon-show', this).hide();
      $('.password-input-toggle-icon-hide', this).show();
    }
  });

  $('#aws-cognito-log-in').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    'rules': {
      'login-email-address': {
        required: true,
        email: true
      },
      'login-password': {
        required: true
      }
    },
    'messages': {
      'login-email-address': {
        required: 'Please enter your email address.',
        email: 'Please enter a valid email address.'
      },
      'login-password': {
        required: 'Please enter your password.'
      }
    },
    submitHandler: function (form) {
      // enable spinner animation on submit button
      $('.button-spinner', form).prop('disabled', true);

      grecaptcha.ready(function() {
        grecaptcha.execute(recaptcha_site_key, { action: 'aws_cognito_log_in' }).then(function(token) {
          // get all the variables
          var email_address = $('#login-email-address', form).val();
          var password = $('#login-password', form).val();
          // var nonce = $('#aws-cognito-log-in-nonce', form).val();

          // do something with them!
          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'aws_cognito_log_in',
              email_address: email_address,
              password: password,
              recaptcha_token: token
              // nonce: nonce
            },
            success: function (results) {
              var results = JSON.parse(results);
              // console.log(results);
              if (results.status === 'success') {
                if (results['results']['ChallengeName'] === 'MFA_SETUP') {
                  if (results['authenticator_app_setup']['SecretCode']) {
                    // this is for authenticator app setup
                    var qr_code = $('#mfa-authenticator-app-qr-code');
                    var site_name = $(qr_code).attr('data-site-name');
                    var secret_code = results['authenticator_app_setup']['SecretCode'];
                    var qr_code_url = 'otpauth://totp/' + site_name + '?secret=' + secret_code;
                    var code = new QRCode('mfa-authenticator-app-qr-code', {
                      text: qr_code_url,
                      width: 200,
                      height: 200,
                      colorDark: '#000000',
                      colorLight: '#FFFFFF',
                      correctLevel: QRCode.CorrectLevel.H
                    });
                    $(qr_code).attr('data-secret-code', secret_code);
                    $('#aws-cognito-mfa-setup #session').val(results['authenticator_app_setup']['Session']);
                    // hide this step and show next step
                    // $(form).hide();
                    // $('#aws-cognito-mfa-setup').show();
                  }
                } else if (results['results']['ChallengeName'] === 'SOFTWARE_TOKEN_MFA') {
                  // this is for entering a one-time password from your authenticator app

                  // let's go to MFA challenge
                  $('#aws-cognito-mfa-verify-otp #email-address').val(results['email_address']);
                  $('#aws-cognito-mfa-verify-otp #session').val(results['results']['Session']);
                  // hide this step and show next step
                  $(form).hide();
                  $('#aws-cognito-mfa-verify-otp').show();
                } else {
                  // regular log in with email and password with no MFA
                  var redirect_url = $(form).attr('data-redirect-url');
                  if (redirect_url) {
                    if (redirect_url === 'reload') {
                      setTimeout(function () {
                        location.reload();
                      }, 250);
                    } else {
                      setTimeout(function () {
                        window.location.href = redirect_url;
                      }, 250);
                    }
                  }
                }
                $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
              } else if (results.status === 'error') {
                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
                if (results.error_code === 'PasswordResetRequiredException') {
                  // copy email address to forgot password form
                  $('#forgot-password-email-address').val(results.email_address);
                  // hide this step and show next step
                  setTimeout(function () {
                    $(form).removeClass('form-flow-active');
                    $(form).next().addClass('form-flow-active');
                  }, 250);
                }
              } else {
                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');
              }
              // disable spinner animation on submit button
              $('.button-spinner', form).prop('disabled', false);
            },
            error: function (results) {
              // var results = JSON.parse(results);
              console.log(results);
              // disable spinner animation on submit button
              $('.button-spinner', form).prop('disabled', false);
            }
          });
        });
      });
    }
  });

  // $('#aws-cognito-mfa-setup').validate({
  //   // debug: true,
  //   errorElement: 'span',
  //   errorClass: 'form-field-error',
  //   validClass: 'form-field-valid',
  //   errorPlacement: function(error, element) {
  //     error.appendTo(element.parents('.form-field'));
  //   },
  //   highlight: function(element, errorClass, validClass) {
  //     $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
  //   },
  //   unhighlight: function(element, errorClass, validClass) {
  //     $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
  //   },
  //   'rules': {
  //     'mfa-options': {
  //       required: true
  //     },
  //     'one-time-password': {
  //       required: {
  //         depends: function() {
  //           if ($('input[name="mfa-options"][value="authenticator-app"]').is(':checked')) {
  //             return true;
  //           } else {
  //             return false;
  //           }
  //         }
  //       },
  //       number: true,
  //       minlength: 6,
  //       maxlength: 6
  //     },
  //     'email-address': {
  //       required: {
  //         depends: function() {
  //           if ($('input[name="mfa-options"][value="email"]').is(':checked')) {
  //             return true;
  //           } else {
  //             return false;
  //           }
  //         }
  //       },
  //       email: true
  //     },
  //     'phone-number': {
  //       required: {
  //         depends: function() {
  //           if ($('input[name="mfa-options"][value="sms"]').is(':checked')) {
  //             return true;
  //           } else {
  //             return false;
  //           }
  //         }
  //       },
  //       phoneUS: true
  //     }
  //   },
  //   'messages': {
  //     'mfa-options': {
  //       required: 'Please choose a multi-factor authentication option.'
  //     },
  //     'one-time-password': {
  //       required: 'Please enter your one-time password from your authenticator app.',
  //       number: 'Your one-time password is a six digit number.',
  //       minlength: 'Your one-time password is too short.',
  //       maxlength: 'Your one-time password is too long.'
  //     },
  //     'email-address': {
  //       required: 'Please enter your email address.',
  //       email: 'Please enter a valid email address.'
  //     },
  //     'phone-number': {
  //       required: 'Please enter your mobile phone number.',
  //       phoneUS: 'Please enter a valid phone number.'
  //     }
  //   },
  //   submitHandler: function(form) {
  //     // enable spinner animation on submit button
  //     $('.button-spinner', form).prop('disabled', true);

  //     grecaptcha.ready(function() {
  //       grecaptcha.execute(recaptcha_site_key, { action: 'aws_cognito_mfa_setup' }).then(function(token) {
  //         // get all the variables
  //         var mfa_option = $('input[name="mfa-options"]', form).val();
  //         var one_time_password = null;
  //         var email_address = null;
  //         var phone_number = null;
  //         var session = $('#session', form).val();
  //         var nonce = $('#aws-cognito-mfa-setup-nonce', form).val();
  //         if (mfa_option === 'authenticator-app') {
  //           one_time_password = $('#one-time-password', form).val();
  //         } else if (mfa_option === 'email') {
  //           email_address = $('#email-address', form).val();
  //         } else if (mfa_option === 'sms') {
  //           phone_number = $('#phone-number', form).val();
  //         }

  //         // do something with them!
  //         $.ajax({
  //           type: 'post',
  //           url: '/wp-admin/admin-ajax.php',
  //           data: {
  //             action: 'aws_cognito_mfa_setup',
  //             mfa_option: mfa_option,
  //             one_time_password: one_time_password,
  //             email_address: email_address,
  //             phone_number: phone_number,
  //             session: session,
  //             recaptcha_token: token,
  //             nonce: nonce
  //           },
  //           success: function(results) {
  //             var results = JSON.parse(results);
  //             console.log(results);
  //             if (results.status === 'success') {
  //               if (results.mfa_option === 'authenticator-app' && results['results']['Status'] === 'SUCCESS') {
  //                 // hide this step and show next step
  //                 $(form).hide();
  //                 $('#aws-cognito-mfa-verify-otp').show();
  //               } else if (results.mfa_option === 'email') {

  //               } else if (results.mfa_option === 'sms') {

  //               }
  //               $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
  //             } else if (results.status === 'error') {
  //               $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
  //             } else {
  //               $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');
  //             }
  //             // disable spinner animation on submit button
  //             $('.button-spinner', form).prop('disabled', false);
  //           },
  //           error: function(results) {
  //             console.log(results);
  //             $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');
  //             // disable spinner animation on submit button
  //             $('.button-spinner', form).prop('disabled', false);
  //           }
  //         });
  //       });
  //     });
  //   }
  // });

  // $('#aws-cognito-mfa-verify-otp').validate({
  //   // debug: true,
  //   errorElement: 'span',
  //   errorClass: 'form-field-error',
  //   validClass: 'form-field-valid',
  //   errorPlacement: function(error, element) {
  //     error.appendTo(element.parents('.form-field'));
  //   },
  //   highlight: function(element, errorClass, validClass) {
  //     $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
  //   },
  //   unhighlight: function(element, errorClass, validClass) {
  //     $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
  //   },
  //   'rules': {
  //     'one-time-password': {
  //       required: true,
  //       number: true,
  //       minlength: 6,
  //       maxlength: 6
  //     }
  //   },
  //   'messages': {
  //     'one-time-password': {
  //       required: 'Please enter your one-time password from your authenticator app.',
  //       number: 'Your one-time password is a six digit number.',
  //       minlength: 'Your one-time password is too short.',
  //       maxlength: 'Your one-time password is too long.'
  //     }
  //   },
  //   submitHandler: function(form) {
  //     // enable spinner animation on submit button
  //     $('.button-spinner', form).prop('disabled', true);

  //     grecaptcha.ready(function() {
  //       grecaptcha.execute(recaptcha_site_key, { action: 'aws_cognito_mfa_verify_otp' }).then(function(token) {
  //         // get all the variables
  //         var challenge_name = $('#challenge-name', form).val();
  //         var email_address = $('#email-address', form).val();
  //         var one_time_password = $('#one-time-password', form).val();
  //         var session = $('#session', form).val();
  //         var nonce = $('#aws-cognito-mfa-verify-otp-nonce', form).val();

  //         // do something with them!
  //         $.ajax({
  //           type: 'post',
  //           url: '/wp-admin/admin-ajax.php',
  //           data: {
  //             action: 'aws_cognito_mfa_verify_otp',
  //             challenge_name: challenge_name,
  //             email_address: email_address,
  //             one_time_password: one_time_password,
  //             session: session,
  //             recaptcha_token: token,
  //             nonce: nonce
  //           },
  //           success: function(results) {
  //             var results = JSON.parse(results);
  //             console.log(results);
  //             // disable spinner animation on submit button
  //             $('.button-spinner', form).prop('disabled', false);
  //           },
  //           error: function(results) {
  //             console.log(results);
  //             // disable spinner animation on submit button
  //             $('.button-spinner', form).prop('disabled', false);
  //           }
  //         });
  //       });
  //     });
  //   }
  // });

  // // show/hide necessary fields for each mfa option
  // $('input[type="radio"][name="mfa-options"]').on('change', function() {
  //   var value = $(this).val();
  //   $('.mfa-option-fields').hide();
  //   $('.mfa-option-fields-' + value).show();
  // });

  // log out of AWS Cognito account
  $('body').on('click', '#aws-cognito-log-out', function (e) {
    e.preventDefault();
    $(this).prop('disabled', true);
    var redirect_url = $(this).attr('data-redirect-url');
    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'aws_cognito_log_out'
      },
      success: function (results) {
        var results = JSON.parse(results);
        // console.log(results);
        if (results.status === 'success') {
          if (redirect_url) {
            if (redirect_url === 'reload') {
              setTimeout(function () {
                location.reload();
              }, 250);
            } else {
              setTimeout(function () {
                window.location.href = redirect_url;
              }, 250);
            }
          }
        }
        $(this).prop('disabled', false);
      },
      error: function (results) {
        console.log(results);
        $(this).prop('disabled', false);
      }
    });
  });

  // AWS Cognito :: Forgot Password
  $('#aws-cognito-forgot-password').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    'rules': {
      'forgot-password-email-address': {
        required: true,
        email: true
      }
    },
    'messages': {
      'forgot-password-email-address': {
        required: 'Please enter your email address.',
        email: 'Please enter a valid email address.'
      }
    },
    submitHandler: function (form) {
      // enable spinner animation on submit button
      $('.button-spinner', form).prop('disabled', true);

      // get variables
      var email_address = $('#forgot-password-email-address', form).val();
      // var nonce = $('#aws-cognito-forgot-password-nonce').val();

      // do stuff
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'aws_cognito_forgot_password',
          email_address: email_address
          // nonce: nonce
        },
        success: function (results) {
          var results = JSON.parse(results);
          // console.log(results);
          if (results.status === 'success') {
            $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
            // hide this step and show next step
            setTimeout(function () {
              $(form).removeClass('form-flow-active');
              $(form).next().addClass('form-flow-active');
              $('.page-header-text-step-1').hide();
              $('.page-header-text-step-2').show();
            }, 250);
          } else if (results.status === 'error') {
            $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
          }
          // disable spinner animation on submit button
          $('.button-spinner', form).prop('disabled', false);
        },
        error: function (results) {
          console.log(results);
          $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');
          // disable spinner animation on submit button
          $('.button-spinner', form).prop('disabled', false);
        }
      });
    }
  });

  // AWS Cognito :: Confirm Forgot Password
  $('#aws-cognito-confirm-forgot-password').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    'rules': {
      'confirm-forgot-password-password': {
        required: true,
        minlength: 12,
        maxlength: 99
      },
      'confirm-forgot-password-password-match': {
        required: true,
        minlength: 12,
        maxlength: 99,
        equalTo: '#confirm-forgot-password-password'
      },
      'confirm-forgot-password-password-reset-code': {
        required: true,
        number: true,
        minlength: 6,
        maxlength: 6
      }
    },
    'messages': {
      'confirm-forgot-password-password': {
        required: 'Please provide a password.',
        minlength: 'Your password must be at least 12 characters long.',
        maxlength: 'Your password must be 99 characters or less.'
      },
      'confirm-forgot-password-password-match': {
        required: 'Your password does not match the previous field.',
        minlength: 'Your password must be at least 12 characters long.',
        maxlength: 'Your password must be 99 characters or less.',
        equalTo: 'Your password does not match the previous field.'
      },
      'confirm-forgot-password-password-reset-code': {
        required: 'Please enter the verification code you were emailed.',
        number: 'Your verification code is a six digit number.',
        minlength: 'Your verification code is too short.',
        maxlength: 'Your verification code is too long.'
      }
    },
    submitHandler: function (form) {
      // enable spinner animation on submit button
      $('.button-spinner', form).prop('disabled', true);

      // get variables
      var password = $('#confirm-forgot-password-password', form).val();
      var password_reset_code = $('#confirm-forgot-password-password-reset-code', form).val();
      // var nonce = $('#aws-cognito-confirm-forgot-password-nonce', form).val();

      // do stuff
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'aws_cognito_confirm_forgot_password',
          password: password,
          password_reset_code: password_reset_code
          // nonce: nonce
        },
        success: function (results) {
          var results = JSON.parse(results);
          // console.log(results);
          if (results.status === 'success') {
            $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
            var redirect_url = $(form).attr('data-redirect-url');
            if (redirect_url) {
              if (redirect_url === 'reload') {
                setTimeout(function () {
                  location.reload();
                }, 250);
              } else if (redirect_url === 'onboarding') {
                // hide this step and show next step
                setTimeout(function () {
                  $(form).removeClass('form-flow-active');
                  $(form).next().addClass('form-flow-active');
                }, 250);
              } else {
                setTimeout(function () {
                  window.location.href = redirect_url;
                }, 250);
              }
            }
          } else if (results.status === 'error') {
            $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
          }
          // disable spinner animation on submit button
          $('.button-spinner', form).prop('disabled', false);
        },
        error: function (results) {
          console.log(results);
          $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');
          // disable spinner animation on submit button
          $('.button-spinner', form).prop('disabled', false);
        }
      });

    }
  });

  // AWS Cognito :: Update Profile
  $('#aws-cognito-update-profile').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
      error.attr('data-cy', `${error[0].id}-text`);
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    'rules': {
      'first-name': {
        required: true,
        minlength: 2
      },
      'last-name': {
        required: true,
        minlength: 2
      },
      'country-code': {
        required: true,
        minlength: 1,
        maxlength: 3
      },
      'phone-number': {
        required: true,
        minlength: 10,
        maxlength: 15,
      },
      'street-address': {
        minlength: 2
      },
      'city': {
        minlength: 2
      },
      'zip-code': {
        zipcodeUS: true
      }
    },
    'messages': {
      'first-name': {
        required: 'Please enter your first name.',
        minlength: 'Your first name must be at least 2 characters long.'
      },
      'last-name': {
        required: 'Please enter your last name.',
        minlength: 'Your last name must be at least 2 characters long.'
      },
      'country-code': {
        required: 'Please enter your country code.',
        minlength: 'Your country code must be at least 1 character long.',
        maxlength: 'Your country code must be 3 characters or less.'
      },
      'phone-number': {
        required: 'Please enter your phone number.',
        minlength: 'Your phone number must be at least 10 characters long.',
        maxlength: 'Your phone number must be 15 characters or less.'
      },
      'street-address': {
        minlength: 'Please enter a valid street address.'
      },
      'city': {
        minlength: 'Please enter a valid city name.'
      },
      'zip-code': {
        zipcodeUS: 'Please enter a valid zip code.'
      }
    },
    submitHandler: function (form) {
      // enable spinner animation on submit button
      $('.button-spinner', form).prop('disabled', true);

      // get all license plates and store them in an array
      var license_plates = [];
      $('input[name="license-plates"]').each(function (index, license_plate) {
        if ($(license_plate).val()) {
          license_plates.push($(license_plate).val());
        }
      });

      // wrap everything up into an object
      var metadata = {};
      metadata['firstName'] = $('#first-name').val();
      metadata['lastName'] = $('#last-name').val();
      metadata['countryCode'] = $('#country-code').val();
      metadata['phoneNumber'] = $('#phone-number').val();
      metadata['street'] = $('#street-address').val();
      metadata['city'] = $('#city').val();
      metadata['state'] = $('#state').val();
      metadata['zip'] = $('#zip-code').val();
      metadata['licensePlates'] = license_plates;

      // convert object to JSON
      console.log(metadata);
      metadata = JSON.stringify(metadata);
      console.log(metadata);

      // get AWS Cognito ID Token from cookie
      var id_token = getCookie('aws_cognito_id_token');
      if (id_token.length) {
        // send it away!
        $.ajax({
          type: 'post',
          url: aws_api_endpoint_url + 'update-user-metadata',
          headers: {
            'Authorization': id_token
          },
          data: metadata,
          contentType: 'application/json',
          success: function (results) {
            console.log('Profile updated!', results);
            $.ajax({
              type: 'post',
              url: '/wp-admin/admin-ajax.php',
              data: {
                action: 'aws_cognito_refresh_token'
              },
              success: function (results) {
                var results = JSON.parse(results);
                if (results.status === 'success') {
                  console.log('Tokens refreshed!', results);
                  $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text('Profile updated!');
                  setTimeout(function () {
                    location.reload(true);
                  }, 250);
                } else if (results.status === 'error') {
                  console.log('Tokens not refreshed?!', results);
                  // disable spinner animation on submit button
                  $('.button-spinner', form).prop('disabled', false);
                }
              },
              error: function (results) {
                console.log('Token refresh failed?', results);
                // disable spinner animation on submit button
                $('.button-spinner', form).prop('disabled', false);
              }
            });
          },
          error: function (results) {
            console.log(results);
            $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong. Try again?');
            // disable spinner animation on submit button
            $('.button-spinner', form).prop('disabled', false);
          }
        });
      }
    }
  });

  // AWS Cognito :: Change Password
  $('#aws-cognito-change-password').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
      error.attr('data-cy', `${error[0].id}-text`);
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    'rules': {
      'current-password': {
        required: true,
      },
      'new-password': {
        required: true,
        minlength: 12,
        maxlength: 99
      },
      'new-password-match': {
        required: true,
        minlength: 12,
        maxlength: 99,
        equalTo: '#new-password'
      }
    },
    'messages': {
      'current-password': {
        required: 'Please enter your current password.'
      },
      'new-password': {
        required: 'Please provide a password.',
        minlength: 'Your password must be at least 12 characters long.',
        maxlength: 'Your password must be 64 characters or less.'
      },
      'new-password-match': {
        required: 'Your password does not match the previous field.',
        minlength: 'Your password must be at least 12 characters long.',
        maxlength: 'Your password must be 64 characters or less.',
        equalTo: 'Your password does not match the previous field.'
      }
    },
    submitHandler: function (form) {
      // enable spinner animation on submit button
      $('.button-spinner', form).prop('disabled', true);

      var current_password = $('#current-password', form).val();
      var new_password = $('#new-password', form).val();
      var new_password_match = $('#new-password-match', form).val();
      // var nonce = $('#aws-cognito-change-password-nonce', form).val();

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'aws_cognito_change_password',
          current_password: current_password,
          new_password: new_password
          // nonce: nonce
        },
        success: function (results) {
          var results = JSON.parse(results);
          // console.log(results);
          var message = results.message;
          if (results.status === 'success') {
            $.ajax({
              type: 'post',
              url: '/wp-admin/admin-ajax.php',
              data: {
                action: 'aws_cognito_refresh_token'
              },
              success: function (results) {
                var results = JSON.parse(results);
                if (results.status === 'success') {
                  console.log('Tokens refreshed!', results);
                  $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(message);
                  setTimeout(function () {
                    location.reload(true);
                  }, 250);
                } else if (results.status === 'error') {
                  console.log('Tokens not refreshed?!', results);
                  $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-success').text(message);
                  // disable spinner animation on submit button
                  $('.button-spinner', form).prop('disabled', false);
                }
              },
              error: function (results) {
                console.log('Token refresh failed?', results);
                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-success').text('Token refresh failed?');
                // disable spinner animation on submit button
                $('.button-spinner', form).prop('disabled', false);
              }
            });
          } else if (results.status === 'error') {
            $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(message);
            // disable spinner animation on submit button
            $('.button-spinner', form).prop('disabled', false);
          }
        },
        error: function (results) {
          console.log(results);
          $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');
          // disable spinner animation on submit button
          $('.button-spinner', form).prop('disabled', false);
        }
      });
    }
  });
  
  // inc-chirp2-single-facility-form functionality
  $('.chirp2-sf-form').each(function(index, form) {

    // hourly/monthly/coupon tabs functionality
    $('.chirp2-sf-form-menu-item', form).on('click', function() {
      var tab_name = $(this).attr('data-tab');
      $('.chirp2-sf-form-menu-item', form).removeClass('chirp2-sf-form-menu-item-active');
      $('.chirp2-sf-form-tab', form).removeClass('chirp2-sf-form-tab-active');
      $('.chirp2-sf-form-menu-item[data-tab="' + tab_name + '"]', form).addClass('chirp2-sf-form-menu-item-active');
      $('.chirp2-sf-form-tab[data-tab="' + tab_name + '"]', form).addClass('chirp2-sf-form-tab-active');
    });
    
    // get initial hourly parking price if the hourly tab is active
    if ($('.chirp2-sf-form-tab[data-tab="hourly-parking"]', form).hasClass('chirp2-sf-form-tab-active')) {
      // get variables
      var facility_id = $('#facility-id').val();
      var start_date = $('#hourly-start-date', form).val();
      var start_time = $('#hourly-start-time', form).val();
      var end_date = $('#hourly-end-date', form).val();
      var end_time = $('#hourly-end-time', form).val();
      var promo_code = $('#hourly-promo-code', form).val();
      var offset = $('#offset', form).val();
      // get a new price
      chirp2_sf_form_update_hourly_price(facility_id, start_date, start_time, end_date, end_time, offset, promo_code);
    }
    
    // update hourly parking price on date/time change
    $('#hourly-start-date, #hourly-start-time, #hourly-end-date, #hourly-end-time', form).on('change', function() {
      // get variables
      var facility_id = $('#facility-id').val();
      var start_date = $('#hourly-start-date', form).val();
      var start_time = $('#hourly-start-time', form).val();
      var end_date = $('#hourly-end-date', form).val();
      var end_time = $('#hourly-end-time', form).val();
      var promo_code = $('#hourly-promo-code', form).val();
      var offset = $('#offset', form).val();
      // if start_date is later than end_date, change them to match
      if (start_date > end_date) {
        $('#hourly-end-date', form).val(start_date);
        end_date = start_date;
      }
      // get a new price
      chirp2_sf_form_update_hourly_price(facility_id, start_date, start_time, end_date, end_time, offset, promo_code);
    });
    
    // update hourly parking price on promo code typing
    $('#hourly-promo-code', form).on('keyup', debounce(function() {
      // get variables
      var facility_id = $('#facility-id').val();
      var start_date = $('#hourly-start-date', form).val();
      var start_time = $('#hourly-start-time', form).val();
      var end_date = $('#hourly-end-date', form).val();
      var end_time = $('#hourly-end-time', form).val();
      var promo_code = $('#hourly-promo-code', form).val();
      var offset = $('#offset', form).val();
      // get a new price
      chirp2_sf_form_update_hourly_price(facility_id, start_date, start_time, end_date, end_time, offset, promo_code);
    }, 500));
    
    // update hourly parking price on promo code submit
    $('#hourly-promo-code-submit', form).on('click', function(e) {
      e.preventDefault();
      // get variables
      var facility_id = $('#facility-id').val();
      var start_date = $('#hourly-start-date', form).val();
      var start_time = $('#hourly-start-time', form).val();
      var end_date = $('#hourly-end-date', form).val();
      var end_time = $('#hourly-end-time', form).val();
      var promo_code = $('#hourly-promo-code', form).val();
      var offset = $('#offset', form).val();
      // get a new price
      chirp2_sf_form_update_hourly_price(facility_id, start_date, start_time, end_date, end_time, offset, promo_code);
    });
    
    // calculate monthly product changes
    $('input[name="monthly-options"], #monthly-quantity', form).on('change', function() {
      var price = $('input[name="monthly-options"]:checked').attr('data-price');
      var quantity = $('#monthly-quantity').val();
      chirp2_sf_form_update_product_price('monthly', price, quantity);
      var current_url = $('#monthly-parking-submit').attr('href');
      var product_id = $('input[name="monthly-options"]:checked').val();
      var start_date = $('#monthly-start-date').val();
      var offset = $('#offset').val();
      var promo_code = $('#monthly-promo-code').val();
      chirp2_sf_form_update_monthly_checkout_url(current_url, product_id, start_date, offset, quantity, promo_code);
    });
    
    // update monthly parking products on promo code typing
    $('#monthly-promo-code', form).on('keyup', debounce(function() {
      var facility_id = $('#facility-id').val();
      var promo_code = $('#monthly-promo-code', form).val();
      chirp2_sf_form_update_products('monthly', facility_id, promo_code);
    }, 500));
    
    // update monthly parking products on promo code submit
    $('#monthly-promo-code-submit', form).on('click', function(e) {
      e.preventDefault();
      var facility_id = $('#facility-id').val();
      var promo_code = $('#monthly-promo-code', form).val();
      chirp2_sf_form_update_products('monthly', facility_id, promo_code);
    });
    
    // calculate coupon product changes
    $('input[name="coupon-options"], #coupon-quantity', form).on('change', function() {
      var price = $('input[name="coupon-options"]:checked').attr('data-price');
      var quantity = $('#coupon-quantity').val();
      chirp2_sf_form_update_product_price('coupon', price, quantity);
      var current_url = $('#coupon-parking-submit').attr('href');
      var product_id = $('input[name="coupon-options"]:checked').val();
      var promo_code = $('#coupon-promo-code').val();
      chirp2_sf_form_update_coupon_checkout_url(current_url, product_id, quantity, promo_code);
    });
    
    // update coupon parking products on promo code typing
    $('#coupon-promo-code', form).on('keyup', debounce(function() {
      var facility_id = $('#facility-id').val();
      var promo_code = $('#coupon-promo-code', form).val();
      chirp2_sf_form_update_products('coupon', facility_id, promo_code);
    }, 500));
    
    // update coupon parking products on promo code submit
    $('#coupon-promo-code-submit', form).on('click', function(e) {
      e.preventDefault();
      var facility_id = $('#facility-id').val();
      var promo_code = $('#coupon-promo-code', form).val();
      chirp2_sf_form_update_products('coupon', facility_id, promo_code);
    });
    
  });
});
